const royalcaninDogProducts = [
  // -- Size-based Dry Food --
  {
    image: '/pet_images/RC_X_Small_Puppy_1_5kg.jpg',
    id: 'RC_X_Small_Puppy_1_5kg',
    name: 'Royal Canin X-Small Puppy (1.5kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1.5,
    price: 298,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Puppy',
    breed: '',
    needs: 'General',
    size: 'very small',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'Royal Canin X-Small Junior Puppy Food for very small breed puppies (adult weight up to 4 kg) up to 10 months old.Provides a balanced intake of fibres to help facilitate intestinal transit and contribute to good stool quality. Contains a specially...',
    longDescription:
      '<div class="std" itemprop="description"><p><strong>Royal Canin X-Small Junior Puppy Food</strong><span>for very small breed puppies (adult weight up to 4 kg) up to 10 months old.</span></p><p><span>Provides a balanced intake of fibres to help facilitate intestinal transit and contribute to good stool quality. Contains a specially selected complex of antioxidants to support your puppy\\\\\\\'s immune system.</span></p><p><strong>Key Features:</strong></p><ul><li><strong>Immune system support</strong> :helps support your puppy’s natural defences thanks particularly to a patented complex of antioxidants including vitamin E.</li><li><strong>Healthy digestion and transit</strong> : A balanced intake of fibres (including psyllium) to help facilitate intestinal transit and to contribute to good stool quality.</li><li><strong>Intense energy content</strong> : Meets the energy needs of very small breed puppies during the growth period, and satisfies fussy appetites.</li></ul></div>',
    keyBenefits: [
      'Immune system support',
      'Healthy digestion and transit',
      'Intense energy content',
    ],
    feedingGuide: [
      {
        weight: 'WEIGHT/AGE',
        idealWeight: '2 MONTHS',
        overweight: '-',
      },
      {
        weight: '1 kg',
        idealWeight: '29g',
        overweight: '2/8 cup',
      },
      {
        weight: '3 kg',
        idealWeight: '64g',
        overweight: '5/8 cup',
      },
      {
        weight: '4 kg',
        idealWeight: '79g',
        overweight: '6/8 cup',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'No',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food, Immune Support',
      breed: 'No',
      breed_size: 'Mini Breed',
      flavour: 'Chicken',
      lifestage: 'Puppy',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_X_Small_Adult_1_5kg.jpg',
    id: 'RC_X_Small_Adult_1_5kg',
    name: 'Royal Canin X-Small Adult (1.5kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1.5,
    price: 269,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: '',
    needs: 'General',
    size: 'very small',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'Royal Canin X-Small Adult Dog Food is designed for toy and miniature breed dogs (weight up to 4 kg) from 10 months to 8 years. It has targeted nutrition to support your mini dog’s playful nature and petite size. And since they have tiny jaws and...',
    longDescription:
      '<div class="std" itemprop="description"><p><strong>Royal Canin X-Small Adult Dog Food</strong> is designed for toy and miniature breed dogs (weight up to 4 kg) from 10 months to 8 years. It has targeted nutrition to support your mini dog’s playful nature and petite size. And since they have tiny jaws and miniature teeth, this kibble is specially formulated to be small enough to pick up and chew. </p><p><strong>Key Features:</strong></p><ul><li>Formulated with adapted energy levels to meet the high energy needs of miniature and toy breed dogs.</li><li>Ideal levels of EPA and DHA support healthy skin and a beautiful, shiny coat.</li><li>Highly digestible proteins and precise levels of fibers help promote healthy digestion.</li><li>This extra-small and highly palatable kibble is designed for tiny teeth and jaws, pleasing even the pickiest of eaters.</li></ul></div>',
    keyBenefits: [
      'Formulated with adapted energy levels to meet the high energy needs of miniature and toy breed dogs.',
      'Ideal levels of EPA and DHA support healthy skin and a beautiful, shiny coat.',
      'Highly digestible proteins and precise levels of fibers help promote healthy digestion.',
      'This extra-small and highly palatable kibble is designed for tiny teeth and jaws, pleasing even the pickiest of eaters.',
    ],
    feedingGuide: [
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Tub',
      breed: 'No',
      breed_size: 'Mini Breed',
      flavour: 'Chicken',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_X_Small_Ageing_12_plus_1_5kg.jpg',
    id: 'RC_X_Small_Ageing_12_plus_1_5kg',
    name: 'Royal Canin X-Small Ageing 12+ (1.5kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1.5,
    price: 306,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Senior',
    breed: '',
    needs: 'General',
    size: 'very small',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'Royal Canin X-Small Ageing 12+ Dog Food is designed for extra small dogs (weight up to 4 kg) from 12 years. Your extra-small pup will have unique nutritional needs as they phase into their senior years. Their tiny jaws, sensitive digestive systems,...',
    longDescription:
      '<div class="std" itemprop="description"><p><strong>Royal Canin X-Small Ageing 12+ Dog Food</strong> is designed for extra small dogs (weight up to 4 kg) from 12 years. </p><p>Your extra-small pup will have unique nutritional needs as they phase into their senior years. Their tiny jaws, sensitive digestive systems, and aging heart can benefit from a targerted size-specific diet. These fussy eaters will only grow more picky in their old age, making thus highly palatable formula ideal to satisfy your small dog.</p><p><strong>Key Features:</strong></p><ul><li>Contains very high-quality protein (L.I.P.), specifically chosen for its easy digestibility.</li><li>Supports heart health with key nutrients for senior dogs.</li><li>Satisfies the fussy appetites of small dogs with enhanced palatability.</li><li>Rehydratable kibble is easy to chew and ideal for older dogs’ miniature teeth and senior jaws.</li></ul></div>',
    keyBenefits: [
      'Contains very high-quality protein (L.I.P.), specifically chosen for its easy digestibility.',
      'Supports heart health with key nutrients for senior dogs.',
      'Satisfies the fussy appetites of small dogs with enhanced palatability.',
      'Rehydratable kibble is easy to chew and ideal for older dogs’ miniature teeth and senior jaws.',
    ],
    feedingGuide: [
      {
        weight: 'Dog\'s weight',
        idealWeight: '1 kg',
        overweight: '1.5 kg',
      },
      {
        weight: 'Indoor',
        idealWeight: '24g 2/8 cup',
        overweight: '33g 3/8 cup',
      },
      {
        weight: 'Normal',
        idealWeight: '28g 2/8 cup',
        overweight: '38g 3/8 cup',
      },
      {
        weight: 'High',
        idealWeight: '32g 3/8 cup',
        overweight: '43g 4/8 cup',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Tub',
      breed: 'No',
      breed_size: 'Mini Breed',
      flavour: 'Chicken',
      lifestage: 'Senior',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Mini_Starter_Mother_Babydog_4kg.jpg',
    id: 'RC_Mini_Starter_Mother_Babydog_4kg',
    name: 'Royal Canin Mini Starter Mother & Babydog (4kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 4.0,
    price: 681,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Puppy',
    breed: '',
    needs: 'General',
    size: 'small',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'Complete feed for dogs - From weaning to 2 months.',
    longDescription:
      '<div class="std" itemprop="description"><p>Complete feed for dogs - From weaning to 2 months.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Immune System Support - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Digestive Health - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Growth Support - </strong>Nutritional support tailored to your pet\'s needs.</li></ul></div>',
    keyBenefits: [
      'Immune System Support -',
      'Digestive Health -',
      'Growth Support -',
    ],
    feedingGuide: [
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'No',
      breed_size: 'No',
      flavour: 'None',
      lifestage: 'Puppy',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Mini_Starter_Mother_Babydog_8kg.jpg',
    id: 'RC_Mini_Starter_Mother_Babydog_8kg',
    name: 'Royal Canin Mini Starter Mother & Babydog (8kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 8.0,
    price: 1174,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Puppy',
    breed: '',
    needs: 'General',
    size: 'small',
    sterilised: 'No',
    productSize: '5.1-10kg',
    description:
      'Complete feed for dogs - From weaning to 2 months.',
    longDescription:
      '<div class="std" itemprop="description"><p>Complete feed for dogs - From weaning to 2 months.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Immune System Support - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Digestive Health - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Growth Support - </strong>Nutritional support tailored to your pet\'s needs.</li></ul></div>',
    keyBenefits: [
      'Immune System Support -',
      'Digestive Health -',
      'Growth Support -',
    ],
    feedingGuide: [
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'No',
      breed_size: 'No',
      flavour: 'None',
      lifestage: 'Puppy',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Mini_Puppy_800g.jpg',
    id: 'RC_Mini_Puppy_800g',
    name: 'Royal Canin Mini Puppy (800g)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 0.8,
    price: 151,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Puppy',
    breed: '',
    needs: 'General',
    size: 'small',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'The Royal Canin Mini Puppy Food is suitable for puppies aged 2-10 months that will have an adult weight of up to 10kg.Contains a special combination of proteins, vitamins, minerals, and a patented complex of antioxidants - all designed to keep your...',
    longDescription:
      '<div class="std" itemprop="description"><p><strong>The Royal Canin Mini Puppy Food</strong> is suitable for puppies aged 2-10 months that will have an adult weight of up to 10kg.</p><p><span>Contains a special combination of proteins, vitamins, minerals, and a patented complex of antioxidants - all designed to keep your puppy healthy as it grows into a strong adult dog.</span></p><p><strong>Key Features:</strong></p><ul><li><strong>Immune system support:</strong> Helps support your puppy’s natural defences thanks to a complex of antioxidants including vitamin E.</li><li><strong>Digestive health:</strong> Combination of nutrients with high quality protein and prebiotics to support digestive health and balance of intestinal flora, which contributes to good stool quality. </li><li><strong>Intense energy content:</strong> Meets the energy needs of small breed puppies during the growth period, and satisfies fussy appetites.</li><li><strong>Growth &amp; weight control: </strong><span>Contains a moderate level of fat to help limit weight gain with no compromise on the intake of protein, calcium, and phosphorus for a healthy growth.</span></li></ul></div>',
    keyBenefits: [
      'Immune system support:',
      'Digestive health:',
      'Intense energy content:',
      'Growth & weight control:',
    ],
    feedingGuide: [
      {
        weight: 'AGE (MONTHS)',
        idealWeight: 'ADULT WEIGHT = 2 KG',
        overweight: 'ADULT WEIGHT = 6 KG',
      },
      {
        weight: '2 m',
        idealWeight: '49 g (4/8 cups)',
        overweight: '103 g (1+1/8 cups)',
      },
      {
        weight: '3 m',
        idealWeight: '54 g (5/8 cups)',
        overweight: '119 g (1+2/8 cups)',
      },
      {
        weight: '4 m',
        idealWeight: '55 g (5/8 cups)',
        overweight: '125 g (1+3/8 cups)',
      },
      {
        weight: '5 m',
        idealWeight: '55 g (5/8 cups)',
        overweight: '126 g (1+3/8 cups)',
      },
      {
        weight: '6 m',
        idealWeight: '48 g (4/8 cups)',
        overweight: '125 g (1+3/8 cups)',
      },
      {
        weight: '7 m',
        idealWeight: '40 g (4/8 cups)',
        overweight: '113 g (1+2/8 cups)',
      },
      {
        weight: '8 m',
        idealWeight: '39 g (3/8 cups)',
        overweight: '101 g (1+1/8 cups)',
      },
      {
        weight: '9 m',
        idealWeight: '39 g (3/8 cups)',
        overweight: '90 g (1 cups)',
      },
      {
        weight: '10 m',
        idealWeight: '39 g (3/8 cups)',
        overweight: '89 g (1 cups)',
      },
      {
        weight: '11 m',
        idealWeight: 'Transition to Mini Adult',
        overweight: 'Transition to Mini Adult',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'No',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Immune Support',
      breed: 'No',
      breed_size: 'Small Breed',
      flavour: 'Chicken',
      lifestage: 'Puppy',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Mini_Puppy_2kg.jpg',
    id: 'RC_Mini_Puppy_2kg',
    name: 'Royal Canin Mini Puppy (2kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 2.0,
    price: 334,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Puppy',
    breed: '',
    needs: 'General',
    size: 'small',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'The Royal Canin Mini Puppy Food is suitable for puppies aged 2-10 months that will have an adult weight of up to 10kg.Contains a special combination of proteins, vitamins, minerals, and a patented complex of antioxidants - all designed to keep your...',
    longDescription:
      '<div class="std" itemprop="description"><p><strong>The Royal Canin Mini Puppy Food</strong> is suitable for puppies aged 2-10 months that will have an adult weight of up to 10kg.</p><p><span>Contains a special combination of proteins, vitamins, minerals, and a patented complex of antioxidants - all designed to keep your puppy healthy as it grows into a strong adult dog.</span></p><p><strong>Key Features:</strong></p><ul><li><strong>Immune system support:</strong> Helps support your puppy’s natural defences thanks to a complex of antioxidants including vitamin E.</li><li><strong>Digestive health:</strong> Combination of nutrients with high quality protein and prebiotics to support digestive health and balance of intestinal flora, which contributes to good stool quality. </li><li><strong>Intense energy content:</strong> Meets the energy needs of small breed puppies during the growth period, and satisfies fussy appetites.</li><li><strong>Growth &amp; weight control: </strong><span>Contains a moderate level of fat to help limit weight gain with no compromise on the intake of protein, calcium, and phosphorus for a healthy growth.</span></li></ul></div>',
    keyBenefits: [
      'Immune system support:',
      'Digestive health:',
      'Intense energy content:',
      'Growth & weight control:',
    ],
    feedingGuide: [
      {
        weight: 'AGE (MONTHS)',
        idealWeight: 'ADULT WEIGHT = 2 KG',
        overweight: 'ADULT WEIGHT = 6 KG',
      },
      {
        weight: '2 m',
        idealWeight: '49 g (4/8 cups)',
        overweight: '103 g (1+1/8 cups)',
      },
      {
        weight: '3 m',
        idealWeight: '54 g (5/8 cups)',
        overweight: '119 g (1+2/8 cups)',
      },
      {
        weight: '4 m',
        idealWeight: '55 g (5/8 cups)',
        overweight: '125 g (1+3/8 cups)',
      },
      {
        weight: '5 m',
        idealWeight: '55 g (5/8 cups)',
        overweight: '126 g (1+3/8 cups)',
      },
      {
        weight: '6 m',
        idealWeight: '48 g (4/8 cups)',
        overweight: '125 g (1+3/8 cups)',
      },
      {
        weight: '7 m',
        idealWeight: '40 g (4/8 cups)',
        overweight: '113 g (1+2/8 cups)',
      },
      {
        weight: '8 m',
        idealWeight: '39 g (3/8 cups)',
        overweight: '101 g (1+1/8 cups)',
      },
      {
        weight: '9 m',
        idealWeight: '39 g (3/8 cups)',
        overweight: '90 g (1 cups)',
      },
      {
        weight: '10 m',
        idealWeight: '39 g (3/8 cups)',
        overweight: '89 g (1 cups)',
      },
      {
        weight: '11 m',
        idealWeight: 'Transition to Mini Adult',
        overweight: 'Transition to Mini Adult',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'No',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Immune Support',
      breed: 'No',
      breed_size: 'Small Breed',
      flavour: 'Chicken',
      lifestage: 'Puppy',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Mini_Puppy_4kg.jpg',
    id: 'RC_Mini_Puppy_4kg',
    name: 'Royal Canin Mini Puppy (4kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 4.0,
    price: 611,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Puppy',
    breed: '',
    needs: 'General',
    size: 'small',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'The Royal Canin Mini Puppy Food is suitable for puppies aged 2-10 months that will have an adult weight of up to 10kg.Contains a special combination of proteins, vitamins, minerals, and a patented complex of antioxidants - all designed to keep your...',
    longDescription:
      '<div class="std" itemprop="description"><p><strong>The Royal Canin Mini Puppy Food</strong> is suitable for puppies aged 2-10 months that will have an adult weight of up to 10kg.</p><p><span>Contains a special combination of proteins, vitamins, minerals, and a patented complex of antioxidants - all designed to keep your puppy healthy as it grows into a strong adult dog.</span></p><p><strong>Key Features:</strong></p><ul><li><strong>Immune system support:</strong> Helps support your puppy’s natural defences thanks to a complex of antioxidants including vitamin E.</li><li><strong>Digestive health:</strong> Combination of nutrients with high quality protein and prebiotics to support digestive health and balance of intestinal flora, which contributes to good stool quality. </li><li><strong>Intense energy content:</strong> Meets the energy needs of small breed puppies during the growth period, and satisfies fussy appetites.</li><li><strong>Growth &amp; weight control: </strong><span>Contains a moderate level of fat to help limit weight gain with no compromise on the intake of protein, calcium, and phosphorus for a healthy growth.</span></li></ul></div>',
    keyBenefits: [
      'Immune system support:',
      'Digestive health:',
      'Intense energy content:',
      'Growth & weight control:',
    ],
    feedingGuide: [
      {
        weight: 'AGE (MONTHS)',
        idealWeight: 'ADULT WEIGHT = 2 KG',
        overweight: 'ADULT WEIGHT = 6 KG',
      },
      {
        weight: '2 m',
        idealWeight: '49 g (4/8 cups)',
        overweight: '103 g (1+1/8 cups)',
      },
      {
        weight: '3 m',
        idealWeight: '54 g (5/8 cups)',
        overweight: '119 g (1+2/8 cups)',
      },
      {
        weight: '4 m',
        idealWeight: '55 g (5/8 cups)',
        overweight: '125 g (1+3/8 cups)',
      },
      {
        weight: '5 m',
        idealWeight: '55 g (5/8 cups)',
        overweight: '126 g (1+3/8 cups)',
      },
      {
        weight: '6 m',
        idealWeight: '48 g (4/8 cups)',
        overweight: '125 g (1+3/8 cups)',
      },
      {
        weight: '7 m',
        idealWeight: '40 g (4/8 cups)',
        overweight: '113 g (1+2/8 cups)',
      },
      {
        weight: '8 m',
        idealWeight: '39 g (3/8 cups)',
        overweight: '101 g (1+1/8 cups)',
      },
      {
        weight: '9 m',
        idealWeight: '39 g (3/8 cups)',
        overweight: '90 g (1 cups)',
      },
      {
        weight: '10 m',
        idealWeight: '39 g (3/8 cups)',
        overweight: '89 g (1 cups)',
      },
      {
        weight: '11 m',
        idealWeight: 'Transition to Mini Adult',
        overweight: 'Transition to Mini Adult',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'No',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Immune Support',
      breed: 'No',
      breed_size: 'Small Breed',
      flavour: 'Chicken',
      lifestage: 'Puppy',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Mini_Puppy_8kg.jpg',
    id: 'RC_Mini_Puppy_8kg',
    name: 'Royal Canin Mini Puppy (8kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 8.0,
    price: 1110,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Puppy',
    breed: '',
    needs: 'General',
    size: 'small',
    sterilised: 'No',
    productSize: '5.1-10kg',
    description:
      'The Royal Canin Mini Puppy Food is suitable for puppies aged 2-10 months that will have an adult weight of up to 10kg.Contains a special combination of proteins, vitamins, minerals, and a patented complex of antioxidants - all designed to keep your...',
    longDescription:
      '<div class="std" itemprop="description"><p><strong>The Royal Canin Mini Puppy Food</strong> is suitable for puppies aged 2-10 months that will have an adult weight of up to 10kg.</p><p><span>Contains a special combination of proteins, vitamins, minerals, and a patented complex of antioxidants - all designed to keep your puppy healthy as it grows into a strong adult dog.</span></p><p><strong>Key Features:</strong></p><ul><li><strong>Immune system support:</strong> Helps support your puppy’s natural defences thanks to a complex of antioxidants including vitamin E.</li><li><strong>Digestive health:</strong> Combination of nutrients with high quality protein and prebiotics to support digestive health and balance of intestinal flora, which contributes to good stool quality. </li><li><strong>Intense energy content:</strong> Meets the energy needs of small breed puppies during the growth period, and satisfies fussy appetites.</li><li><strong>Growth &amp; weight control: </strong><span>Contains a moderate level of fat to help limit weight gain with no compromise on the intake of protein, calcium, and phosphorus for a healthy growth.</span></li></ul></div>',
    keyBenefits: [
      'Immune system support:',
      'Digestive health:',
      'Intense energy content:',
      'Growth & weight control:',
    ],
    feedingGuide: [
      {
        weight: 'AGE (MONTHS)',
        idealWeight: 'ADULT WEIGHT = 2 KG',
        overweight: 'ADULT WEIGHT = 6 KG',
      },
      {
        weight: '2 m',
        idealWeight: '49 g (4/8 cups)',
        overweight: '103 g (1+1/8 cups)',
      },
      {
        weight: '3 m',
        idealWeight: '54 g (5/8 cups)',
        overweight: '119 g (1+2/8 cups)',
      },
      {
        weight: '4 m',
        idealWeight: '55 g (5/8 cups)',
        overweight: '125 g (1+3/8 cups)',
      },
      {
        weight: '5 m',
        idealWeight: '55 g (5/8 cups)',
        overweight: '126 g (1+3/8 cups)',
      },
      {
        weight: '6 m',
        idealWeight: '48 g (4/8 cups)',
        overweight: '125 g (1+3/8 cups)',
      },
      {
        weight: '7 m',
        idealWeight: '40 g (4/8 cups)',
        overweight: '113 g (1+2/8 cups)',
      },
      {
        weight: '8 m',
        idealWeight: '39 g (3/8 cups)',
        overweight: '101 g (1+1/8 cups)',
      },
      {
        weight: '9 m',
        idealWeight: '39 g (3/8 cups)',
        overweight: '90 g (1 cups)',
      },
      {
        weight: '10 m',
        idealWeight: '39 g (3/8 cups)',
        overweight: '89 g (1 cups)',
      },
      {
        weight: '11 m',
        idealWeight: 'Transition to Mini Adult',
        overweight: 'Transition to Mini Adult',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'No',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Immune Support',
      breed: 'No',
      breed_size: 'Small Breed',
      flavour: 'Chicken',
      lifestage: 'Puppy',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Mini_Adult_2kg.jpg',
    id: 'RC_Mini_Adult_2kg',
    name: 'Royal Canin Mini Adult (2kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 2.0,
    price: 333,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: '',
    needs: 'General',
    size: 'small',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'The Royal Canin Mini Adult Dog Food is designed for adult small breed dogs (weight between 1 and 10 kg) - Over 10 months old. Royal Canin Mini Adult is formulated with nutrients that help to meet those energy needs, whilst also helping your dog to...',
    longDescription:
      '<div class="std" itemprop="description"><p>The <strong>Royal Canin Mini Adult Dog Food</strong> is designed f<span>or adult small breed dogs (weight between 1 and 10 kg) - Over 10 months old.</span></p><p><span></span><span>Royal Canin Mini Adult is formulated with nutrients that help to meet those energy needs, whilst also helping your dog to maintain a healthy weight.</span></p><p><strong>Key Benefits:</strong></p><ul><li><strong>Adapted energy :</strong> Helps maintain a healthy weight in small breed dogs by perfectly meeting their high energy needs.</li><li><strong>Enhanced palatability :</strong> Satisfies the fussy appetite of small breed dogs by means of its formulation and a selection of exclusive flavourings.</li><li><strong>Coat condition :</strong> This formula contains nutrients that help support a healthy skin.</li></ul></div>',
    keyBenefits: [
      'Adapted energy :',
      'Enhanced palatability :',
      'Coat condition :',
    ],
    feedingGuide: [
      {
        weight: 'WEIGHT OF DOG',
        idealWeight: 'LOW ACTIVITY',
        overweight: 'MEDIUM ACTIVITY',
      },
      {
        weight: '2',
        idealWeight: '40 g (4/8 cup)',
        overweight: '47 g (4/8 cup)',
      },
      {
        weight: '3 kg',
        idealWeight: '55 g (5/8 cup)',
        overweight: '63 g (6/8 cup)',
      },
      {
        weight: '4 kg',
        idealWeight: '68 g (6/8 cup)',
        overweight: '79 g (7/8 cup)',
      },
      {
        weight: '5 kg',
        idealWeight: '80 g (7/8 cup)',
        overweight: '93 g (1 cup)',
      },
      {
        weight: '6 kg',
        idealWeight: '92 g (1 cup)',
        overweight: '106 g (1+1/8 cup)',
      },
      {
        weight: '7 kg',
        idealWeight: '103 g (1+1/8 cup)',
        overweight: '119 g (1+3/8 cup)',
      },
      {
        weight: '8 kg',
        idealWeight: '114 g (1+2/8 cup)',
        overweight: '132 g (1+4/8 cup)',
      },
      {
        weight: '9 kg',
        idealWeight: '125 g (1+3/8 cup)',
        overweight: '144 g (1+5/8 cup)',
      },
      {
        weight: '10 kg',
        idealWeight: '135 g (1+4/8 cup)',
        overweight: '156 g (1+6/8 cup)',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'No',
      breed_size: 'Mini Breed',
      flavour: 'Chicken',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Mini_Adult_8kg.jpg',
    id: 'RC_Mini_Adult_8kg',
    name: 'Royal Canin Mini Adult (8kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 8.0,
    price: 1044,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: '',
    needs: 'General',
    size: 'small',
    sterilised: 'No',
    productSize: '5.1-10kg',
    description:
      'The Royal Canin Mini Adult Dog Food is designed for adult small breed dogs (weight between 1 and 10 kg) - Over 10 months old. Royal Canin Mini Adult is formulated with nutrients that help to meet those energy needs, whilst also helping your dog to...',
    longDescription:
      '<div class="std" itemprop="description"><p>The <strong>Royal Canin Mini Adult Dog Food</strong> is designed f<span>or adult small breed dogs (weight between 1 and 10 kg) - Over 10 months old.</span></p><p><span></span><span>Royal Canin Mini Adult is formulated with nutrients that help to meet those energy needs, whilst also helping your dog to maintain a healthy weight.</span></p><p><strong>Key Benefits:</strong></p><ul><li><strong>Adapted energy :</strong> Helps maintain a healthy weight in small breed dogs by perfectly meeting their high energy needs.</li><li><strong>Enhanced palatability :</strong> Satisfies the fussy appetite of small breed dogs by means of its formulation and a selection of exclusive flavourings.</li><li><strong>Coat condition :</strong> This formula contains nutrients that help support a healthy skin.</li></ul></div>',
    keyBenefits: [
      'Adapted energy :',
      'Enhanced palatability :',
      'Coat condition :',
    ],
    feedingGuide: [
      {
        weight: 'WEIGHT OF DOG',
        idealWeight: 'LOW ACTIVITY',
        overweight: 'MEDIUM ACTIVITY',
      },
      {
        weight: '2',
        idealWeight: '40 g (4/8 cup)',
        overweight: '47 g (4/8 cup)',
      },
      {
        weight: '3 kg',
        idealWeight: '55 g (5/8 cup)',
        overweight: '63 g (6/8 cup)',
      },
      {
        weight: '4 kg',
        idealWeight: '68 g (6/8 cup)',
        overweight: '79 g (7/8 cup)',
      },
      {
        weight: '5 kg',
        idealWeight: '80 g (7/8 cup)',
        overweight: '93 g (1 cup)',
      },
      {
        weight: '6 kg',
        idealWeight: '92 g (1 cup)',
        overweight: '106 g (1+1/8 cup)',
      },
      {
        weight: '7 kg',
        idealWeight: '103 g (1+1/8 cup)',
        overweight: '119 g (1+3/8 cup)',
      },
      {
        weight: '8 kg',
        idealWeight: '114 g (1+2/8 cup)',
        overweight: '132 g (1+4/8 cup)',
      },
      {
        weight: '9 kg',
        idealWeight: '125 g (1+3/8 cup)',
        overweight: '144 g (1+5/8 cup)',
      },
      {
        weight: '10 kg',
        idealWeight: '135 g (1+4/8 cup)',
        overweight: '156 g (1+6/8 cup)',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'No',
      breed_size: 'Mini Breed',
      flavour: 'Chicken',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Mini_Adult_Ageing_8_plus_2kg.jpg',
    id: 'RC_Mini_Adult_Ageing_8_plus_2kg',
    name: 'Royal Canin Mini Adult Ageing 8+ (2kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 2.0,
    price: 342,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Senior',
    breed: '',
    needs: 'General',
    size: 'small',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'Complete feed for dogs - For adult small breed dogs (weight between 1 and 10 kg) - Over 8 years old.',
    longDescription:
      '<div class="std" itemprop="description"><p>Complete feed for dogs - For adult small breed dogs (weight between 1 and 10 kg) - Over 8 years old.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Healthy Ageing - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Joint Support - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Skin & Coat Support - </strong>Nutritional support tailored to your pet\'s needs.</li></ul></div>',
    keyBenefits: [
      'Healthy Ageing -',
      'Joint Support -',
      'Skin & Coat Support -',
    ],
    feedingGuide: [
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'No',
      breed_size: 'No',
      flavour: 'None',
      lifestage: 'Senior',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Mini_Adult_Ageing_8_plus_8kg.jpg',
    id: 'RC_Mini_Adult_Ageing_8_plus_8kg',
    name: 'Royal Canin Mini Adult Ageing 8+ (8kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 8.0,
    price: 1058,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Senior',
    breed: '',
    needs: 'General',
    size: 'small',
    sterilised: 'No',
    productSize: '5.1-10kg',
    description:
      'Complete feed for dogs - For adult small breed dogs (weight between 1 and 10 kg) - Over 8 years old.',
    longDescription:
      '<div class="std" itemprop="description"><p>Complete feed for dogs - For adult small breed dogs (weight between 1 and 10 kg) - Over 8 years old.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Healthy Ageing - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Joint Support - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Skin & Coat Support - </strong>Nutritional support tailored to your pet\'s needs.</li></ul></div>',
    keyBenefits: [
      'Healthy Ageing -',
      'Joint Support -',
      'Skin & Coat Support -',
    ],
    feedingGuide: [
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'No',
      breed_size: 'No',
      flavour: 'None',
      lifestage: 'Senior',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Mini_Adult_Ageing_12_plus_1_5kg.jpg',
    id: 'RC_Mini_Adult_Ageing_12_plus_1_5kg',
    name: 'Royal Canin Mini Adult Ageing 12+ (1.5kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1.5,
    price: 306,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Senior',
    breed: '',
    needs: 'General',
    size: 'small',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'Complete feed for dogs - Over 12 years.',
    longDescription:
      '<div class="std" itemprop="description"><p>Complete feed for dogs - Over 12 years.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Healthy Ageing - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Joint Support - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Skin & Coat Support - </strong>Nutritional support tailored to your pet\'s needs.</li></ul></div>',
    keyBenefits: [
      'Healthy Ageing -',
      'Joint Support -',
      'Skin & Coat Support -',
    ],
    feedingGuide: [
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'No',
      breed_size: 'No',
      flavour: 'None',
      lifestage: 'Senior',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Medium_Starter_Mother_Babydog_4kg.jpg',
    id: 'RC_Medium_Starter_Mother_Babydog_4kg',
    name: 'Royal Canin Medium Starter Mother & Babydog (4kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 4.0,
    price: 615,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Puppy',
    breed: '',
    needs: 'General',
    size: 'medium',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'Complete feed for dogs - From weaning to 2 months.',
    longDescription:
      '<div class="std" itemprop="description"><p>Complete feed for dogs - From weaning to 2 months.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Immune System Support - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Digestive Health - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Growth Support - </strong>Nutritional support tailored to your pet\'s needs.</li></ul></div>',
    keyBenefits: [
      'Immune System Support -',
      'Digestive Health -',
      'Growth Support -',
    ],
    feedingGuide: [
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'No',
      breed_size: 'No',
      flavour: 'None',
      lifestage: 'Puppy',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Medium_Puppy_4kg.jpg',
    id: 'RC_Medium_Puppy_4kg',
    name: 'Royal Canin Medium Puppy (4kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 4.0,
    price: 590,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Puppy',
    breed: '',
    needs: 'General',
    size: 'medium',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'The Royal Canin Medium Junior Puppy Food for medium breed puppies (adult weight from 11 to 25 kg) - up to 12 months old.Contains an increased protein content to help support healthy, muscular, and skeletal growth during the relatively short growth...',
    longDescription:
      '<div class="std" itemprop="description"><p>The <strong>Royal Canin Medium Junior Puppy Food</strong> f<span>or medium breed puppies (adult weight from 11 to 25 kg) - up to 12 months old.</span></p><p><span>Contains an increased protein content to help support healthy, muscular, and skeletal growth during the relatively short growth period. Antioxidants are included to support your puppy\\\\\\\'s natural defences which can be a particular challenge during this life stage.</span></p><p><strong>Key Features:</strong><span></span></p><ul><li><strong>Immune system support :</strong> Helps support your puppy’s natural defences thanks particularly to a patented complex of antioxidants including vitamin E.</li><li><strong>Digestive health :</strong> Combination of nutrients with high quality protein and prebiotics to support digestive health and balance of intestinal flora, which contributes to good stool quality. </li><li><strong>Short growth - high energy content :</strong> Meets the high energy needs of medium breed puppies which have a short growth period.</li></ul></div>',
    keyBenefits: [
      'Immune system support :',
      'Digestive health :',
      'Short growth - high energy content :',
    ],
    feedingGuide: [
      {
        weight: 'AGE (MONTHS)',
        idealWeight: 'ADULT WEIGHT = 11 KG',
        overweight: 'ADULT WEIGHT = 14 KG',
      },
      {
        weight: '2 m',
        idealWeight: '155 g (1+4/8 cups)',
        overweight: '184 g (1+7/8 cups)',
      },
      {
        weight: '3 m',
        idealWeight: '182 g (1+6/8 cups)',
        overweight: '216 g (2+1/8 cups)',
      },
      {
        weight: '4 m',
        idealWeight: '194 g (1+7/8 cups)',
        overweight: '232 g (2+2/8 cups)',
      },
      {
        weight: '5 m',
        idealWeight: '197 g (2 cups)',
        overweight: '236 g (2+3/8 cups)',
      },
      {
        weight: '6 m',
        idealWeight: '197 g (2 cups)',
        overweight: '236 g (2+3/8 cups)',
      },
      {
        weight: '8 m',
        idealWeight: '159g (1+5/8 cups)',
        overweight: '204 g (2 cups)',
      },
      {
        weight: '10 m',
        idealWeight: '141 g (1+3/8 cups)',
        overweight: '169 g (1 +5/8 cups)',
      },
      {
        weight: '12 m',
        idealWeight: 'Transition to Medium Adult',
        overweight: 'Transition to Medium Adult',
      },
      {
        weight: '13 m',
        idealWeight: 'Medium Adult',
        overweight: 'Medium Adult',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'No',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'No',
      breed: 'No',
      breed_size: 'Medium Breed',
      flavour: 'Chicken',
      lifestage: 'Puppy',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Medium_Puppy_15kg.jpg',
    id: 'RC_Medium_Puppy_15kg',
    name: 'Royal Canin Medium Puppy (15kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 15.0,
    price: 1564,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Puppy',
    breed: '',
    needs: 'General',
    size: 'medium',
    sterilised: 'No',
    productSize: '10.1-20kg',
    description:
      'The Royal Canin Medium Junior Puppy Food for medium breed puppies (adult weight from 11 to 25 kg) - up to 12 months old.Contains an increased protein content to help support healthy, muscular, and skeletal growth during the relatively short growth...',
    longDescription:
      '<div class="std" itemprop="description"><p>The <strong>Royal Canin Medium Junior Puppy Food</strong> f<span>or medium breed puppies (adult weight from 11 to 25 kg) - up to 12 months old.</span></p><p><span>Contains an increased protein content to help support healthy, muscular, and skeletal growth during the relatively short growth period. Antioxidants are included to support your puppy\\\\\\\'s natural defences which can be a particular challenge during this life stage.</span></p><p><strong>Key Features:</strong><span></span></p><ul><li><strong>Immune system support :</strong> Helps support your puppy’s natural defences thanks particularly to a patented complex of antioxidants including vitamin E.</li><li><strong>Digestive health :</strong> Combination of nutrients with high quality protein and prebiotics to support digestive health and balance of intestinal flora, which contributes to good stool quality. </li><li><strong>Short growth - high energy content :</strong> Meets the high energy needs of medium breed puppies which have a short growth period.</li></ul></div>',
    keyBenefits: [
      'Immune system support :',
      'Digestive health :',
      'Short growth - high energy content :',
    ],
    feedingGuide: [
      {
        weight: 'AGE (MONTHS)',
        idealWeight: 'ADULT WEIGHT = 11 KG',
        overweight: 'ADULT WEIGHT = 14 KG',
      },
      {
        weight: '2 m',
        idealWeight: '155 g (1+4/8 cups)',
        overweight: '184 g (1+7/8 cups)',
      },
      {
        weight: '3 m',
        idealWeight: '182 g (1+6/8 cups)',
        overweight: '216 g (2+1/8 cups)',
      },
      {
        weight: '4 m',
        idealWeight: '194 g (1+7/8 cups)',
        overweight: '232 g (2+2/8 cups)',
      },
      {
        weight: '5 m',
        idealWeight: '197 g (2 cups)',
        overweight: '236 g (2+3/8 cups)',
      },
      {
        weight: '6 m',
        idealWeight: '197 g (2 cups)',
        overweight: '236 g (2+3/8 cups)',
      },
      {
        weight: '8 m',
        idealWeight: '159g (1+5/8 cups)',
        overweight: '204 g (2 cups)',
      },
      {
        weight: '10 m',
        idealWeight: '141 g (1+3/8 cups)',
        overweight: '169 g (1 +5/8 cups)',
      },
      {
        weight: '12 m',
        idealWeight: 'Transition to Medium Adult',
        overweight: 'Transition to Medium Adult',
      },
      {
        weight: '13 m',
        idealWeight: 'Medium Adult',
        overweight: 'Medium Adult',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'No',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'No',
      breed: 'No',
      breed_size: 'Medium Breed',
      flavour: 'Chicken',
      lifestage: 'Puppy',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Medium_Adult_4kg.jpg',
    id: 'RC_Medium_Adult_4kg',
    name: 'Royal Canin Medium Adult (4kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 4.0,
    price: 594,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: '',
    needs: 'General',
    size: 'medium',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'The Royal Canin Medium Adult Dog Food is designed for adult medium breed dogs (from 11 to 25 kg) - From 12 months to 7 years old.Royal Canin Medium Adult contains an exclusive antioxidant complex, as well as nutrients like manno-oligo-saccharides,...',
    longDescription:
      '<div class="std" itemprop="description"><p>The<strong> Royal Canin Medium Adult Dog Food</strong> is designed for <span>adult medium breed dogs (from 11 to 25 kg) - From 12 months to 7 years old.</span></p><p><span>Royal Canin Medium Adult contains an exclusive antioxidant complex, as well as nutrients like manno-oligo-saccharides, to help support your dog’s natural defences, allowing it to maintain a healthy lifestyle. </span></p><p><strong>Key Benefits:</strong></p><ul><li><strong>Natural defences :</strong> Helps support your dog’s natural defences, thanks particularly to an antioxidant complex and manno-oligo-saccharides.</li><li><strong>High digestibility :</strong> Helps support optimal digestibility thanks to an exclusive formula including very high quality protein and a balanced supply of dietary fibre.</li><li><strong>Omega 3:</strong> Enriched with Omega 3 fatty acids (EPA-DHA) to help maintain healthy skin.</li></ul></div>',
    keyBenefits: [
      'Natural defences :',
      'High digestibility :',
      'Omega 3:',
    ],
    feedingGuide: [
      {
        weight: 'WEIGHT OF DOG',
        idealWeight: 'LOW ACTIVITY',
        overweight: 'MEDIUM ACTIVITY',
      },
      {
        weight: '11 kg',
        idealWeight: '149 g (1+4/8 cups)',
        overweight: '173 g (1+6/8 cups)',
      },
      {
        weight: '12 kg',
        idealWeight: '159 g (1+5/8 cups)',
        overweight: '185 g (1+7/8 cups)',
      },
      {
        weight: '14 kg',
        idealWeight: '179 g (1+7/8 cups)',
        overweight: '207 g (2+1/8 cups)',
      },
      {
        weight: '16 kg',
        idealWeight: '198 g (2+1/8 cups)',
        overweight: '229 g (2+3/8 cups)',
      },
      {
        weight: '18 kg',
        idealWeight: '216 g (2+2/8 cups)',
        overweight: '250 g (2+5/8 cups)',
      },
      {
        weight: '20 kg',
        idealWeight: '234 g (2+4/8 cups)',
        overweight: '271 g (2+7/8 cups)',
      },
      {
        weight: '22 kg',
        idealWeight: '251 g (2+5/8 cups)',
        overweight: '291 g (3 cups)',
      },
      {
        weight: '24 kg',
        idealWeight: '268 g (2+6/8 cups)',
        overweight: '310 g (3+2/8 cups)',
      },
      {
        weight: '25 kg',
        idealWeight: '276 g (2+7/8 cups)',
        overweight: '320 g (3+3/8 cups)',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'No',
      breed_size: 'No',
      flavour: 'Chicken',
      lifestage: 'No',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Medium_Adult_10kg.jpg',
    id: 'RC_Medium_Adult_10kg',
    name: 'Royal Canin Medium Adult (10kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 10.0,
    price: 945,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: '',
    needs: 'General',
    size: 'medium',
    sterilised: 'No',
    productSize: '5.1-10kg',
    description:
      'The Royal Canin Medium Adult Dog Food is designed for adult medium breed dogs (from 11 to 25 kg) - From 12 months to 7 years old.Royal Canin Medium Adult contains an exclusive antioxidant complex, as well as nutrients like manno-oligo-saccharides,...',
    longDescription:
      '<div class="std" itemprop="description"><p>The<strong> Royal Canin Medium Adult Dog Food</strong> is designed for <span>adult medium breed dogs (from 11 to 25 kg) - From 12 months to 7 years old.</span></p><p><span>Royal Canin Medium Adult contains an exclusive antioxidant complex, as well as nutrients like manno-oligo-saccharides, to help support your dog’s natural defences, allowing it to maintain a healthy lifestyle. </span></p><p><strong>Key Benefits:</strong></p><ul><li><strong>Natural defences :</strong> Helps support your dog’s natural defences, thanks particularly to an antioxidant complex and manno-oligo-saccharides.</li><li><strong>High digestibility :</strong> Helps support optimal digestibility thanks to an exclusive formula including very high quality protein and a balanced supply of dietary fibre.</li><li><strong>Omega 3:</strong> Enriched with Omega 3 fatty acids (EPA-DHA) to help maintain healthy skin.</li></ul></div>',
    keyBenefits: [
      'Natural defences :',
      'High digestibility :',
      'Omega 3:',
    ],
    feedingGuide: [
      {
        weight: 'WEIGHT OF DOG',
        idealWeight: 'LOW ACTIVITY',
        overweight: 'MEDIUM ACTIVITY',
      },
      {
        weight: '11 kg',
        idealWeight: '149 g (1+4/8 cups)',
        overweight: '173 g (1+6/8 cups)',
      },
      {
        weight: '12 kg',
        idealWeight: '159 g (1+5/8 cups)',
        overweight: '185 g (1+7/8 cups)',
      },
      {
        weight: '14 kg',
        idealWeight: '179 g (1+7/8 cups)',
        overweight: '207 g (2+1/8 cups)',
      },
      {
        weight: '16 kg',
        idealWeight: '198 g (2+1/8 cups)',
        overweight: '229 g (2+3/8 cups)',
      },
      {
        weight: '18 kg',
        idealWeight: '216 g (2+2/8 cups)',
        overweight: '250 g (2+5/8 cups)',
      },
      {
        weight: '20 kg',
        idealWeight: '234 g (2+4/8 cups)',
        overweight: '271 g (2+7/8 cups)',
      },
      {
        weight: '22 kg',
        idealWeight: '251 g (2+5/8 cups)',
        overweight: '291 g (3 cups)',
      },
      {
        weight: '24 kg',
        idealWeight: '268 g (2+6/8 cups)',
        overweight: '310 g (3+2/8 cups)',
      },
      {
        weight: '25 kg',
        idealWeight: '276 g (2+7/8 cups)',
        overweight: '320 g (3+3/8 cups)',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'No',
      breed_size: 'No',
      flavour: 'Chicken',
      lifestage: 'No',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Medium_Adult_15kg.jpg',
    id: 'RC_Medium_Adult_15kg',
    name: 'Royal Canin Medium Adult (15kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 15.0,
    price: 1529,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: '',
    needs: 'General',
    size: 'medium',
    sterilised: 'No',
    productSize: '10.1-20kg',
    description:
      'The Royal Canin Medium Adult Dog Food is designed for adult medium breed dogs (from 11 to 25 kg) - From 12 months to 7 years old.Royal Canin Medium Adult contains an exclusive antioxidant complex, as well as nutrients like manno-oligo-saccharides,...',
    longDescription:
      '<div class="std" itemprop="description"><p>The<strong> Royal Canin Medium Adult Dog Food</strong> is designed for <span>adult medium breed dogs (from 11 to 25 kg) - From 12 months to 7 years old.</span></p><p><span>Royal Canin Medium Adult contains an exclusive antioxidant complex, as well as nutrients like manno-oligo-saccharides, to help support your dog’s natural defences, allowing it to maintain a healthy lifestyle. </span></p><p><strong>Key Benefits:</strong></p><ul><li><strong>Natural defences :</strong> Helps support your dog’s natural defences, thanks particularly to an antioxidant complex and manno-oligo-saccharides.</li><li><strong>High digestibility :</strong> Helps support optimal digestibility thanks to an exclusive formula including very high quality protein and a balanced supply of dietary fibre.</li><li><strong>Omega 3:</strong> Enriched with Omega 3 fatty acids (EPA-DHA) to help maintain healthy skin.</li></ul></div>',
    keyBenefits: [
      'Natural defences :',
      'High digestibility :',
      'Omega 3:',
    ],
    feedingGuide: [
      {
        weight: 'WEIGHT OF DOG',
        idealWeight: 'LOW ACTIVITY',
        overweight: 'MEDIUM ACTIVITY',
      },
      {
        weight: '11 kg',
        idealWeight: '149 g (1+4/8 cups)',
        overweight: '173 g (1+6/8 cups)',
      },
      {
        weight: '12 kg',
        idealWeight: '159 g (1+5/8 cups)',
        overweight: '185 g (1+7/8 cups)',
      },
      {
        weight: '14 kg',
        idealWeight: '179 g (1+7/8 cups)',
        overweight: '207 g (2+1/8 cups)',
      },
      {
        weight: '16 kg',
        idealWeight: '198 g (2+1/8 cups)',
        overweight: '229 g (2+3/8 cups)',
      },
      {
        weight: '18 kg',
        idealWeight: '216 g (2+2/8 cups)',
        overweight: '250 g (2+5/8 cups)',
      },
      {
        weight: '20 kg',
        idealWeight: '234 g (2+4/8 cups)',
        overweight: '271 g (2+7/8 cups)',
      },
      {
        weight: '22 kg',
        idealWeight: '251 g (2+5/8 cups)',
        overweight: '291 g (3 cups)',
      },
      {
        weight: '24 kg',
        idealWeight: '268 g (2+6/8 cups)',
        overweight: '310 g (3+2/8 cups)',
      },
      {
        weight: '25 kg',
        idealWeight: '276 g (2+7/8 cups)',
        overweight: '320 g (3+3/8 cups)',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'No',
      breed_size: 'No',
      flavour: 'Chicken',
      lifestage: 'No',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Medium_Adult_Ageing_7_plus_10kg.jpg',
    id: 'RC_Medium_Adult_Ageing_7_plus_10kg',
    name: 'Royal Canin Medium Adult Ageing 7+ (10kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 10.0,
    price: 1169,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Senior',
    breed: '',
    needs: 'General',
    size: 'medium',
    sterilised: 'No',
    productSize: '5.1-10kg',
    description:
      'The Royal Canin Medium Mature 7+ Adult Dog Food is designed for medium breed dogs (weight between 10 to 25 kg) over 7 years old.Royal Canin Medium Adult 7+ contains an exclusive complex of antioxidants to help neutralise free radicals and to help...',
    longDescription:
      '<div class="std" itemprop="description"><p>The <strong>Royal Canin Medium Mature 7+ Adult Dog Food</strong> is designed for medium breed dogs (weight between 10 to 25 kg) over 7 years old.</p><p><span>Royal Canin Medium Adult 7+ contains an exclusive complex of antioxidants to help neutralise free radicals and to help maintain the condition of vital molecules in your dog\\\\\\\'s body</span></p><p><strong>Key Benefits: </strong></p><ul><li><strong>Vitality support :</strong> Adapted content of nutrients to help maintain vitality in medium breed dogs facing the first signs of ageing. Contains an exclusive complex of antioxidants to help neutralise free radicals.</li><li><strong>High digestibility :</strong> Helps support optimal digestibility thanks to an exclusive formula including very high quality protein and a balanced supply of dietary fibre.</li><li><strong>Coat condition :</strong> This formula contains nutrients that help support a healthy skin.</li></ul></div>',
    keyBenefits: [
      'Vitality support :',
      'High digestibility :',
      'Coat condition :',
    ],
    feedingGuide: [
      {
        weight: 'WEIGHT OF DOG',
        idealWeight: 'LOW ACTIVITY',
        overweight: 'MEDIUM ACTIVITY',
      },
      {
        weight: '11 kg',
        idealWeight: '149 g (1+4/8 cups)',
        overweight: '172 g (1+6/8 cups)',
      },
      {
        weight: '12 kg',
        idealWeight: '159 g (1+5/8 cups)',
        overweight: '184 g (1+7/8 cups)',
      },
      {
        weight: '14 kg',
        idealWeight: '178 g (1+7/8 cups)',
        overweight: '207 g (2+1/8 cups)',
      },
      {
        weight: '16 kg',
        idealWeight: '197 g (2 cups)',
        overweight: '228 g (2+3/8 cups)',
      },
      {
        weight: '18 kg',
        idealWeight: '215 g (2+2/8 cups)',
        overweight: '249 g (2+5/8 cups)',
      },
      {
        weight: '20 kg',
        idealWeight: '233 g (2+3/8 cups)',
        overweight: '270 g (2+7/8 cups)',
      },
      {
        weight: '22 kg',
        idealWeight: '250 g (2+5/8 cups)',
        overweight: '290 g (3 cups)',
      },
      {
        weight: '24 kg',
        idealWeight: '267 g (2+6/8 cups)',
        overweight: '309 g (3+2/8 cups)',
      },
      {
        weight: '25 kg',
        idealWeight: '276 g (2+7/8 cups)',
        overweight: '319 g (3+3/8 cups)',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'No',
      breed_size: 'No',
      flavour: 'Chicken',
      lifestage: 'No',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Maxi_Starter_Mother_Babydog_15kg.jpg',
    id: 'RC_Maxi_Starter_Mother_Babydog_15kg',
    name: 'Royal Canin Maxi Starter Mother & Babydog (15kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 15.0,
    price: 1739,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Puppy',
    breed: '',
    needs: 'General',
    size: 'large',
    sterilised: 'No',
    productSize: '10.1-20kg',
    description:
      'Complete feed for dogs - From weaning to 2 months.',
    longDescription:
      '<div class="std" itemprop="description"><p>Complete feed for dogs - From weaning to 2 months.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Immune System Support - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Digestive Health - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Growth Support - </strong>Nutritional support tailored to your pet\'s needs.</li></ul></div>',
    keyBenefits: [
      'Immune System Support -',
      'Digestive Health -',
      'Growth Support -',
    ],
    feedingGuide: [
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'No',
      breed_size: 'No',
      flavour: 'None',
      lifestage: 'Puppy',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Maxi_Puppy_4kg.jpg',
    id: 'RC_Maxi_Puppy_4kg',
    name: 'Royal Canin Maxi Puppy (4kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 4.0,
    price: 607,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Puppy',
    breed: '',
    needs: 'General',
    size: 'large',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'The Royal Canin Maxi Junior Puppy Food is designed for large breed puppies (adult weight between 25 to 45 kg) up to 15 months. Royal Canin Maxi Puppy food contains a patented complex of antioxidants - including the highly beneficial vitamin E to...',
    longDescription:
      '<div class="std" itemprop="description"><p>The <strong>Royal Canin Maxi Junior Puppy Food </strong>is designed for large breed puppies (adult weight between 25 to 45 kg) up to 15 months. </p><p><span>Royal Canin Maxi Puppy food contains a patented complex of antioxidants - including the highly beneficial vitamin E to support your puppy\\\\\\\'s natural defences while its immune system is immature and still developing.</span></p><p><strong>Key Features:</strong><span></span></p><ul><li><strong>Immune system support : </strong>Helps support your puppy’s natural defences thanks particularly to a patented complex of antioxidants including vitamin E. </li><li><strong>Long growth - moderate energy :</strong> Meets the moderate energy needs of large breed puppies which have a long growth period.</li><li><strong>Digestive health :</strong> Combination of nutrients with high quality protein and prebiotics to support digestive health and balance of intestinal flora, which contributes to good stool quality.</li></ul></div>',
    keyBenefits: [
      'Immune system support :',
      'Long growth - moderate energy :',
      'Digestive health :',
    ],
    feedingGuide: [
      {
        weight: 'ADULT WEIGHT',
        idealWeight: '26KG',
        overweight: '-',
      },
      {
        weight: 'Age (month)',
        idealWeight: 'grams',
        overweight: 'cup',
      },
      {
        weight: '2m',
        idealWeight: '264g',
        overweight: '3+3/8',
      },
      {
        weight: '3m',
        idealWeight: '326g',
        overweight: '4+1/8',
      },
      {
        weight: '4m',
        idealWeight: '354g',
        overweight: '4+4/8',
      },
      {
        weight: '5m',
        idealWeight: '380g',
        overweight: '4+7/8',
      },
      {
        weight: '6m',
        idealWeight: '404g',
        overweight: '5+1/8',
      },
      {
        weight: '8m',
        idealWeight: '374g',
        overweight: '4+6/8',
      },
      {
        weight: '10m',
        idealWeight: '318g',
        overweight: '4+1/8',
      },
      {
        weight: '12m',
        idealWeight: '287g',
        overweight: '3+5/8',
      },
      {
        weight: '14m',
        idealWeight: '285g',
        overweight: '3+5/8',
      },
      {
        weight: '15m',
        idealWeight: '285g',
        overweight: '3+5/8',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'No',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'No',
      breed: 'No',
      breed_size: 'No',
      flavour: 'Chicken',
      lifestage: 'No',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Maxi_Puppy_15kg.jpg',
    id: 'RC_Maxi_Puppy_15kg',
    name: 'Royal Canin Maxi Puppy (15kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 15.0,
    price: 1557,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Puppy',
    breed: '',
    needs: 'General',
    size: 'large',
    sterilised: 'No',
    productSize: '10.1-20kg',
    description:
      'The Royal Canin Maxi Junior Puppy Food is designed for large breed puppies (adult weight between 25 to 45 kg) up to 15 months. Royal Canin Maxi Puppy food contains a patented complex of antioxidants - including the highly beneficial vitamin E to...',
    longDescription:
      '<div class="std" itemprop="description"><p>The <strong>Royal Canin Maxi Junior Puppy Food </strong>is designed for large breed puppies (adult weight between 25 to 45 kg) up to 15 months. </p><p><span>Royal Canin Maxi Puppy food contains a patented complex of antioxidants - including the highly beneficial vitamin E to support your puppy\\\\\\\'s natural defences while its immune system is immature and still developing.</span></p><p><strong>Key Features:</strong><span></span></p><ul><li><strong>Immune system support : </strong>Helps support your puppy’s natural defences thanks particularly to a patented complex of antioxidants including vitamin E. </li><li><strong>Long growth - moderate energy :</strong> Meets the moderate energy needs of large breed puppies which have a long growth period.</li><li><strong>Digestive health :</strong> Combination of nutrients with high quality protein and prebiotics to support digestive health and balance of intestinal flora, which contributes to good stool quality.</li></ul></div>',
    keyBenefits: [
      'Immune system support :',
      'Long growth - moderate energy :',
      'Digestive health :',
    ],
    feedingGuide: [
      {
        weight: 'ADULT WEIGHT',
        idealWeight: '26KG',
        overweight: '-',
      },
      {
        weight: 'Age (month)',
        idealWeight: 'grams',
        overweight: 'cup',
      },
      {
        weight: '2m',
        idealWeight: '264g',
        overweight: '3+3/8',
      },
      {
        weight: '3m',
        idealWeight: '326g',
        overweight: '4+1/8',
      },
      {
        weight: '4m',
        idealWeight: '354g',
        overweight: '4+4/8',
      },
      {
        weight: '5m',
        idealWeight: '380g',
        overweight: '4+7/8',
      },
      {
        weight: '6m',
        idealWeight: '404g',
        overweight: '5+1/8',
      },
      {
        weight: '8m',
        idealWeight: '374g',
        overweight: '4+6/8',
      },
      {
        weight: '10m',
        idealWeight: '318g',
        overweight: '4+1/8',
      },
      {
        weight: '12m',
        idealWeight: '287g',
        overweight: '3+5/8',
      },
      {
        weight: '14m',
        idealWeight: '285g',
        overweight: '3+5/8',
      },
      {
        weight: '15m',
        idealWeight: '285g',
        overweight: '3+5/8',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'No',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'No',
      breed: 'No',
      breed_size: 'No',
      flavour: 'Chicken',
      lifestage: 'No',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Maxi_Adult_4kg.jpg',
    id: 'RC_Maxi_Adult_4kg',
    name: 'Royal Canin Maxi Adult (4kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 4.0,
    price: 558,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: '',
    needs: 'General',
    size: 'large',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'Royal Canin Maxi Adult Dog Food is suitable for large breed dogs (weight between 26 and 44 kg) - aged15 months to 5 years old.Royal Canin Maxi Adult food will help maintain an ideal weight that your dog can comfortably supportKey Benefits:High...',
    longDescription:
      '<div class="std" itemprop="description"><p><strong>Royal Canin Maxi Adult Dog Food</strong> is suitable for large breed dogs (weight between 26 and 44 kg) - aged<span>15 months to 5 years old.</span></p><p><span>Royal Canin Maxi Adult food will help maintain an ideal weight that your dog can comfortably support</span></p><p><strong>Key Benefits:</strong></p><ul><li><strong>High digestibility -</strong> Contains high quality protein and a balanced supply of dietary fibre, supporting optimal digestibility.</li><li><strong>Bone &amp; joint support - </strong>Helps support large breed dogs’ healthy bones and joints, which can be placed under stress by body weight.</li><li><strong>Omega 3: EPA-DHA -</strong> Enriched with Omega 3 fatty acids (EPA-DHA) to help maintain healthy skin.</li><li><strong>Delicious Formula - </strong>Exclusive large-sized kibble design is highly palatable.</li></ul></div>',
    keyBenefits: [
      'High digestibility -',
      'Bone & joint support -',
      'Omega 3: EPA-DHA -',
      'Delicious Formula -',
    ],
    feedingGuide: [
      {
        weight: 'WEIGHT OF DOG',
        idealWeight: 'LOW ACTIVITY',
        overweight: 'MEDIUM ACTIVITY',
      },
      {
        weight: '26 kg',
        idealWeight: '276 g (2+7/8 cups)',
        overweight: '319 g (3+3/8 cups)',
      },
      {
        weight: '28 kg',
        idealWeight: '291 g (3 cups)',
        overweight: '337 g (3+4/8 cups)',
      },
      {
        weight: '30 kg',
        idealWeight: '307 g (3+2/8 cups)',
        overweight: '355 g (3+6/8 cups)',
      },
      {
        weight: '32 kg',
        idealWeight: '322 g (3+3/8 cups)',
        overweight: '373 g (3+7/8 cups)',
      },
      {
        weight: '34 kg',
        idealWeight: '337 g (3+4/8 cups)',
        overweight: '390 g (4+1/8 cups)',
      },
      {
        weight: '36 kg',
        idealWeight: '352 g (3+5/8 cups)',
        overweight: '407 g (4+2/8 cups)',
      },
      {
        weight: '38 kg',
        idealWeight: '366 g (3+7/8 cups)',
        overweight: '424 g (4+3/8 cups)',
      },
      {
        weight: '40 kg',
        idealWeight: '381 g (4 cups)',
        overweight: '441 g (4+5/8 cups)',
      },
      {
        weight: '42 kg',
        idealWeight: '395 g (4+1/8 cups)',
        overweight: '457 g (4+6/8 cups)',
      },
      {
        weight: '44 kg',
        idealWeight: '405 g (4+2/8 cups)',
        overweight: '473 g (4+7/8 cups)',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'No',
      breed_size: 'Large Breed',
      flavour: 'Chicken',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Maxi_Adult_15kg.jpg',
    id: 'RC_Maxi_Adult_15kg',
    name: 'Royal Canin Maxi Adult (15kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 15.0,
    price: 1529,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: '',
    needs: 'General',
    size: 'large',
    sterilised: 'No',
    productSize: '10.1-20kg',
    description:
      'Royal Canin Maxi Adult Dog Food is suitable for large breed dogs (weight between 26 and 44 kg) - aged15 months to 5 years old.Royal Canin Maxi Adult food will help maintain an ideal weight that your dog can comfortably supportKey Benefits:High...',
    longDescription:
      '<div class="std" itemprop="description"><p><strong>Royal Canin Maxi Adult Dog Food</strong> is suitable for large breed dogs (weight between 26 and 44 kg) - aged<span>15 months to 5 years old.</span></p><p><span>Royal Canin Maxi Adult food will help maintain an ideal weight that your dog can comfortably support</span></p><p><strong>Key Benefits:</strong></p><ul><li><strong>High digestibility -</strong> Contains high quality protein and a balanced supply of dietary fibre, supporting optimal digestibility.</li><li><strong>Bone &amp; joint support - </strong>Helps support large breed dogs’ healthy bones and joints, which can be placed under stress by body weight.</li><li><strong>Omega 3: EPA-DHA -</strong> Enriched with Omega 3 fatty acids (EPA-DHA) to help maintain healthy skin.</li><li><strong>Delicious Formula - </strong>Exclusive large-sized kibble design is highly palatable.</li></ul></div>',
    keyBenefits: [
      'High digestibility -',
      'Bone & joint support -',
      'Omega 3: EPA-DHA -',
      'Delicious Formula -',
    ],
    feedingGuide: [
      {
        weight: 'WEIGHT OF DOG',
        idealWeight: 'LOW ACTIVITY',
        overweight: 'MEDIUM ACTIVITY',
      },
      {
        weight: '26 kg',
        idealWeight: '276 g (2+7/8 cups)',
        overweight: '319 g (3+3/8 cups)',
      },
      {
        weight: '28 kg',
        idealWeight: '291 g (3 cups)',
        overweight: '337 g (3+4/8 cups)',
      },
      {
        weight: '30 kg',
        idealWeight: '307 g (3+2/8 cups)',
        overweight: '355 g (3+6/8 cups)',
      },
      {
        weight: '32 kg',
        idealWeight: '322 g (3+3/8 cups)',
        overweight: '373 g (3+7/8 cups)',
      },
      {
        weight: '34 kg',
        idealWeight: '337 g (3+4/8 cups)',
        overweight: '390 g (4+1/8 cups)',
      },
      {
        weight: '36 kg',
        idealWeight: '352 g (3+5/8 cups)',
        overweight: '407 g (4+2/8 cups)',
      },
      {
        weight: '38 kg',
        idealWeight: '366 g (3+7/8 cups)',
        overweight: '424 g (4+3/8 cups)',
      },
      {
        weight: '40 kg',
        idealWeight: '381 g (4 cups)',
        overweight: '441 g (4+5/8 cups)',
      },
      {
        weight: '42 kg',
        idealWeight: '395 g (4+1/8 cups)',
        overweight: '457 g (4+6/8 cups)',
      },
      {
        weight: '44 kg',
        idealWeight: '405 g (4+2/8 cups)',
        overweight: '473 g (4+7/8 cups)',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'No',
      breed_size: 'Large Breed',
      flavour: 'Chicken',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Maxi_Adult_Ageing_5_plus_15kg.jpg',
    id: 'RC_Maxi_Adult_Ageing_5_plus_15kg',
    name: 'Royal Canin Maxi Adult Ageing 5+ (15kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 15.0,
    price: 1629,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Senior',
    breed: '',
    needs: 'General',
    size: 'large',
    sterilised: 'No',
    productSize: '10.1-20kg',
    description:
      'Royal Canin Maxi Adult Dog Food is suitable for large breed dogs (weight between 26 and 44 kg) - over 5 years old. Royal Canin Maxi Adult 5+ contains a unique and balanced blend of very high-quality protein and dietary fibre, meaning each serving...',
    longDescription:
      '<div class="std" itemprop="description"><p><strong>Royal Canin Maxi Adult Dog Food</strong> is suitable for large breed dogs (weight between 26 and 44 kg) - over 5 years old. </p><p><span>Royal Canin Maxi Adult 5+ contains a unique and balanced blend of very high-quality protein and dietary fibre, meaning each serving gives your dog what it needs to maintain a healthy weight and support optimal digestion.</span></p><p><strong>Key Benefits:</strong></p><ul><li><strong>Vitality support : </strong><span>Adapted content of nutrients to help maintain vitality in large breed dogs facing the first signs of ageing. Contains an exclusive complex of antioxidants to help neutralise free radicals.</span></li><li><span><strong>Bone &amp; joint support :</strong> Helps support large breed dogs’ healthy bones and joints, which can be placed under stress by body weight.</span></li><li><span><strong>Omega 3:</strong> Enriched with Omega 3 fatty acids to help maintain healthy skin</span></li></ul></div>',
    keyBenefits: [
      'Vitality support :',
      'Bone & joint support :',
      'Omega 3:',
    ],
    feedingGuide: [
      {
        weight: 'WEIGHT OF DOG',
        idealWeight: 'LOW ACTIVITY',
        overweight: 'MEDIUM ACTIVITY',
      },
      {
        weight: '26 kg',
        idealWeight: '281 g (3 cups)',
        overweight: '325 g (3+4/8 cups)',
      },
      {
        weight: '28 kg',
        idealWeight: '297 g (3+1/8 cups)',
        overweight: '344 g (3+5/8 cups)',
      },
      {
        weight: '30 kg',
        idealWeight: '312 g (3+3/8 cups)',
        overweight: '362 g (3+7/8 cups)',
      },
      {
        weight: '32 kg',
        idealWeight: '328 g (3+4/8 cups)',
        overweight: '380 g (4 cups)',
      },
      {
        weight: '34 kg',
        idealWeight: '343 g (3+5/8 cups)',
        overweight: '397 g (4+2/8 cups)',
      },
      {
        weight: '36 kg',
        idealWeight: '358 g (3+7/8 cups)',
        overweight: '415 g (4+3/8 cups)',
      },
      {
        weight: '38 kg',
        idealWeight: '373 g (4 cups)',
        overweight: '432 g (4+5/8 cups)',
      },
      {
        weight: '40 kg',
        idealWeight: '388 g (4+1/8 cups)',
        overweight: '449 g (4+6/8 cups)',
      },
      {
        weight: '42 kg',
        idealWeight: '402 g (4+2/8 cups)',
        overweight: '466 g (5 cups)',
      },
      {
        weight: '44 kg',
        idealWeight: '416 g (4+4/8 cups)',
        overweight: '482 g (5+1/8 cups)',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'No',
      breed_size: 'Large Breed',
      flavour: 'Chicken',
      lifestage: 'Senior',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Giant_Starter_Mother_Babydog_15kg.jpg',
    id: 'RC_Giant_Starter_Mother_Babydog_15kg',
    name: 'Royal Canin Giant Starter Mother & Babydog (15kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 15.0,
    price: 1598,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Puppy',
    breed: '',
    needs: 'General',
    size: 'giant',
    sterilised: 'No',
    productSize: '10.1-20kg',
    description:
      'Complete feed for dogs - From weaning to 2 months.',
    longDescription:
      '<div class="std" itemprop="description"><p>Complete feed for dogs - From weaning to 2 months.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Immune System Support - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Digestive Health - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Growth Support - </strong>Nutritional support tailored to your pet\'s needs.</li></ul></div>',
    keyBenefits: [
      'Immune System Support -',
      'Digestive Health -',
      'Growth Support -',
    ],
    feedingGuide: [
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'No',
      breed_size: 'No',
      flavour: 'None',
      lifestage: 'Puppy',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Giant_Puppy_3_5kg.jpg',
    id: 'RC_Giant_Puppy_3_5kg',
    name: 'Royal Canin Giant Puppy (3.5kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 3.5,
    price: 458,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Puppy',
    breed: '',
    needs: 'General',
    size: 'giant',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'The Royal Canin Giant Puppy Food is for giant breed puppies (adult weight over 45 kg) up to 8 months. The strategic balance of energy and minerals in the food contribute to healthy bone mineralisation in giant breed puppies. This helps to support...',
    longDescription:
      '<div class="std" itemprop="description"><p>The <strong>Royal Canin Giant Puppy Food</strong> is for giant breed puppies (adult weight over 45 kg) up to 8 months. </p><p>The strategic balance of energy and minerals in the food contribute to healthy bone mineralisation in giant breed puppies. This helps to support joint and bone consolidation, as well as healthy growth.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Immune system support : </strong>Helps support your puppy’s natural defences thanks particularly to a patented complex of antioxidants including vitamin E.</li><li><strong>Intense growth - controlled energy : </strong>Helps support high growth rate during the first growth phase in giant breed puppies and helps avoid excess weight gain thanks to an adapted energy content.</li><li><span><strong>Bone &amp; joint support :</strong> Contributes to good bone mineralisation in giant breed puppies thanks to a balanced intake of energy and minerals, thus supporting bone consolidation and joints.</span></li></ul></div>',
    keyBenefits: [
      'Immune system support :',
      'Intense growth - controlled energy :',
      'Bone & joint support :',
    ],
    feedingGuide: [
      {
        weight: 'AGE (MONTHS)',
        idealWeight: 'ADULT WEIGHT = 45 KG',
        overweight: 'ADULT WEIGHT = 60 KG',
      },
      {
        weight: '2 m',
        idealWeight: '311 g (3+5/8 cups)',
        overweight: '397 g (4+5/8 cups)',
      },
      {
        weight: '3 m',
        idealWeight: '409 g (4+6/8 cups)',
        overweight: '507 g (5+7/8 cups)',
      },
      {
        weight: '4 m',
        idealWeight: '452 g (5+2/8 cups)',
        overweight: '559 g (6+4/8 cups)',
      },
      {
        weight: '5 m',
        idealWeight: '537g (6+2/8 cups)',
        overweight: '662 g (7+5/8 cups)',
      },
      {
        weight: '6 m',
        idealWeight: '611 g (7+1/8 cups)',
        overweight: '753 g (8+6/8 cups)',
      },
      {
        weight: '7 m',
        idealWeight: '613 g (7+1/8 cups)',
        overweight: '760 g (8+6/8 cups)',
      },
      {
        weight: '8 m',
        idealWeight: '609 g (7 cups)',
        overweight: '760 g (8+6/8 cups)',
      },
      {
        weight: '9 m +',
        idealWeight: 'Transition to Giant Junior',
        overweight: 'Transition to Giant Junior',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'No',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food, Immune Support',
      breed: 'No',
      breed_size: 'Giant Breed',
      flavour: 'Chicken',
      lifestage: 'Puppy',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Giant_Puppy_15kg.jpg',
    id: 'RC_Giant_Puppy_15kg',
    name: 'Royal Canin Giant Puppy (15kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 15.0,
    price: 1491,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Puppy',
    breed: '',
    needs: 'General',
    size: 'giant',
    sterilised: 'No',
    productSize: '10.1-20kg',
    description:
      'The Royal Canin Giant Puppy Food is for giant breed puppies (adult weight over 45 kg) up to 8 months. The strategic balance of energy and minerals in the food contribute to healthy bone mineralisation in giant breed puppies. This helps to support...',
    longDescription:
      '<div class="std" itemprop="description"><p>The <strong>Royal Canin Giant Puppy Food</strong> is for giant breed puppies (adult weight over 45 kg) up to 8 months. </p><p>The strategic balance of energy and minerals in the food contribute to healthy bone mineralisation in giant breed puppies. This helps to support joint and bone consolidation, as well as healthy growth.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Immune system support : </strong>Helps support your puppy’s natural defences thanks particularly to a patented complex of antioxidants including vitamin E.</li><li><strong>Intense growth - controlled energy : </strong>Helps support high growth rate during the first growth phase in giant breed puppies and helps avoid excess weight gain thanks to an adapted energy content.</li><li><span><strong>Bone &amp; joint support :</strong> Contributes to good bone mineralisation in giant breed puppies thanks to a balanced intake of energy and minerals, thus supporting bone consolidation and joints.</span></li></ul></div>',
    keyBenefits: [
      'Immune system support :',
      'Intense growth - controlled energy :',
      'Bone & joint support :',
    ],
    feedingGuide: [
      {
        weight: 'AGE (MONTHS)',
        idealWeight: 'ADULT WEIGHT = 45 KG',
        overweight: 'ADULT WEIGHT = 60 KG',
      },
      {
        weight: '2 m',
        idealWeight: '311 g (3+5/8 cups)',
        overweight: '397 g (4+5/8 cups)',
      },
      {
        weight: '3 m',
        idealWeight: '409 g (4+6/8 cups)',
        overweight: '507 g (5+7/8 cups)',
      },
      {
        weight: '4 m',
        idealWeight: '452 g (5+2/8 cups)',
        overweight: '559 g (6+4/8 cups)',
      },
      {
        weight: '5 m',
        idealWeight: '537g (6+2/8 cups)',
        overweight: '662 g (7+5/8 cups)',
      },
      {
        weight: '6 m',
        idealWeight: '611 g (7+1/8 cups)',
        overweight: '753 g (8+6/8 cups)',
      },
      {
        weight: '7 m',
        idealWeight: '613 g (7+1/8 cups)',
        overweight: '760 g (8+6/8 cups)',
      },
      {
        weight: '8 m',
        idealWeight: '609 g (7 cups)',
        overweight: '760 g (8+6/8 cups)',
      },
      {
        weight: '9 m +',
        idealWeight: 'Transition to Giant Junior',
        overweight: 'Transition to Giant Junior',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'No',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food, Immune Support',
      breed: 'No',
      breed_size: 'Giant Breed',
      flavour: 'Chicken',
      lifestage: 'Puppy',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Giant_Junior_15kg.jpg',
    id: 'RC_Giant_Junior_15kg',
    name: 'Royal Canin Giant Junior (15kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 15.0,
    price: 1491,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Junior',
    breed: '',
    needs: 'General',
    size: 'giant',
    sterilised: 'No',
    productSize: '10.1-20kg',
    description:
      'The Royal Canin Giant Junior Food is designed for giant breed puppies (adult weight over 45 kg) from 8 months to 18/24 months.Royal Canin Giant Junior helps to support your puppy\'s high growth rate during the second stage of growth. Key Features:...',
    longDescription:
      '<div class="std" itemprop="description"><p>The <strong>Royal Canin Giant Junior Food</strong> is designed for giant breed puppies (adult weight over 45 kg) from 8 months to 18/24 months.</p><p><span>Royal Canin Giant Junior helps to support your puppy\\\\\\\'s high growth rate during the second stage of growth. </span></p><p><strong>Key Features: </strong></p><ul><li><strong>Immune system support :</strong> Helps support your puppy’s natural defences thanks particularly to a patented complex of antioxidants including vitamin E. </li><li><strong>2nd growth phase: muscle development :</strong> An adapted protein and L-carnitine content to help support muscle development in giant breed puppies during the second growth phase from 8 months old.</li><li><strong>Bone &amp; joint support : </strong>Contributes to good bone mineralisation in giant breed puppies thanks to a balanced intake of energy and minerals (calcium and phosphorus), thus supporting bone consolidation and joints.</li></ul></div>',
    keyBenefits: [
      'Immune system support :',
      '2nd growth phase: muscle development :',
      'Bone & joint support :',
    ],
    feedingGuide: [
      {
        weight: 'AGE (MONTHS)',
        idealWeight: 'ADULT WEIGHT = 45 KG',
        overweight: 'ADULT WEIGHT = 60 KG',
      },
      {
        weight: '8 m',
        idealWeight: '593 g (6+7/8 cups)',
        overweight: '741 g (8+5/8 cups)',
      },
      {
        weight: '9 m',
        idealWeight: '554 g (6+3/8 cups)',
        overweight: '697 g (8+1/8 cups)',
      },
      {
        weight: '10 m',
        idealWeight: '518 g (6 cups)',
        overweight: '654 g (7+5/8 cups)',
      },
      {
        weight: '11 m',
        idealWeight: '473 g (5+4/8 cups)',
        overweight: '610 g (7 cups)',
      },
      {
        weight: '12 m',
        idealWeight: '431 g (5 cups)',
        overweight: '571 g (6+5/8 cups)',
      },
      {
        weight: '13 m',
        idealWeight: '428 g (5 cups)',
        overweight: '535 g (6+2/8 cups)',
      },
      {
        weight: '14 m',
        idealWeight: '424 g (4+7/8 cups)',
        overweight: '532 g (6+1/8 cups)',
      },
      {
        weight: '18 m',
        idealWeight: 'Transition to Giant Adult',
        overweight: '526 g (6+1/8 cups)',
      },
      {
        weight: '24 m',
        idealWeight: 'Transition to Giant Adult',
        overweight: 'Transition to Giant Adult',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'No',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'No',
      breed_size: 'Giant Breed',
      flavour: 'Chicken',
      lifestage: 'Puppy',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Giant_Adult_15kg.jpg',
    id: 'RC_Giant_Adult_15kg',
    name: 'Royal Canin Giant Adult (15kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 15.0,
    price: 1458,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: '',
    needs: 'General',
    size: 'giant',
    sterilised: 'No',
    productSize: '10.1-20kg',
    description:
      'Royal Canin Giant Adult Dry Dog Food is suited for adult giant breed dogs (weight 45 kg and over) - from over 18-24 months old. Due to their sheer size your gentle giant has a lot of daily stress on their joints. These giant breed dogs need a...',
    longDescription:
      '<div class="std" itemprop="description"><p><strong>Royal Canin Giant Adult Dry Dog Food</strong> is suited for adult giant breed dogs (weight 45 kg and over) - from over 18-24 months old. </p><p>Due to their sheer size your gentle giant has a lot of daily stress on their joints. These giant breed dogs need a size-specific formula that will support all their nutritional needs and help them live a long, happy life. </p><p><span><strong>Key Benefits:</strong></span></p><ul><li><strong>Bone &amp; joint support :</strong> Helps support giant breed dogs’ healthy bones and joints, which can be placed under stress by body weight.</li><li><strong>Antioxidant complex :</strong> Contains an exclusive complex of antioxidants to help neutralise free radicals.</li><li><strong>Cardiac health :</strong> Helps maintain a healthy heart thanks to an adapted taurine content.</li></ul></div>',
    keyBenefits: [
      'Bone & joint support :',
      'Antioxidant complex :',
      'Cardiac health :',
    ],
    feedingGuide: [
      {
        weight: 'WEIGHT OF DOG',
        idealWeight: 'LOW ACTIVITY',
        overweight: 'MEDIUM ACTIVITY',
      },
      {
        weight: '45 kg',
        idealWeight: '394 g (3+7/8 cups)',
        overweight: '457 g (4+3/8 cups)',
      },
      {
        weight: '55 kg',
        idealWeight: '459 g (4+4/8 cups)',
        overweight: '531 g (5+1/8 cups)',
      },
      {
        weight: '65 kg',
        idealWeight: '520 g (5 cups)',
        overweight: '602 g (5+7/8 cups)',
      },
      {
        weight: '75 kg',
        idealWeight: '579 g (5+5/8 cups)',
        overweight: '670 g (6+4/8 cups)',
      },
      {
        weight: '85 kg',
        idealWeight: '636 g (6+1/8 cups)',
        overweight: '736 g (7+1/8 cups)',
      },
      {
        weight: '100 kg',
        idealWeight: '718 g (7 cups)',
        overweight: '831 g (8 cups)',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'No',
      breed_size: 'Giant Breed',
      flavour: 'Chicken',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Babydog_Milk_400g.jpg',
    id: 'RC_Babydog_Milk_400g',
    name: 'Royal Canin Babydog Milk (400g)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 0.4,
    price: 421,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Puppy',
    breed: '',
    needs: 'General',
    size: 'medium',
    sterilised: 'No',
    productSize: '101-400g',
    description:
      'Complete feed for dogs - Milk substitute up to 2 months.',
    longDescription:
      '<div class="std" itemprop="description"><p>Complete feed for dogs - Milk substitute up to 2 months.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Immune System Support - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Digestive Health - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Growth Support - </strong>Nutritional support tailored to your pet\'s needs.</li></ul></div>',
    keyBenefits: [
      'Immune System Support -',
      'Digestive Health -',
      'Growth Support -',
    ],
    feedingGuide: [
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'No',
      breed_size: 'No',
      flavour: 'None',
      lifestage: 'Puppy',
      size_chart: 'No',
    },
  },
  // -- Starter & Supplements --
  {
    image: '/pet_images/RC_Starter_Mousse_Can_12x195g.jpg',
    id: 'RC_Starter_Mousse_Can_12x195g',
    name: 'Royal Canin Starter Mousse Can (12x195g)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 2.34,
    price: 485,
    category: 'Wet food',
    brand: 'Royal Canin',
    age: 'Puppy',
    breed: '',
    needs: 'General',
    size: 'small',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'Complete feed for dogs - From weaning to 2 months.',
    longDescription:
      '<div class="std" itemprop="description"><p>Complete feed for dogs - From weaning to 2 months.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Immune System Support - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Digestive Health - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Growth Support - </strong>Nutritional support tailored to your pet\'s needs.</li></ul></div>',
    keyBenefits: [
      'Immune System Support -',
      'Digestive Health -',
      'Growth Support -',
    ],
    feedingGuide: [
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'No',
      breed_size: 'No',
      flavour: 'None',
      lifestage: 'Puppy',
      size_chart: 'No',
    },
  },
  // -- Wet Food --
  {
    image: '/pet_images/RC_Mini_Puppy_12x85g.jpg',
    id: 'RC_Mini_Puppy_12x85g',
    name: 'Royal Canin Mini Puppy (12x85g)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1.02,
    price: 269,
    category: 'Wet food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: '',
    needs: 'General',
    size: 'small',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'Complete feed for dogs - For adult small breed dogs (weight between 1 and 10 kg) - Over 10 months old.',
    longDescription:
      'Suitable for small breed dogs over 10 months old that weigh up to 10kg, ROYAL CANINÃ‚Â® Mini Adult is specially formulated with all the nutritional needs of your adult mini dog in mind.<div style="margin: 0cm 0cm 8pt">Because small breed dogs like yours tend to have high energy needs, ROYAL CANINÃ‚Â® Mini Adult is formulated with nutrients that help to meet those energy needs, whilst also helping your dog to maintain a healthy weight.<div style="margin: 0cm 0cm 8pt">Some small breed dogs have fussier appetites than others, that\\\'s why ROYAL CANINÃ‚Â® Mini Adult\\\'s formula contains a selection of exclusive flavourings. It is this enhanced palatability that directly appeals to even the fussiest of dogs.<div style="margin: 0cm 0cm 8pt">ROYAL CANINÃ‚Â® Mini Adult also contains a variety of nutrients that help to support and maintain the health of your dog\\\'s skin and coat.<div style="margin: 0cm 0cm 8pt">To cater to each dog\\\'s individual preferences, ROYAL CANINÃ‚Â® Mini Adult is also available as wet food in delicious gravy.<div style="margin: 0cm 0cm 8pt">If you\\\'re considering mixed feeding, simply follow our feeding guidelines to ensure your dog gets an accurate amount of both wet and dry food for optimal benefit.</div></div></div></div></div>',
  },
  {
    image: '/pet_images/RC_Mini_Adult_12x85g.jpg',
    id: 'RC_Mini_Adult_12x85g',
    name: 'Royal Canin Mini Adult (12x85g)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1.02,
    price: 269,
    category: 'Wet food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: '',
    needs: 'General',
    size: 'small',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'Complete feed for dogs - For adult small breed dogs (weight between 1 and 10 kg) - Over 10 months old.',
    longDescription:
      'Suitable for small breed dogs over 10 months old that weigh up to 10kg, ROYAL CANINÃ‚Â® Mini Adult is specially formulated with all the nutritional needs of your adult mini dog in mind.<div style="margin: 0cm 0cm 8pt">Because small breed dogs like yours tend to have high energy needs, ROYAL CANINÃ‚Â® Mini Adult is formulated with nutrients that help to meet those energy needs, whilst also helping your dog to maintain a healthy weight.<div style="margin: 0cm 0cm 8pt">Some small breed dogs have fussier appetites than others, that\\\'s why ROYAL CANINÃ‚Â® Mini Adult\\\'s formula contains a selection of exclusive flavourings. It is this enhanced palatability that directly appeals to even the fussiest of dogs.<div style="margin: 0cm 0cm 8pt">ROYAL CANINÃ‚Â® Mini Adult also contains a variety of nutrients that help to support and maintain the health of your dog\\\'s skin and coat.<div style="margin: 0cm 0cm 8pt">To cater to each dog\\\'s individual preferences, ROYAL CANINÃ‚Â® Mini Adult is also available as wet food in delicious gravy.<div style="margin: 0cm 0cm 8pt">If you\\\'re considering mixed feeding, simply follow our feeding guidelines to ensure your dog gets an accurate amount of both wet and dry food for optimal benefit.</div></div></div></div></div>',
  },
  {
    image: '/pet_images/RC_Mini_Ageing_12x85g.jpg',
    id: 'RC_Mini_Ageing_12x85g',
    name: 'Royal Canin Mini Ageing (12x85g)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1.02,
    price: 269,
    category: 'Wet food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: '',
    needs: 'General',
    size: 'small',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'Complete feed for dogs - For adult small breed dogs (weight between 1 and 10 kg) - Over 10 months old.',
    longDescription:
      'Suitable for small breed dogs over 10 months old that weigh up to 10kg, ROYAL CANINÃ‚Â® Mini Adult is specially formulated with all the nutritional needs of your adult mini dog in mind.<div style="margin: 0cm 0cm 8pt">Because small breed dogs like yours tend to have high energy needs, ROYAL CANINÃ‚Â® Mini Adult is formulated with nutrients that help to meet those energy needs, whilst also helping your dog to maintain a healthy weight.<div style="margin: 0cm 0cm 8pt">Some small breed dogs have fussier appetites than others, that\\\'s why ROYAL CANINÃ‚Â® Mini Adult\\\'s formula contains a selection of exclusive flavourings. It is this enhanced palatability that directly appeals to even the fussiest of dogs.<div style="margin: 0cm 0cm 8pt">ROYAL CANINÃ‚Â® Mini Adult also contains a variety of nutrients that help to support and maintain the health of your dog\\\'s skin and coat.<div style="margin: 0cm 0cm 8pt">To cater to each dog\\\'s individual preferences, ROYAL CANINÃ‚Â® Mini Adult is also available as wet food in delicious gravy.<div style="margin: 0cm 0cm 8pt">If you\\\'re considering mixed feeding, simply follow our feeding guidelines to ensure your dog gets an accurate amount of both wet and dry food for optimal benefit.</div></div></div></div></div>',
  },
  {
    image: '/pet_images/RC_Medium_Puppy_10x140g.jpg',
    id: 'RC_Medium_Puppy_10x140g',
    name: 'Royal Canin Medium Puppy (10x140g)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1.4,
    price: 413,
    category: 'Wet food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: '',
    needs: 'General',
    size: 'medium',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'Complete feed for dogs - For adult medium breed dogs (from 11 to 25 kg) - From 12 months to 10 years old.',
    longDescription:
      'Suitable for dogs aged between 12 months and 10 years old that weigh between 11-25 kg, ROYAL CANINÃ‚Â® Medium Adult in Gravy is specially formulated with all the nutritional needs of your medium sized adult dog in mind. ROYAL CANINÃ‚Â® Medium Adult in Gravy supports optimal digestive health, as well as helping to maintain a healthy balance of intestinal flora.Thanks to a specific antioxidant complex and additional prebiotics, ROYAL CANINÃ‚Â® Medium Adult in Gravy helps to support and maintain your dog\'s natural defences.What\'s more, ROYAL CANINÃ‚Â® Medium Adult in Gravy is enriched with EPA and DHA Ã¢â‚¬â€œ these Omega-3 fatty acids contribute to the maintenance of healthy skin and coat condition. To cater to each dog\'s individual preferences, ROYAL CANINÃ‚Â® Medium Adult is also available as dry food, with crunchy and tasty kibble. If you\'re considering mixed feeding, simply follow our feeding guidelines to ensure your dog gets an accurate amount of both wet and dry food for optimal benefit.',
  },
  {
    image: '/pet_images/RC_Medium_Adult_10x140g.jpg',
    id: 'RC_Medium_Adult_10x140g',
    name: 'Royal Canin Medium Adult (10x140g)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1.4,
    price: 413,
    category: 'Wet food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: '',
    needs: 'General',
    size: 'medium',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'Complete feed for dogs - For adult medium breed dogs (from 11 to 25 kg) - From 12 months to 10 years old.',
    longDescription:
      'Suitable for dogs aged between 12 months and 10 years old that weigh between 11-25 kg, ROYAL CANINÃ‚Â® Medium Adult in Gravy is specially formulated with all the nutritional needs of your medium sized adult dog in mind. ROYAL CANINÃ‚Â® Medium Adult in Gravy supports optimal digestive health, as well as helping to maintain a healthy balance of intestinal flora.Thanks to a specific antioxidant complex and additional prebiotics, ROYAL CANINÃ‚Â® Medium Adult in Gravy helps to support and maintain your dog\'s natural defences.What\'s more, ROYAL CANINÃ‚Â® Medium Adult in Gravy is enriched with EPA and DHA Ã¢â‚¬â€œ these Omega-3 fatty acids contribute to the maintenance of healthy skin and coat condition. To cater to each dog\'s individual preferences, ROYAL CANINÃ‚Â® Medium Adult is also available as dry food, with crunchy and tasty kibble. If you\'re considering mixed feeding, simply follow our feeding guidelines to ensure your dog gets an accurate amount of both wet and dry food for optimal benefit.',
  },
  {
    image: '/pet_images/RC_Maxi_Puppy_10x140g.jpg',
    id: 'RC_Maxi_Puppy_10x140g',
    name: 'Royal Canin Maxi Puppy (10x140g)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1.4,
    price: 413,
    category: 'Wet food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: '',
    needs: 'General',
    size: 'large',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'Complete feed for dogs - For adult large breed dogs (from 26 to 44 kg) - From 15 months to 8 years old.',
    longDescription:
      'Suitable for all large dogs between 15 months-8 years old that weigh between 26-44 kg, ROYAL CANINÃ‚Â® Maxi Adult in Gravy is specially formulated with all the nutritional needs of your adult dog in mind.ROYAL CANINÃ‚Â® Maxi Adult in Gravy\'s exclusive formula contains a balanced supply of dietary fibre and high quality protein, selected for its very high digestibility.ROYAL CANINÃ‚Â® Maxi Adult in Gravy contains nutrients that help to support and maintain your dog\'s strong bones and healthy joints throughout its adult years.What\'s more, ROYAL CANINÃ‚Â® Maxi Adult in Gravy is enriched with Omega-3 fatty acids, such as EPA and DHA. These fatty acids help to maintain your dog\'s healthy skin condition.To cater to each dog\'s individual preferences, ROYAL CANINÃ‚Â® Maxi Adult is also available as dry food, with crunchy and tasty kibble. If you\'re considering mixed feeding, simply follow our feeding guidelines to ensure your dog gets an accurate amount of both wet and dry food for optimal benefit.',
  },
  {
    image: '/pet_images/RC_Maxi_Adult_10x140g.jpg',
    id: 'RC_Maxi_Adult_10x140g',
    name: 'Royal Canin Maxi Adult (10x140g)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1.4,
    price: 413,
    category: 'Wet food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: '',
    needs: 'General',
    size: 'large',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'Complete feed for dogs - For adult large breed dogs (from 26 to 44 kg) - From 15 months to 8 years old.',
    longDescription:
      'Suitable for all large dogs between 15 months-8 years old that weigh between 26-44 kg, ROYAL CANINÃ‚Â® Maxi Adult in Gravy is specially formulated with all the nutritional needs of your adult dog in mind.ROYAL CANINÃ‚Â® Maxi Adult in Gravy\'s exclusive formula contains a balanced supply of dietary fibre and high quality protein, selected for its very high digestibility.ROYAL CANINÃ‚Â® Maxi Adult in Gravy contains nutrients that help to support and maintain your dog\'s strong bones and healthy joints throughout its adult years.What\'s more, ROYAL CANINÃ‚Â® Maxi Adult in Gravy is enriched with Omega-3 fatty acids, such as EPA and DHA. These fatty acids help to maintain your dog\'s healthy skin condition.To cater to each dog\'s individual preferences, ROYAL CANINÃ‚Â® Maxi Adult is also available as dry food, with crunchy and tasty kibble. If you\'re considering mixed feeding, simply follow our feeding guidelines to ensure your dog gets an accurate amount of both wet and dry food for optimal benefit.',
  },
  {
    image: '/pet_images/RC_Maxi_Ageing_10x140g.jpg',
    id: 'RC_Maxi_Ageing_10x140g',
    name: 'Royal Canin Maxi Ageing (10x140g)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1.4,
    price: 413,
    category: 'Wet food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: '',
    needs: 'General',
    size: 'large',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'Complete feed for dogs - For adult large breed dogs (from 26 to 44 kg) - From 15 months to 8 years old.',
    longDescription:
      'Suitable for all large dogs between 15 months-8 years old that weigh between 26-44 kg, ROYAL CANINÃ‚Â® Maxi Adult in Gravy is specially formulated with all the nutritional needs of your adult dog in mind.ROYAL CANINÃ‚Â® Maxi Adult in Gravy\'s exclusive formula contains a balanced supply of dietary fibre and high quality protein, selected for its very high digestibility.ROYAL CANINÃ‚Â® Maxi Adult in Gravy contains nutrients that help to support and maintain your dog\'s strong bones and healthy joints throughout its adult years.What\'s more, ROYAL CANINÃ‚Â® Maxi Adult in Gravy is enriched with Omega-3 fatty acids, such as EPA and DHA. These fatty acids help to maintain your dog\'s healthy skin condition.To cater to each dog\'s individual preferences, ROYAL CANINÃ‚Â® Maxi Adult is also available as dry food, with crunchy and tasty kibble. If you\'re considering mixed feeding, simply follow our feeding guidelines to ensure your dog gets an accurate amount of both wet and dry food for optimal benefit.',
  },
  // -- Breed-specific Dry Food --
  {
    image: '/pet_images/RC_Educ_30x50g.jpg',
    id: 'RC_Educ_30x50g',
    name: 'Royal Canin Educ (30x50g)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1.5,
    price: 527,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Puppy',
    breed: '',
    needs: 'General',
    size: 'medium',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'Complete feed for dogs - Milk substitute up to 2 months.',
    longDescription:
      '<div class="std" itemprop="description"><p>Complete feed for dogs - Milk substitute up to 2 months.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Immune System Support - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Digestive Health - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Growth Support - </strong>Nutritional support tailored to your pet\'s needs.</li></ul></div>',
    keyBenefits: [
      'Immune System Support -',
      'Digestive Health -',
      'Growth Support -',
    ],
    feedingGuide: [
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'No',
      breed_size: 'No',
      flavour: 'None',
      lifestage: 'Puppy',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Beagle_Adult_12kg.jpg',
    id: 'RC_Beagle_Adult_12kg',
    name: 'Royal Canin Beagle Adult (12kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 12.0,
    price: 1593,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: 'Beagle',
    needs: 'General',
    size: 'medium',
    sterilised: 'No',
    productSize: '10.1-20kg',
    description:
      'Royal Canin knows what makes your Beagle magnificent is in the details. The Royal Canin Beagle Adult Dog Food is designed exclusively for pure breed Beagles over 12 months.Key Benefits:Ideal Weight - Beagles are know for been more prone to weight...',
    longDescription:
      '<div class="std" itemprop="description"><p>Royal Canin knows what makes your Beagle magnificent is in the details. The <strong>Royal Canin Beagle Adult Dog Food</strong> is designed exclusively for pure breed Beagles over 12 months.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Ideal Weight - </strong>Beagles are know for been more prone to weight gain. This adapted calorie formula helps them to maintain an ideal weight. </li><li><strong>Food Intake Control - </strong>Kibble designed to encouraging them to chew and slowly eat their food.</li><li><strong>Bone &amp; Joint Support - </strong>Enriched with EPA &amp; DHA to help support healthy bones and joints.</li><li><strong>Exclusive kibble design - </strong>The custom kibble is designed for your Beagle’s square muzzle.</li></ul></div>',
    keyBenefits: [
      'Ideal Weight -',
      'Food Intake Control -',
      'Bone & Joint Support -',
      'Exclusive kibble design -',
    ],
    feedingGuide: [
      {
        weight: 'WEIGHT OF DOG',
        idealWeight: 'LOW ACTIVITY',
        overweight: 'MEDIUM ACTIVITY',
      },
      {
        weight: '12 kg',
        idealWeight: '171 g (2+1/8 cups)',
        overweight: '198 g (2+3/8 cups cups)',
      },
      {
        weight: '14 kg',
        idealWeight: '192 g (2+3/8 cups)',
        overweight: '222 g (2+6/8 cups cups)',
      },
      {
        weight: '16 kg',
        idealWeight: '212 g (2+5/8 cups)',
        overweight: '246 g (3 cups)',
      },
      {
        weight: '18 kg',
        idealWeight: '232 g (2+7/8 cups)',
        overweight: '268 g (3+2/8 cups)',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'Beagle',
      breed_size: 'No',
      flavour: 'Chicken',
      lifestage: 'No',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Boxer_Puppy_12kg.jpg',
    id: 'RC_Boxer_Puppy_12kg',
    name: 'Royal Canin Boxer Puppy (12kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 12.0,
    price: 1574,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Puppy',
    breed: 'Boxer',
    needs: 'General',
    size: 'medium',
    sterilised: 'No',
    productSize: '10.1-20kg',
    description:
      'Complete feed for dogs - Specially for Boxer puppies - Up to 15 months old.',
    longDescription:
      '<div class="std" itemprop="description"><p>Complete feed for dogs - Specially for Boxer puppies - Up to 15 months old.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Immune System Support - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Digestive Health - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Growth Support - </strong>Nutritional support tailored to your pet\'s needs.</li></ul></div>',
    keyBenefits: [
      'Immune System Support -',
      'Digestive Health -',
      'Growth Support -',
    ],
    feedingGuide: [
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'Boxer',
      breed_size: 'No',
      flavour: 'None',
      lifestage: 'Puppy',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Boxer_Adult_12kg.jpg',
    id: 'RC_Boxer_Adult_12kg',
    name: 'Royal Canin Boxer Adult (12kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 12.0,
    price: 1593,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: 'Boxer',
    needs: 'General',
    size: 'medium',
    sterilised: 'No',
    productSize: '10.1-20kg',
    description:
      'Complete feed for dogs - Specially for adult and mature Boxers - Over 15 months old.',
    longDescription:
      'Boxer dogs are self-assured, playful, and intelligent. They are also among the most athletic members of the canine species. Because each breed has specific needs, itÃ¢â‚¬â„¢s important that your dogÃ¢â‚¬â„¢s diet helps to maintain its unique lifestyle and optimal health. Suitable for Boxers aged 15 months old and over, ROYAL CANINÃ‚Â® Boxer Adult is specially formulated with all the nutritional needs of your adult dog in mind. The BoxerÃ¢â‚¬â„¢s dynamism is well-renowned Ã¢â‚¬â€œ this breed never holds back in terms of exerting energy once engaged in physical activity. Therefore, great demands can be placed on its body, meaning the Boxer needs a diet adapted to its intense levels of physical activity. ThatÃ¢â‚¬â„¢s why ROYAL CANINÃ‚Â® Boxer Adult contributes to maintaining muscle mass, thanks to an adapted protein content and the inclusion of L-Carnitine. ROYAL CANINÃ‚Â® Boxer Adult also contains specific nutrients, such as taurine, EPA &amp; DHA, to help support healthy cardiac function. Additionally, this formula contains an exclusive complex of antioxidants to help neutralise free radicals and support your dogÃ¢â‚¬â„¢s natural defences. The kibble found in ROYAL CANINÃ‚Â® Boxer Adult is exclusively designed not only to make it easier for your dog to grasp the kibble, but to also encourage sufficient chewing before swallowing.',
    keyBenefits: [
      'Maintains Ideal Weight -',
      'Healthy Skin & Coat -',
      'Digestive Health -',
    ],
    feedingGuide: [
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'Boxer',
      breed_size: 'No',
      flavour: 'None',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Chihuahua_Puppy_1_5kg.jpg',
    id: 'RC_Chihuahua_Puppy_1_5kg',
    name: 'Royal Canin Chihuahua Puppy (1.5kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1.5,
    price: 296,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Puppy',
    breed: 'Chihuahua',
    needs: 'General',
    size: 'small',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'The Royal Canin Chihuahua Junior Puppy Food is designed exclusively for pure breed Chihuahuas up to 8 months.While Chihuahuas might be one of the smallest breeds in the world, these protective little pooches have big nutritional needs.Key...',
    longDescription:
      '<div class="std" itemprop="description"><p>The <strong>Royal Canin Chihuahua Junior Puppy Food</strong> is designed exclusively for pure breed Chihuahuas up to 8 months.</p><p>While Chihuahuas might be one of the smallest breeds in the world, these protective little pooches have big nutritional needs.</p><p><strong>Key Features:</strong></p><ul><li><strong>Exclusive Kibble - Special Miniature Jaw : </strong>Exclusive tailor-made kibble is adapted to your Chihuahua puppy\\\\\\\'s small jaw. </li><li><strong>Stool &amp; Odour Reduction : </strong>Helps reduce stool odour with highly digestible proteins and precise fibre content.</li><li><strong>High Palatability : </strong>With exceptional aromas and flavours to satisfy picky appetites.</li><li><strong>Immune System Support : </strong>Premium formula designed to support your puppy’s natural defences during this essential growth stage.</li></ul></div>',
    keyBenefits: [
      'Exclusive Kibble - Special Miniature Jaw :',
      'Stool & Odour Reduction :',
      'High Palatability :',
      'Immune System Support :',
    ],
    feedingGuide: [
      {
        weight: 'AGE (MONTHS)',
        idealWeight: 'ADULT WEIGHT = 1 KG',
        overweight: 'ADULT WEIGHT = 2 KG',
      },
      {
        weight: '2 m',
        idealWeight: '29 g (3/8 cup)',
        overweight: '49 g (4/8 cup)',
      },
      {
        weight: '3 m',
        idealWeight: '32 g (3/8 cup)',
        overweight: '55 g (5/8 cup)',
      },
      {
        weight: '4 m',
        idealWeight: '33 g (3/8 cup)',
        overweight: '56 g (5/8 cup)',
      },
      {
        weight: '5 m',
        idealWeight: '33 g (3/8 cup)',
        overweight: '56 g (5/8 cup)',
      },
      {
        weight: '6 m',
        idealWeight: '29 g ( 3/8cup)',
        overweight: '48 g (4/8 cup)',
      },
      {
        weight: '7 m',
        idealWeight: '24 g (2/8 cup)',
        overweight: '40 g (4/8 cup)',
      },
      {
        weight: '8 m',
        idealWeight: '24 g (2/8 cup)',
        overweight: '40 g (4/8 cup)',
      },
      {
        weight: '9 m',
        idealWeight: 'Transition to Chihuahua Adult',
        overweight: 'Transition to Chihuahua Adult',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'No',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food, Immune Support',
      breed: 'Chihuahua',
      breed_size: 'No',
      flavour: 'Chicken',
      lifestage: 'Puppy',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Chihuahua_Adult_1_5kg.jpg',
    id: 'RC_Chihuahua_Adult_1_5kg',
    name: 'Royal Canin Chihuahua Adult (1.5kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1.5,
    price: 302,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: 'Chihuahua',
    needs: 'General',
    size: 'small',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'The Royal Canin Chihuahua Adult Dog Food is designed exclusively for pure breed Chihuahuas over 8 months.While Chihuahuas might be one of the smallest breeds in the world, these protective little pooches have big nutritional needs.Key...',
    longDescription:
      '<div class="std" itemprop="description"><p>The <strong>Royal Canin Chihuahua Adult Dog Food</strong> is designed exclusively for pure breed Chihuahuas over 8 months.</p><p>While Chihuahuas might be one of the smallest breeds in the world, these protective little pooches have big nutritional needs.</p><p><strong>Key Features:</strong><span></span></p><ul><li><strong>Exclusive Kibble Design: Special Miniature Jaw : </strong> Tailor-made kibble is adapted to your Chihuahua\\\'s small jaw. </li><li><strong>Dental Health : </strong>Reduce tartar formation thanks to calcium chelators.</li><li><strong>Stool &amp; Odour Reduction :</strong>Helps reduce stool odour with highly digestible proteins and precise fibre content.</li><li><strong>High Palatability :</strong> With exceptional aromas and flavours to satisfy picky appetites.</li></ul></div>',
    keyBenefits: [
      'Exclusive Kibble Design: Special Miniature Jaw :',
      'Dental Health :',
      'Stool & Odour Reduction :',
      'High Palatability :',
    ],
    feedingGuide: [
      {
        weight: 'DOG WEIGHT',
        idealWeight: 'NORMAL ACTIVITY LEVEL',
        overweight: 'HIGER ACTIVITY LEVEL',
      },
      {
        weight: '1 kg',
        idealWeight: '24 g (2/8 cups)',
        overweight: '28 g (3/8 cups)',
      },
      {
        weight: '1.5 kg',
        idealWeight: '33 g (3/8 cups)',
        overweight: '38 g (4/8 cups)',
      },
      {
        weight: '2 kg',
        idealWeight: '41 g (4/8 cups)',
        overweight: '47 g (4/8 cups)',
      },
      {
        weight: '2.5 kg',
        idealWeight: '48 g (4/8 cups)',
        overweight: '56 g (5/8 cups)',
      },
      {
        weight: '3 kg',
        idealWeight: '55 g (5/8 cups)',
        overweight: '64 g (6/8 cups)',
      },
      {
        weight: '3.5 kg',
        idealWeight: '62 g (6/8 cups)',
        overweight: '72 g (7/8 cups)',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'Chihuahua',
      breed_size: 'No',
      flavour: 'Chicken',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Chihuahua_Adult_3kg.jpg',
    id: 'RC_Chihuahua_Adult_3kg',
    name: 'Royal Canin Chihuahua Adult (3kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 3.0,
    price: 539,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: 'Chihuahua',
    needs: 'General',
    size: 'small',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'The Royal Canin Chihuahua Adult Dog Food is designed exclusively for pure breed Chihuahuas over 8 months.While Chihuahuas might be one of the smallest breeds in the world, these protective little pooches have big nutritional needs.Key...',
    longDescription:
      '<div class="std" itemprop="description"><p>The <strong>Royal Canin Chihuahua Adult Dog Food</strong> is designed exclusively for pure breed Chihuahuas over 8 months.</p><p>While Chihuahuas might be one of the smallest breeds in the world, these protective little pooches have big nutritional needs.</p><p><strong>Key Features:</strong><span></span></p><ul><li><strong>Exclusive Kibble Design: Special Miniature Jaw : </strong> Tailor-made kibble is adapted to your Chihuahua\\\'s small jaw. </li><li><strong>Dental Health : </strong>Reduce tartar formation thanks to calcium chelators.</li><li><strong>Stool &amp; Odour Reduction :</strong>Helps reduce stool odour with highly digestible proteins and precise fibre content.</li><li><strong>High Palatability :</strong> With exceptional aromas and flavours to satisfy picky appetites.</li></ul></div>',
    keyBenefits: [
      'Exclusive Kibble Design: Special Miniature Jaw :',
      'Dental Health :',
      'Stool & Odour Reduction :',
      'High Palatability :',
    ],
    feedingGuide: [
      {
        weight: 'DOG WEIGHT',
        idealWeight: 'NORMAL ACTIVITY LEVEL',
        overweight: 'HIGER ACTIVITY LEVEL',
      },
      {
        weight: '1 kg',
        idealWeight: '24 g (2/8 cups)',
        overweight: '28 g (3/8 cups)',
      },
      {
        weight: '1.5 kg',
        idealWeight: '33 g (3/8 cups)',
        overweight: '38 g (4/8 cups)',
      },
      {
        weight: '2 kg',
        idealWeight: '41 g (4/8 cups)',
        overweight: '47 g (4/8 cups)',
      },
      {
        weight: '2.5 kg',
        idealWeight: '48 g (4/8 cups)',
        overweight: '56 g (5/8 cups)',
      },
      {
        weight: '3 kg',
        idealWeight: '55 g (5/8 cups)',
        overweight: '64 g (6/8 cups)',
      },
      {
        weight: '3.5 kg',
        idealWeight: '62 g (6/8 cups)',
        overweight: '72 g (7/8 cups)',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'Chihuahua',
      breed_size: 'No',
      flavour: 'Chicken',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Cocker_Adult_3kg.jpg',
    id: 'RC_Cocker_Puppy_3kg',
    name: 'Royal Canin Cocker Puppy (3kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 3.0,
    price: 530,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Puppy',
    breed: 'Cocker Spaniel',
    needs: 'General',
    size: 'medium',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'Royal Canin Cocker Spaniel Junior Puppy Food is designed exclusively for pure breed Cocker Spaniels up to 12 months.Royal Canin Cocker Puppy\'s formula also contains a variety of nutrients that help to support your puppy\'s skin\'s ‘barrier\' roll and...',
    longDescription:
      '<div class="std" itemprop="description"><p><strong>Royal Canin Cocker Spaniel Junior Puppy Food</strong> is designed exclusively for pure breed Cocker Spaniels up to 12 months.</p><p><span>Royal Canin Cocker Puppy\\\\\\\'s formula also contains a variety of nutrients that help to support your puppy\\\\\\\'s skin\\\\\\\'s ‘barrier\\\\\\\' roll and maintain the health of your puppy\\\\\\\'s skin,<span>also helps to nourish your puppy\\\\\\\'s coat.</span></span></p><p><strong>Key Benefits:</strong></p><ul><li><strong>Healthy Skin &amp; Coat : </strong>Reinforces the skin barrier with essential nutrients to support skin and coat health while maintaining a beautiful coat.</li><li><strong>Immune System Support : </strong>Premium formula designed to support your puppy’s natural defences during this essential growth stage.</li><li><strong>Digestive Healthy : </strong>Supports digestion and healthy balance of intestinal flora, contributing to good stool quality.</li><li><strong>Exclusive Kibble: Dental Health : </strong>Calcium chelators aid in reducing tartar formation.&amp;nbsp</li></ul></div>',
    keyBenefits: [
      'Healthy Skin & Coat :',
      'Immune System Support :',
      'Digestive Healthy :',
      'Exclusive Kibble: Dental Health :',
    ],
    feedingGuide: [
      {
        weight: 'AGE (MONTHS)',
        idealWeight: 'ADULT WEIGHT = 10 KG',
        overweight: 'ADULT WEIGHT = 12 KG',
      },
      {
        weight: '2 m',
        idealWeight: '150 g (1+6/8 cups)',
        overweight: '171 g (1+7/8 cups)',
      },
      {
        weight: '3 m',
        idealWeight: '177 g (2 cups)',
        overweight: '201 g (2+2/8 cups)',
      },
      {
        weight: '4 m',
        idealWeight: '188 g (2+1/8 cups)',
        overweight: '214 g (2+3/8 cups)',
      },
      {
        weight: '6 m',
        idealWeight: '190 g (2+1/8 cups)',
        overweight: '217 g (2+4/8 cups)',
      },
      {
        weight: '7 m',
        idealWeight: '172 g (1+7/8 cups)',
        overweight: '197 g (2+2/8 cups)',
      },
      {
        weight: '8 m',
        idealWeight: '154 g (1+6/8 cups)',
        overweight: '176 g (2 cups)',
      },
      {
        weight: '10 m',
        idealWeight: '136 g (1+4/8 cups)',
        overweight: '156 g (1+6/8 cups)',
      },
      {
        weight: '11 m',
        idealWeight: '135 g (1+4/8 cups)',
        overweight: '154 g (1+6/8 cups)',
      },
      {
        weight: '12 m',
        idealWeight: 'Transition to Cocker Adult',
        overweight: 'Transition to Cocker Adult',
      },
      {
        weight: '13 m',
        idealWeight: 'Transition to Cocker Adult',
        overweight: 'Transition to Cocker Adult',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'No',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'No',
      breed: 'Cocker Spaniel',
      breed_size: 'No',
      flavour: 'Chicken',
      lifestage: 'Puppy',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Cocker_Adult_12kg.jpg',
    id: 'RC_Cocker_Adult_12kg',
    name: 'Royal Canin Cocker Adult (12kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 12.0,
    price: 1593,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: 'Cocker Spaniel',
    needs: 'General',
    size: 'medium',
    sterilised: 'No',
    productSize: '10.1-20kg',
    description:
      'Complete feed for dogs - Specially for adult and mature, English or American Cocker Spaniels - Over 12 months old.',
    longDescription:
      '<div class="std" itemprop="description"><p>Complete feed for dogs - Specially for adult and mature, English or American Cocker Spaniels - Over 12 months old.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Maintains Ideal Weight - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Healthy Skin & Coat - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Digestive Health - </strong>Nutritional support tailored to your pet\'s needs.</li></ul></div>',
    keyBenefits: [
      'Maintains Ideal Weight -',
      'Healthy Skin & Coat -',
      'Digestive Health -',
    ],
    feedingGuide: [
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'Cocker Spaniel',
      breed_size: 'No',
      flavour: 'None',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Dachshund_Puppy_1_5kg.jpg',
    id: 'RC_Dachshund_Puppy_1_5kg',
    name: 'Royal Canin Dachshund Puppy (1.5kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1.5,
    price: 296,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Puppy',
    breed: 'Dachshund',
    needs: 'General',
    size: 'small',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'The Royal Canin Dachshund Junior Puppy Food is designed exclusively for pure breed Dachshunds up to 10 months old.The formula contains high quality protein, this protein has been specifically selected due to its high digestibility. Key...',
    longDescription:
      '<div class="std" itemprop="description"><p>The <strong>Royal Canin Dachshund Junior Puppy Food</strong> is designed exclusively for pure breed Dachshunds up to 10 months old.</p><p><span>The formula contains high quality protein, this protein has been specifically selected due to its high digestibility. </span></p><p><strong>Key Features:</strong></p><ul type="disc"><li><strong>Exclusive Kibble Design : </strong>Exclusive tailor-made kibble is adapted to your Dachshund puppy\\\\\\\'s small jaw.</li><li><strong>Joint &amp; Bone Support :</strong> Maintains bone &amp; joint health with calcium and phosphorus to help support tiny limbs and a long backbone.</li><li><strong>Immune System Support : </strong>Premium formula designed to support your puppy’s natural defences during this essential growth stage.</li><li><strong>Digestive Health : </strong>Supports digestion and healthy balance of intestinal flora, contributing to good stool quality.</li><li><strong>Dental Health : </strong>Reduces tartar formation thanks to calcium chelators.</li></ul></div>',
    keyBenefits: [
      'Exclusive Kibble Design :',
      'Joint & Bone Support :',
      'Immune System Support :',
      'Digestive Health :',
      'Dental Health :',
    ],
    feedingGuide: [
      {
        weight: 'AGE (MONTHS)',
        idealWeight: 'ADULT WEIGHT = 3 KG',
        overweight: 'ADULT WEIGHT = 6 KG',
      },
      {
        weight: '2 m',
        idealWeight: '67 g (6/8 cup)',
        overweight: '108 g (1+2/8 cups)',
      },
      {
        weight: '3 m',
        idealWeight: '75 g (7/8 cup)',
        overweight: '125 g (1+4/8 cups)',
      },
      {
        weight: '4 m',
        idealWeight: '79 g (7/8 cup)',
        overweight: '131 g (1+4/8 cups)',
      },
      {
        weight: '5 m',
        idealWeight: '79 g (7/8 cup)',
        overweight: '132 g (1+4/8 cups)',
      },
      {
        weight: '6 m',
        idealWeight: '71 g (7/8 cup)',
        overweight: '131 g (1+4/8 cups)',
      },
      {
        weight: '7 m',
        idealWeight: '64 g (6/8 cup)',
        overweight: '118 g (1+3/8 cups)',
      },
      {
        weight: '8 m',
        idealWeight: '57 g (5/8 cup)',
        overweight: '106 g (1+2/8 cups)',
      },
      {
        weight: '9 m',
        idealWeight: '56 g (5/8 cup)',
        overweight: '95 g (1+1/8 cups)',
      },
      {
        weight: '10 m',
        idealWeight: '56 g (5/8 cup)',
        overweight: '95 g (1+1/8 cups)',
      },
      {
        weight: '11 m',
        idealWeight: 'Transition to Dachshund Adult',
        overweight: 'Transition to Dachshund Adult',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'No',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'Dachshund',
      breed_size: 'No',
      flavour: 'Chicken',
      lifestage: 'Puppy',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Dachshund_Adult_1_5kg.jpg',
    id: 'RC_Dachshund_Adult_1_5kg',
    name: 'Royal Canin Dachshund Adult (1.5kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1.5,
    price: 302,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: 'Dachshund',
    needs: 'General',
    size: 'small',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'The Royal Canin Dachshund Adult Dog Food is designed exclusively for pure breed Dachshunds over 10 months. Key Features:Exclusive Kibble Design - Exclusive tailor-made kibble is adapted to your Dachshund\'s small jaw.Joint & Bone Support - Maintains...',
    longDescription:
      '<div class="std" itemprop="description"><p>The <strong>Royal Canin Dachshund Adult Dog Food</strong> is designed exclusively for pure breed Dachshunds over 10 months.</p><p><strong>Key Features:</strong></p><ul><li><strong><span>Exclusive Kibble Design - </span></strong><span>Exclusive tailor-made kibble is adapted to your Dachshund\\\'s small jaw.</span></li><li><strong>Joint &amp; Bone Support -</strong> Maintains bone &amp; joint health with calcium and phosphorus to help support tiny limbs and a long backbone.</li><li><strong>Muscle Tone - </strong>Supports a Dachshund’s muscle tone with precise protein content and L-carnitine.</li><li><strong>Stool &amp; Odour Reduction - </strong>Helps reduce stool volume and stool odour with highly digestible proteins and precise fibre content.</li><li><strong>Dental Health - </strong>Reduces tartar formation <span> thanks to calcium chelators.</span></li></ul></div>',
    keyBenefits: [
      'Exclusive Kibble Design -',
      'Joint & Bone Support -',
      'Muscle Tone -',
      'Stool & Odour Reduction -',
      'Dental Health -',
    ],
    feedingGuide: [
      {
        weight: 'WEIGHT OF DOG',
        idealWeight: 'LOW ACTIVITY',
        overweight: 'MEDIUM ACTIVITY',
      },
      {
        weight: '2 kg',
        idealWeight: '43 g (4/8 cups)',
        overweight: '50 g (5/8 cups)',
      },
      {
        weight: '5 kg',
        idealWeight: '85 g (1+1/8 cups)',
        overweight: '99 g (1+2/8 cups)',
      },
      {
        weight: '8 kg',
        idealWeight: '121 g (1+5/8 cups)',
        overweight: '140 g (1+7/8 cups)',
      },
      {
        weight: '10 kg',
        idealWeight: '143 g (1+7/8 cups)',
        overweight: '166 g (2+1/8 cups)',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'Dachshund',
      breed_size: 'No',
      flavour: 'Chicken',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Dachshund_Adult_7_5kg.jpg',
    id: 'RC_Dachshund_Adult_7_5kg',
    name: 'Royal Canin Dachshund Adult (7.5kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 7.5,
    price: 1107,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: 'Dachshund',
    needs: 'General',
    size: 'small',
    sterilised: 'No',
    productSize: '5.1-10kg',
    description:
      'The Royal Canin Dachshund Adult Dog Food is designed exclusively for pure breed Dachshunds over 10 months. Key Features:Exclusive Kibble Design - Exclusive tailor-made kibble is adapted to your Dachshund\'s small jaw.Joint & Bone Support - Maintains...',
    longDescription:
      '<div class="std" itemprop="description"><p>The <strong>Royal Canin Dachshund Adult Dog Food</strong> is designed exclusively for pure breed Dachshunds over 10 months.</p><p><strong>Key Features:</strong></p><ul><li><strong><span>Exclusive Kibble Design - </span></strong><span>Exclusive tailor-made kibble is adapted to your Dachshund\\\'s small jaw.</span></li><li><strong>Joint &amp; Bone Support -</strong> Maintains bone &amp; joint health with calcium and phosphorus to help support tiny limbs and a long backbone.</li><li><strong>Muscle Tone - </strong>Supports a Dachshund’s muscle tone with precise protein content and L-carnitine.</li><li><strong>Stool &amp; Odour Reduction - </strong>Helps reduce stool volume and stool odour with highly digestible proteins and precise fibre content.</li><li><strong>Dental Health - </strong>Reduces tartar formation <span> thanks to calcium chelators.</span></li></ul></div>',
    keyBenefits: [
      'Exclusive Kibble Design -',
      'Joint & Bone Support -',
      'Muscle Tone -',
      'Stool & Odour Reduction -',
      'Dental Health -',
    ],
    feedingGuide: [
      {
        weight: 'WEIGHT OF DOG',
        idealWeight: 'LOW ACTIVITY',
        overweight: 'MEDIUM ACTIVITY',
      },
      {
        weight: '2 kg',
        idealWeight: '43 g (4/8 cups)',
        overweight: '50 g (5/8 cups)',
      },
      {
        weight: '5 kg',
        idealWeight: '85 g (1+1/8 cups)',
        overweight: '99 g (1+2/8 cups)',
      },
      {
        weight: '8 kg',
        idealWeight: '121 g (1+5/8 cups)',
        overweight: '140 g (1+7/8 cups)',
      },
      {
        weight: '10 kg',
        idealWeight: '143 g (1+7/8 cups)',
        overweight: '166 g (2+1/8 cups)',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'Dachshund',
      breed_size: 'No',
      flavour: 'Chicken',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_French_Bulldog_Adult_3kg.jpg',
    id: 'RC_Bulldog_Puppy_3kg',
    name: 'Royal Canin English Bulldog Puppy (3kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 3.0,
    price: 530,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Puppy',
    breed: 'Bulldog',
    needs: 'General',
    size: 'medium',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'The Royal Canin English Bulldog Junior Puppy Food is designed exclusively for pure breed English Bulldogs over 12 months. Key Features:Immune System Support - Premium formula designed to support your puppy’s natural defences during this essential...',
    longDescription:
      '<div class="std" itemprop="description"><p>The <strong>Royal Canin English Bulldog Junior Puppy Food</strong> is designed exclusively for pure breed English Bulldogs over 12 months.</p><p><strong>Key Features:</strong></p><ul><li><strong>Immune System Support - </strong>Premium formula designed to support your puppy’s natural defences during this essential growth stage.</li><li><strong>Digestive Health - </strong>Supports digestion and healthy balance of intestinal flora, contributing to good stool quality.</li><li><strong>Joint &amp; Bone Health -</strong> Maintains bone &amp; joint health with calcium and phosphorus, while also maintaining an ideal weight.</li><li><strong>Exclusive kibble: Special Brachycephalic Jaw - </strong> Tailor-made kibble design helps Bulldog puppies to easily pick up and chew their food</li></ul></div>',
    keyBenefits: [
      'Immune System Support -',
      'Digestive Health -',
      'Joint & Bone Health -',
      'Exclusive kibble: Special Brachycephalic Jaw -',
    ],
    feedingGuide: [
      {
        weight: 'AGE (MONTHS)',
        idealWeight: 'ADULT WEIGHT = 18 KG',
        overweight: 'ADULT WEIGHT = 24 KG',
      },
      {
        weight: '2 m',
        idealWeight: '231 g (2+4/8 cups)',
        overweight: '257 g (2+6/8 cups)',
      },
      {
        weight: '3 m',
        idealWeight: '276 g (3 cups)',
        overweight: '315 g (3+3/8 cups)',
      },
      {
        weight: '4 m',
        idealWeight: '297 g (3+1/8 cups)',
        overweight: '341 g (3+5/8 cups)',
      },
      {
        weight: '5 m',
        idealWeight: '304 g (3+2/8 cups)',
        overweight: '361 g (3+7/8 cups)',
      },
      {
        weight: '6 m',
        idealWeight: '304 g (3+2/8 cups)',
        overweight: '378 g (4 cups)',
      },
      {
        weight: '7 m',
        idealWeight: '283 g (3 cups)',
        overweight: '375 g (4 cups)',
      },
      {
        weight: '9 m',
        idealWeight: '240 g (2+5/8 cups)',
        overweight: '305 g (3+2/8 cups)',
      },
      {
        weight: '11 m',
        idealWeight: '216 g (2+2/8 cups)',
        overweight: '270 g (2+7/8 cups)',
      },
      {
        weight: '12 m',
        idealWeight: '215 g (2+2/8 cups)',
        overweight: '269 g (2+7/8 cups)',
      },
      {
        weight: '13 m',
        idealWeight: 'Transition to Bulldog Adult',
        overweight: 'Transition to Bulldog Adult',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'No',
      breed: 'English Bulldog',
      breed_size: 'No',
      flavour: 'Chicken',
      lifestage: 'No',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_English_Bulldog_Puppy_12kg.jpg',
    id: 'RC_English_Bulldog_Puppy_12kg',
    name: 'Royal Canin English Bulldog Puppy (12kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 12.0,
    price: 1574,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Puppy',
    breed: 'English Bulldog',
    needs: 'General',
    size: 'medium',
    sterilised: 'No',
    productSize: '10.1-20kg',
    description:
      'The Royal Canin English Bulldog Junior Puppy Food is designed exclusively for pure breed English Bulldogs over 12 months. Key Features:Immune System Support - Premium formula designed to support your puppy’s natural defences during this essential...',
    longDescription:
      '<div class="std" itemprop="description"><p>The <strong>Royal Canin English Bulldog Junior Puppy Food</strong> is designed exclusively for pure breed English Bulldogs over 12 months.</p><p><strong>Key Features:</strong></p><ul><li><strong>Immune System Support - </strong>Premium formula designed to support your puppy’s natural defences during this essential growth stage.</li><li><strong>Digestive Health - </strong>Supports digestion and healthy balance of intestinal flora, contributing to good stool quality.</li><li><strong>Joint &amp; Bone Health -</strong> Maintains bone &amp; joint health with calcium and phosphorus, while also maintaining an ideal weight.</li><li><strong>Exclusive kibble: Special Brachycephalic Jaw - </strong> Tailor-made kibble design helps Bulldog puppies to easily pick up and chew their food</li></ul></div>',
    keyBenefits: [
      'Immune System Support -',
      'Digestive Health -',
      'Joint & Bone Health -',
      'Exclusive kibble: Special Brachycephalic Jaw -',
    ],
    feedingGuide: [
      {
        weight: 'AGE (MONTHS)',
        idealWeight: 'ADULT WEIGHT = 18 KG',
        overweight: 'ADULT WEIGHT = 24 KG',
      },
      {
        weight: '2 m',
        idealWeight: '231 g (2+4/8 cups)',
        overweight: '257 g (2+6/8 cups)',
      },
      {
        weight: '3 m',
        idealWeight: '276 g (3 cups)',
        overweight: '315 g (3+3/8 cups)',
      },
      {
        weight: '4 m',
        idealWeight: '297 g (3+1/8 cups)',
        overweight: '341 g (3+5/8 cups)',
      },
      {
        weight: '5 m',
        idealWeight: '304 g (3+2/8 cups)',
        overweight: '361 g (3+7/8 cups)',
      },
      {
        weight: '6 m',
        idealWeight: '304 g (3+2/8 cups)',
        overweight: '378 g (4 cups)',
      },
      {
        weight: '7 m',
        idealWeight: '283 g (3 cups)',
        overweight: '375 g (4 cups)',
      },
      {
        weight: '9 m',
        idealWeight: '240 g (2+5/8 cups)',
        overweight: '305 g (3+2/8 cups)',
      },
      {
        weight: '11 m',
        idealWeight: '216 g (2+2/8 cups)',
        overweight: '270 g (2+7/8 cups)',
      },
      {
        weight: '12 m',
        idealWeight: '215 g (2+2/8 cups)',
        overweight: '269 g (2+7/8 cups)',
      },
      {
        weight: '13 m',
        idealWeight: 'Transition to Bulldog Adult',
        overweight: 'Transition to Bulldog Adult',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'No',
      breed: 'English Bulldog',
      breed_size: 'No',
      flavour: 'Chicken',
      lifestage: 'No',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_English_Bulldog_Adult_12kg.jpg',
    id: 'RC_English_Bulldog_Adult_12kg',
    name: 'Royal Canin English Bulldog Adult (12kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 12.0,
    price: 1593,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: 'English Bulldog',
    needs: 'General',
    size: 'medium',
    sterilised: 'No',
    productSize: '10.1-20kg',
    description:
      'The Royal Canin English Bulldog Adult Dog Food is designed exclusively for pure breed English Bulldogs over 12 months. Key Features:Exclusive Kibble Design- Tailor-made kibble helps Bulldogs easily pick up and chew their food.Stool & Odour Reduction...',
    longDescription:
      '<div class="std" itemprop="description"><p>The <strong>Royal Canin English Bulldog Adult Dog Food</strong> is designed exclusively for pure breed English Bulldogs over 12 months.</p><p><strong>Key Features:</strong></p><ul><li><strong><span>Exclusive Kibble Design- </span></strong>Tailor-made kibble helps Bulldogs easily pick up and chew their food.</li><li><strong><span>Stool &amp; Odour Reduction - </span></strong><span></span>Helps reduce gas and stool odour with highly digestible proteins, precise fibre, and high-quality carbohydrate sources.</li><li><strong>Reinforces Skin Barrier -</strong> Contains essential nutrients to support healthy skin and wrinkles.</li><li><strong><span>Joint &amp; Bone Support -</span></strong><span></span><span></span>Maintains bone &amp; joint health with EPA and DHA to support your Bulldog\\\'s short, stocky body.</li></ul></div>',
    keyBenefits: [
      'Exclusive Kibble Design-',
      'Stool & Odour Reduction -',
      'Reinforces Skin Barrier -',
      'Joint & Bone Support -',
    ],
    feedingGuide: [
      {
        weight: 'WEIGHT OF DOG',
        idealWeight: 'LOW ACTIVITY',
        overweight: 'MEDIUM ACTIVITY',
      },
      {
        weight: '18 kg',
        idealWeight: '223 g (2+7/8 cups)',
        overweight: '258 g (3+3/8 cups)',
      },
      {
        weight: '20 k',
        idealWeight: '242 g (3+1/8 cups)',
        overweight: '280 g (3+5/8 cups)',
      },
      {
        weight: '22 kg',
        idealWeight: '259 g (3+3/8 cups)',
        overweight: '300 g (3+7/8 cups)',
      },
      {
        weight: '24 kg',
        idealWeight: '277 g (3+5/8cups)',
        overweight: '321 g (4+1/8 cups)',
      },
      {
        weight: '26 kg',
        idealWeight: '294 g (3+7/8cups)',
        overweight: '340 g (4+3/8 cups)',
      },
      {
        weight: '28 kg',
        idealWeight: '311 g (4 cups)',
        overweight: '360 g (4+6/8 cups)',
      },
      {
        weight: '30 kg',
        idealWeight: '327 g (4+2/8 cups)',
        overweight: '379 g (4+7/8 cups)',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'English Bulldog',
      breed_size: 'No',
      flavour: 'Chicken',
      lifestage: 'No',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_French_Bulldog_Adult_3kg.jpg',
    id: 'RC_French_Bulldog_Puppy_3kg',
    name: 'Royal Canin French Bulldog Puppy (3kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 3.0,
    price: 530,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Puppy',
    breed: 'French Bulldog',
    needs: 'General',
    size: 'small',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'Royal Canin French Bulldog Puppy Dog Food specially for French Bulldog puppies up to 12 months old.Royal Canin French Bulldog Puppy contains nutrients with very high quality proteins, specially selected for their high digestibility. It also contains...',
    longDescription:
      '<div class="std" itemprop="description"><p><strong>Royal Canin French Bulldog Puppy Dog Food</strong> s<span>pecially for French Bulldog puppies up to 12 months old.</span></p><p><span>Royal Canin French Bulldog Puppy contains nutrients with very high quality proteins, specially selected for their high digestibility. It also contains highly beneficial prebiotics. The combination of these nutrients helps to support good digestive health.</span></p><p><strong>Key Features:</strong></p><ul><li><span><strong>Immune system support :</strong> H</span>elps support your puppy’s natural defences thanks particularly to a complex of antioxidants including vitamin E.</li><li><strong>Healthy skin : </strong>This formula helps support the skin’s “barrier” role and maintain skin health.</li><li><span><strong>Exclusive kibble:</strong> special brachycephalic jaw : </span>A kibble exclusively designed to make it easier for the French Bulldog puppy to pick up and to encourage him to chew.</li><li><span><strong>Digestive health :</strong></span><span>Combination of nutrients with high quality protein <span>and prebiotics <span>to support digestive health and balance of intestinal flora, which contributes to good stool quality. </span></span></span></li></ul></div>',
    keyBenefits: [
      'Immune system support :',
      'Healthy skin :',
      'Exclusive kibble:',
      'Digestive health :',
    ],
    feedingGuide: [
      {
        weight: 'AGE (MONTHS)',
        idealWeight: 'ADULT WEIGHT = 8 KG',
        overweight: 'ADULT WEIGHT = 10 KG',
      },
      {
        weight: '2 m',
        idealWeight: '122 g (1+2/8 cups)',
        overweight: '144 g (1+4/8 cups)',
      },
      {
        weight: '3 m',
        idealWeight: '143 g (1+4/8 cups)',
        overweight: '169 g (1+6/8 cups)',
      },
      {
        weight: '4 m',
        idealWeight: '152 g (1+4/8 cups)',
        overweight: '180 g (1+7/8 cups)',
      },
      {
        weight: '5 m',
        idealWeight: '154 g (1+5/8 cups)',
        overweight: '183 g (1+7/8 cups)',
      },
      {
        weight: '6 m',
        idealWeight: '153 g (1+4/8 cups)',
        overweight: '182 g (1+7/8 cups)',
      },
      {
        weight: '7 m',
        idealWeight: '138 g (1+3/8 cups)',
        overweight: '165 g (1+5/8 cups)',
      },
      {
        weight: '9 m',
        idealWeight: '110 g (1+1/8 cups)',
        overweight: '131 g (1+3/8 cups)',
      },
      {
        weight: '11 m',
        idealWeight: 'Transition to French Bulldog Adult',
        overweight: '129 g (1+2/8 cups)',
      },
      {
        weight: '12 m',
        idealWeight: 'Transition to French Bulldog Adult',
        overweight: 'Transition to French Bulldog Adult',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'No',
      breed: 'French Bulldog',
      breed_size: 'No',
      flavour: 'Chicken',
      lifestage: 'Puppy',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_French_Bulldog_Adult_3kg.jpg',
    id: 'RC_French_Bulldog_Adult_3kg',
    name: 'Royal Canin French Bulldog Adult (3kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 3.0,
    price: 539,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: 'French Bulldog',
    needs: 'General',
    size: 'small',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'Royal Canin French Bulldog Adult Dog Food is specially for adult and mature French Bulldogs - Over 12 months old. This exclusive breed-specific diet is uniquely formulated for your French Bulldog, with the specific nutrients to help them thrive.Key...',
    longDescription:
      '<div class="std" itemprop="description"><p><strong>Royal Canin French Bulldog Adult Dog Food</strong> is s<span>pecially for adult and mature French Bulldogs - Over 12 months old.</span></p><p>This exclusive breed-specific diet is uniquely formulated for your French Bulldog, with the specific nutrients to help them thrive.</p><p><strong>Key Features:</strong></p><ul><li><strong>Exclusive kibble - </strong> Tailor-made kibble design helps French Bulldogs easily pick up and chew their food.</li><li><strong>Muscle Tone - </strong>Supports muscle tone with precise protein content and L-carnitine.</li><li><strong>Reinforces Skin Barrier -</strong> Contains essential nutrients to support healthy skin and wrinkles.</li><li><strong>Stool &amp; Odour Reduction - </strong>Helps reduce stool volume and stool odour with highly digestible proteins and precise fibre content.</li></ul></div>',
    keyBenefits: [
      'Exclusive kibble -',
      'Muscle Tone -',
      'Reinforces Skin Barrier -',
      'Stool & Odour Reduction -',
    ],
    feedingGuide: [
      {
        weight: 'WEIGHT OF DOG',
        idealWeight: 'LOW ACTIVITY',
        overweight: 'MEDIUM ACTIVITY',
      },
      {
        weight: '8 kg',
        idealWeight: '112 g ( cups)',
        overweight: '130 g (1+3/8 cups)',
      },
      {
        weight: '9 kg',
        idealWeight: '122 g ( cups)',
        overweight: '142 g (1+4/8 cups)',
      },
      {
        weight: '10 kg',
        idealWeight: '132 g ( cups)',
        overweight: '153 g (1+5/8 cups)',
      },
      {
        weight: '11 kg',
        idealWeight: '142 g ( cups)',
        overweight: '165 g (1+6/8 cups)',
      },
      {
        weight: '12 kg',
        idealWeight: '152 g ( cups)',
        overweight: '176 g (1+6/8 cups)',
      },
      {
        weight: '14 kg',
        idealWeight: '170 g ( cups)',
        overweight: '197 g (2 cups)',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'French Bulldog',
      breed_size: 'No',
      flavour: 'Chicken',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_French_Bulldog_Adult_9kg.jpg',
    id: 'RC_French_Bulldog_Adult_9kg',
    name: 'Royal Canin French Bulldog Adult (9kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 9.0,
    price: 1404,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: 'French Bulldog',
    needs: 'General',
    size: 'small',
    sterilised: 'No',
    productSize: '5.1-10kg',
    description:
      'Royal Canin French Bulldog Adult Dog Food is specially for adult and mature French Bulldogs - Over 12 months old. This exclusive breed-specific diet is uniquely formulated for your French Bulldog, with the specific nutrients to help them thrive.Key...',
    longDescription:
      '<div class="std" itemprop="description"><p><strong>Royal Canin French Bulldog Adult Dog Food</strong> is s<span>pecially for adult and mature French Bulldogs - Over 12 months old.</span></p><p>This exclusive breed-specific diet is uniquely formulated for your French Bulldog, with the specific nutrients to help them thrive.</p><p><strong>Key Features:</strong></p><ul><li><strong>Exclusive kibble - </strong> Tailor-made kibble design helps French Bulldogs easily pick up and chew their food.</li><li><strong>Muscle Tone - </strong>Supports muscle tone with precise protein content and L-carnitine.</li><li><strong>Reinforces Skin Barrier -</strong> Contains essential nutrients to support healthy skin and wrinkles.</li><li><strong>Stool &amp; Odour Reduction - </strong>Helps reduce stool volume and stool odour with highly digestible proteins and precise fibre content.</li></ul></div>',
    keyBenefits: [
      'Exclusive kibble -',
      'Muscle Tone -',
      'Reinforces Skin Barrier -',
      'Stool & Odour Reduction -',
    ],
    feedingGuide: [
      {
        weight: 'WEIGHT OF DOG',
        idealWeight: 'LOW ACTIVITY',
        overweight: 'MEDIUM ACTIVITY',
      },
      {
        weight: '8 kg',
        idealWeight: '112 g ( cups)',
        overweight: '130 g (1+3/8 cups)',
      },
      {
        weight: '9 kg',
        idealWeight: '122 g ( cups)',
        overweight: '142 g (1+4/8 cups)',
      },
      {
        weight: '10 kg',
        idealWeight: '132 g ( cups)',
        overweight: '153 g (1+5/8 cups)',
      },
      {
        weight: '11 kg',
        idealWeight: '142 g ( cups)',
        overweight: '165 g (1+6/8 cups)',
      },
      {
        weight: '12 kg',
        idealWeight: '152 g ( cups)',
        overweight: '176 g (1+6/8 cups)',
      },
      {
        weight: '14 kg',
        idealWeight: '170 g ( cups)',
        overweight: '197 g (2 cups)',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'French Bulldog',
      breed_size: 'No',
      flavour: 'Chicken',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_German_Shepherd_Puppy_12kg.jpg',
    id: 'RC_German_Shepherd_Puppy_12kg',
    name: 'Royal Canin German Shepherd Puppy (12kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 12.0,
    price: 1574,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Puppy',
    breed: 'German Shepherd',
    needs: 'General',
    size: 'large',
    sterilised: 'No',
    productSize: '10.1-20kg',
    description:
      'The Royal Canin German Shepherd Junior Puppy Food specially for German Shepherd puppies up to 15 months old.Royal Canin German Shepherd Junior is rich in antioxidants and prebiotics to support your puppys natural immune defences, and is made from...',
    longDescription:
      '<div class="std" itemprop="description"><p>The<strong> Royal Canin German Shepherd Junior Puppy Food</strong> s<span>pecially for German Shepherd puppies up to 15 months old.</span></p><p><span>Royal Canin German Shepherd Junior is rich in antioxidants and prebiotics to support your puppys natural immune defences, and is made from highly digestible ingredients to help prevent digestive problems, flatulence and bad stool odour.</span></p><p><strong>Key Benefits: </strong></p><ul><li><strong>Immune System Support : </strong>Premium formula designed to support your puppy’s natural defences during this essential growth stage.</li><li><strong>Digestive Healthy : </strong>Supports digestion and healthy balance of intestinal flora, contributing to good stool quality.</li><li><strong>Bone &amp; Joint Support :</strong> Contains calcium and phosphorus that support bone &amp; joint health, while also maintaining an ideal weight. </li><li><strong><span>Exclusive Kibble Design: </span></strong><span>Exclusive tailor-made kibble is adapted to your German Shepherd puppy. </span></li></ul></div>',
    keyBenefits: [
      'Immune System Support :',
      'Digestive Healthy :',
      'Bone & Joint Support :',
      'Exclusive Kibble Design:',
    ],
    feedingGuide: [
      {
        weight: 'AGE (MONTHS)',
        idealWeight: 'ADULT WEIGHT = 26 KG',
        overweight: 'ADULT WEIGHT = 35 KG',
      },
      {
        weight: '2 m',
        idealWeight: '266 g (2+7/8 cups)',
        overweight: '287 g (3+1/8 cups)',
      },
      {
        weight: '3 m',
        idealWeight: '328 g (3+5/8 cups)',
        overweight: '367 g (4 cups)',
      },
      {
        weight: '4 m',
        idealWeight: '356 g (3+5/8 cups)',
        overweight: '402 g (4+3/8 cups)',
      },
      {
        weight: '6 m',
        idealWeight: '407 g (4+4/8 cups)',
        overweight: '507 g (5+5/8 cups)',
      },
      {
        weight: '8 m',
        idealWeight: '406 g (4+4/8 cups)',
        overweight: '511 g (5+5/8 cups)',
      },
      {
        weight: '10 m',
        idealWeight: '371 g (4+1/8 cups)',
        overweight: '467 g (5+1/8 cups)',
      },
      {
        weight: '12 m',
        idealWeight: '335 g (3+5/8 cups)',
        overweight: '422 g (4+5/8 cups)',
      },
      {
        weight: '14 m',
        idealWeight: '333 g (3+5/8 cups)',
        overweight: '416 g (4+4/8 cups)',
      },
      {
        weight: '16 m',
        idealWeight: 'Transition to German Shepherd Adult',
        overweight: 'Transition to German Shepherd Adult',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'No',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'No',
      breed: 'German Shepherd',
      breed_size: 'No',
      flavour: 'Chicken',
      lifestage: 'Puppy',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_German_Shepherd_Adult_11kg.jpg',
    id: 'RC_German_Shepherd_Adult_11kg',
    name: 'Royal Canin German Shepherd Adult (11kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 11.0,
    price: 1557,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: 'German Shepherd',
    needs: 'General',
    size: 'large',
    sterilised: 'No',
    productSize: '10.1-20kg',
    description:
      'Royal Canin German Shepherd Adult Dog Food is specially for adult and mature German Shepherds - Over 15 months old..Royal Canin German Shepherd Adult helps to support the skin\'s barrier role with a specific complex. It also contains the omega-3...',
    longDescription:
      '<div class="std" itemprop="description"><p><strong>Royal Canin German Shepherd Adult Dog Food</strong> is s<span>pecially for adult and mature German Shepherds - Over 15 months old.</span>.</p><p><span>Royal Canin German Shepherd Adult helps to support the skin\\\'s barrier role with a specific complex. It also contains the omega-3 fatty acids EPA &amp; DHA.</span></p><p><strong>Key Benefits:</strong></p><ul><li><strong>Exclusive Kibble Design: - </strong>Kibble that is tailor-made for your pup down to its shape, texture, size, and formula.</li><li><strong>Digestive Performance - </strong>Designed to support the German Shepherd\\\'s digestion sensitivity and promote a healthy balance of intestinal flora, contributing to good stool quality.</li><li><strong>Healthy Skin &amp; Coat - </strong>Supports healthy skin and coat with EPA and DHA from fish oil and reinforces the skin barrier with essential nutrients</li><li><strong>Joint &amp; Bone Support -</strong> Promotes bone &amp; joint health, while maintaining an ideal weight. </li></ul></div>',
    keyBenefits: [
      'Exclusive Kibble Design: -',
      'Digestive Performance -',
      'Healthy Skin & Coat -',
      'Joint & Bone Support -',
    ],
    feedingGuide: [
      {
        weight: 'WEIGHT OF DOG',
        idealWeight: 'LOW ACTIVITY',
        overweight: 'MEDIUM ACTIVITY',
      },
      {
        weight: '26 kg',
        idealWeight: '286 g (3+3/8 cups)',
        overweight: '376 g (4+4/8 cups)',
      },
      {
        weight: '28 kg',
        idealWeight: '302 g (3+5/8 cups)',
        overweight: '397 g (4+4/8 cups)',
      },
      {
        weight: '30 kg',
        idealWeight: '318 g (3+6/8 cups)',
        overweight: '418 g (5 cups)',
      },
      {
        weight: '32 kg',
        idealWeight: '334 g (4 cups)',
        overweight: '439 g (5+2/8 cups)',
      },
      {
        weight: '34 kg',
        idealWeight: '349 g (4+1/8 cups)',
        overweight: '460 g (5+4/8 cups)',
      },
      {
        weight: '36 kg',
        idealWeight: '365 g (4+3/8 cups)',
        overweight: '480 g (5+6/8 cups)',
      },
      {
        weight: '38 kg',
        idealWeight: '380 g (4+4/8 cups)',
        overweight: '500 g (6 cups)',
      },
      {
        weight: '40 kg',
        idealWeight: '395 g (4+6/8 cups)',
        overweight: '519 g (6+1/8 cups)',
      },
      {
        weight: '42 kg',
        idealWeight: '409 g (4+7/8 cups)',
        overweight: '539 g (6+3/8 cups)',
      },
      {
        weight: '44 kg',
        idealWeight: '424 g (5 cups)',
        overweight: '558 g (6+5/8 cups)',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'No',
      breed: 'German Shepherd',
      breed_size: 'No',
      flavour: 'Chicken',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Golden_Retriever_Puppy_12kg.jpg',
    id: 'RC_Golden_Retriever_Puppy_12kg',
    name: 'Royal Canin Golden Retriever Puppy (12kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 12.0,
    price: 1574,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Puppy',
    breed: 'Golden Retriever',
    needs: 'General',
    size: 'large',
    sterilised: 'No',
    productSize: '10.1-20kg',
    description:
      'The Royal Canin Golden Retriever Junior Puppy Food is designed exclusively for pure breed Golden Retriever puppies from 8 weeks to 15 months. Your energetic and playful pup deserves the best nutrition during this time of big changes, discoveries and...',
    longDescription:
      '<div class="std" itemprop="description"><p>The <strong>Royal Canin Golden Retriever Junior Puppy Food</strong> is designed exclusively for pure breed Golden Retriever puppies from 8 weeks to 15 months. </p><p>Your energetic and playful pup deserves the best nutrition during this time of big changes, discoveries and new encounters!</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Immune system support :</strong> Helps support your puppy’s natural defences thanks particularly to a patented* complex of antioxidants including vitamin E. </li><li><strong>Healthy skin &amp; coat : </strong>This formula helps support the skin’s “barrier” role and maintain skin and coat health . Enriched with borage oil.</li><li><strong>Digestive health :</strong> Combination of nutrients with high quality protein and prebiotics to support digestive health and balance of intestinal flora, which contributes to good stool quality. Protein selected for its very high digestibility.</li><li><strong>Exclusive kibble :</strong> The kibble’s shape, size, texture and formula are adapted to the Golden Retriever puppy. </li></ul></div>',
    keyBenefits: [
      'Immune system support :',
      'Healthy skin & coat :',
      'Digestive health :',
      'Exclusive kibble :',
    ],
    feedingGuide: [
      {
        weight: 'AGE (MONTHS)',
        idealWeight: 'ADULT WEIGHT = 25 KG',
        overweight: 'ADULT WEIGHT = 30 KG',
      },
      {
        weight: '2 m',
        idealWeight: '215 g (2+2/8 cups)',
        overweight: '225 g (2+3/8 cups)',
      },
      {
        weight: '3 m',
        idealWeight: '265 g (2+7/8 cups)',
        overweight: '282 g (3 cups)',
      },
      {
        weight: '4 m',
        idealWeight: '287 g (3+1/8 cups)',
        overweight: '308 g (3+2/8 cups)',
      },
      {
        weight: '5 m',
        idealWeight: '306 g (3+2/8 cups)',
        overweight: '340 g (3+5/8 cups)',
      },
      {
        weight: '6 m',
        idealWeight: '323 g (3+4/8 cups)',
        overweight: '370 g (4 cups)',
      },
      {
        weight: '8 m',
        idealWeight: '291 g (3+1/8 cups)',
        overweight: '344 g (3+5/8 cups)',
      },
      {
        weight: '10 m',
        idealWeight: '262 g (2+6/8 cups)',
        overweight: '329 g (3+4/8 cups)',
      },
      {
        weight: '12 m',
        idealWeight: '287 g (3+1/8 cups)',
        overweight: '329 g (3+4/8 cups)',
      },
      {
        weight: '16 m',
        idealWeight: 'Transition Golden Retriever Adult',
        overweight: 'Transition Golden Retriever Adult',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'No',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'Golden Retriever',
      breed_size: 'No',
      flavour: 'Chicken',
      lifestage: 'Puppy',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Golden_Retriever_Adult_12kg.jpg',
    id: 'RC_Golden_Retriever_Adult_12kg',
    name: 'Royal Canin Golden Retriever Adult (12kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 12.0,
    price: 1593,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: 'Golden Retriever',
    needs: 'General',
    size: 'large',
    sterilised: 'No',
    productSize: '10.1-20kg',
    description:
      'Complete feed for dogs - Specially for adult and mature Golden Retrievers - Over 15 months old.',
    longDescription:
      '<div class="std" itemprop="description"><p>Complete feed for dogs - Specially for adult and mature Golden Retrievers - Over 15 months old.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Maintains Ideal Weight - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Healthy Skin & Coat - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Digestive Health - </strong>Nutritional support tailored to your pet\'s needs.</li></ul></div>',
    keyBenefits: [
      'Maintains Ideal Weight -',
      'Healthy Skin & Coat -',
      'Digestive Health -',
    ],
    feedingGuide: [
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'Golden Retriever',
      breed_size: 'No',
      flavour: 'None',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Jack_Russell_Adult_1_5kg.jpg',
    id: 'RC_Jack_Russell_Adult_1_5kg',
    name: 'Royal Canin Jack Russell Adult (1.5kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1.5,
    price: 302,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: 'Jack Russell',
    needs: 'General',
    size: 'small',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'The Royal Canin Jack Russell Adult Dog Food is formulated exclusively for pure breed Jack Russell Terriers over 10 months old. The Jack Russell Terrier is known for their lively temperament, and need nutrition that is is specifically designed to...',
    longDescription:
      '<div class="std" itemprop="description"><p>The<strong> Royal Canin Jack Russell Adult Dog Food</strong> is formulated exclusively for pure breed Jack Russell Terriers over 10 months old. </p><p>The Jack Russell Terrier is known for their lively temperament, and need nutrition that is is specifically designed to support their busy, energetic lifestyles. </p><p><strong>Key Benefits: </strong></p><ul><li><strong>Muscle &amp; Vitality Complex - </strong>Enriched with a complex of antioxidants and precise protein content to help maintain vitality and mucle mass.</li><li><strong>Healthy Skin &amp; Coat -</strong> Jack Russells are prone to skin problems. This formula contains nutrients that help to support the skin\\\'s "barrier role" and maintain skin &amp; coat healthy.</li><li><strong><span>Dental Health - </span></strong><span>This breed is prone to dental disease. Calcium chelators help prevent this by r</span><span>educing tartar formation.</span></li><li><span><strong><span>Exclusive Kibble Design: - </span></strong><span>Exclusive tailor-made kibble is adapted to the Jack Russell Terrier dog.</span></span></li></ul></div>',
    keyBenefits: [
      'Muscle & Vitality Complex -',
      'Healthy Skin & Coat  -',
      'Dental Health -',
      'Exclusive Kibble Design: -',
    ],
    feedingGuide: [
      {
        weight: 'WEIGHT OF DOG',
        idealWeight: 'LOW ACTIVITY',
        overweight: 'MEDIUM ACTIVITY',
      },
      {
        weight: '5 kg',
        idealWeight: '80 g (7/8 cups)',
        overweight: '106 g (1+1/8 cups)',
      },
      {
        weight: '6 kg',
        idealWeight: '92 g (1 cups)',
        overweight: '121 g (1+2/8 cups)',
      },
      {
        weight: '8 kg',
        idealWeight: '114 g (1+2/8 cups)',
        overweight: '150 g (1+5/8 cups)',
      },
      {
        weight: '10 kg',
        idealWeight: '135 g (1+4/8 cups)',
        overweight: '178 g (1+7/8 cups)',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'Jack Russell',
      breed_size: 'No',
      flavour: 'Chicken',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Jack_Russell_Adult_3kg.jpg',
    id: 'RC_Jack_Russell_Adult_3kg',
    name: 'Royal Canin Jack Russell Adult (3kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 3.0,
    price: 539,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: 'Jack Russell',
    needs: 'General',
    size: 'small',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'The Royal Canin Jack Russell Adult Dog Food is formulated exclusively for pure breed Jack Russell Terriers over 10 months old. The Jack Russell Terrier is known for their lively temperament, and need nutrition that is is specifically designed to...',
    longDescription:
      '<div class="std" itemprop="description"><p>The<strong> Royal Canin Jack Russell Adult Dog Food</strong> is formulated exclusively for pure breed Jack Russell Terriers over 10 months old. </p><p>The Jack Russell Terrier is known for their lively temperament, and need nutrition that is is specifically designed to support their busy, energetic lifestyles. </p><p><strong>Key Benefits: </strong></p><ul><li><strong>Muscle &amp; Vitality Complex - </strong>Enriched with a complex of antioxidants and precise protein content to help maintain vitality and mucle mass.</li><li><strong>Healthy Skin &amp; Coat -</strong> Jack Russells are prone to skin problems. This formula contains nutrients that help to support the skin\\\'s "barrier role" and maintain skin &amp; coat healthy.</li><li><strong><span>Dental Health - </span></strong><span>This breed is prone to dental disease. Calcium chelators help prevent this by r</span><span>educing tartar formation.</span></li><li><span><strong><span>Exclusive Kibble Design: - </span></strong><span>Exclusive tailor-made kibble is adapted to the Jack Russell Terrier dog.</span></span></li></ul></div>',
    keyBenefits: [
      'Muscle & Vitality Complex -',
      'Healthy Skin & Coat  -',
      'Dental Health -',
      'Exclusive Kibble Design: -',
    ],
    feedingGuide: [
      {
        weight: 'WEIGHT OF DOG',
        idealWeight: 'LOW ACTIVITY',
        overweight: 'MEDIUM ACTIVITY',
      },
      {
        weight: '5 kg',
        idealWeight: '80 g (7/8 cups)',
        overweight: '106 g (1+1/8 cups)',
      },
      {
        weight: '6 kg',
        idealWeight: '92 g (1 cups)',
        overweight: '121 g (1+2/8 cups)',
      },
      {
        weight: '8 kg',
        idealWeight: '114 g (1+2/8 cups)',
        overweight: '150 g (1+5/8 cups)',
      },
      {
        weight: '10 kg',
        idealWeight: '135 g (1+4/8 cups)',
        overweight: '178 g (1+7/8 cups)',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'Jack Russell',
      breed_size: 'No',
      flavour: 'Chicken',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Jack_Russell_Adult_7_5kg.jpg',
    id: 'RC_Jack_Russell_Adult_7_5kg',
    name: 'Royal Canin Jack Russell Adult (7.5kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 7.5,
    price: 1107,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: 'Jack Russell',
    needs: 'General',
    size: 'small',
    sterilised: 'No',
    productSize: '5.1-10kg',
    description:
      'The Royal Canin Jack Russell Adult Dog Food is formulated exclusively for pure breed Jack Russell Terriers over 10 months old. The Jack Russell Terrier is known for their lively temperament, and need nutrition that is is specifically designed to...',
    longDescription:
      '<div class="std" itemprop="description"><p>The<strong> Royal Canin Jack Russell Adult Dog Food</strong> is formulated exclusively for pure breed Jack Russell Terriers over 10 months old. </p><p>The Jack Russell Terrier is known for their lively temperament, and need nutrition that is is specifically designed to support their busy, energetic lifestyles. </p><p><strong>Key Benefits: </strong></p><ul><li><strong>Muscle &amp; Vitality Complex - </strong>Enriched with a complex of antioxidants and precise protein content to help maintain vitality and mucle mass.</li><li><strong>Healthy Skin &amp; Coat -</strong> Jack Russells are prone to skin problems. This formula contains nutrients that help to support the skin\\\'s "barrier role" and maintain skin &amp; coat healthy.</li><li><strong><span>Dental Health - </span></strong><span>This breed is prone to dental disease. Calcium chelators help prevent this by r</span><span>educing tartar formation.</span></li><li><span><strong><span>Exclusive Kibble Design: - </span></strong><span>Exclusive tailor-made kibble is adapted to the Jack Russell Terrier dog.</span></span></li></ul></div>',
    keyBenefits: [
      'Muscle & Vitality Complex -',
      'Healthy Skin & Coat  -',
      'Dental Health -',
      'Exclusive Kibble Design: -',
    ],
    feedingGuide: [
      {
        weight: 'WEIGHT OF DOG',
        idealWeight: 'LOW ACTIVITY',
        overweight: 'MEDIUM ACTIVITY',
      },
      {
        weight: '5 kg',
        idealWeight: '80 g (7/8 cups)',
        overweight: '106 g (1+1/8 cups)',
      },
      {
        weight: '6 kg',
        idealWeight: '92 g (1 cups)',
        overweight: '121 g (1+2/8 cups)',
      },
      {
        weight: '8 kg',
        idealWeight: '114 g (1+2/8 cups)',
        overweight: '150 g (1+5/8 cups)',
      },
      {
        weight: '10 kg',
        idealWeight: '135 g (1+4/8 cups)',
        overweight: '178 g (1+7/8 cups)',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'Jack Russell',
      breed_size: 'No',
      flavour: 'Chicken',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Labrador_Retriever_Puppy_12kg.jpg',
    id: 'RC_Labrador_Retriever_Puppy_12kg',
    name: 'Royal Canin Labrador Retriever Puppy (12kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 12.0,
    price: 1574,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Puppy',
    breed: 'Labrador Retriever',
    needs: 'General',
    size: 'large',
    sterilised: 'No',
    productSize: '10.1-20kg',
    description:
      'The Royal Canin Labrador Retriever Junior Puppy Food is designed exclusively for pure breed Labrador Retriever puppies from 8 weeks to 15 months.The Labrador Retriever is a breed that tends to eat quickly without chewing its food. The donut shaped...',
    longDescription:
      '<div class="std" itemprop="description"><p>The <strong>Royal Canin Labrador Retriever Junior Puppy Food</strong> is designed exclusively for pure breed Labrador Retriever puppies from 8 weeks to 15 months.</p><p>The Labrador Retriever is a breed that tends to eat quickly without chewing its food. The donut shaped kibble of the Labrador Retriever formula helps to slow the rate of ingestion and encourage the Labrador to chew the food.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Immune System Support - </strong>Premium formula designed to support your puppy’s natural defences during this essential growth stage.</li><li><strong>Digestive Health - </strong>Supports digestion and healthy balance of intestinal flora, contributing to good stool quality.</li><li><strong>Healthy Growth &amp; Weight - </strong>Contributes to the healthy development of the growing Labrador Retriever puppy’s bone structure and promotes harmonious weight gain.</li><li><strong><strong><span>Exclusive Kibble Design: - </span></strong></strong>Exclusive tailor-made kibble is adapted to your Labrador Retriever puppy.</li></ul></div>',
    keyBenefits: [
      'Immune System Support -',
      'Digestive Health -',
      'Healthy Growth & Weight -',
      'Exclusive Kibble Design: -',
    ],
    feedingGuide: [
      {
        weight: 'WEIGHT OF DOG',
        idealWeight: 'WEIGHT = 26 KG',
        overweight: 'WEIGHT = 32 KG',
      },
      {
        weight: '2 m',
        idealWeight: '214 g (2 + 3/8 cups)',
        overweight: '226 g ( 2+ 4/8 cups)',
      },
      {
        weight: '3 m',
        idealWeight: '265 g (3 cups)',
        overweight: '285 g (3 + 2/8 cups)',
      },
      {
        weight: '4 m',
        idealWeight: '287 g (3 + 2/8 cups)',
        overweight: '312 g (3 + 4/8 cups)',
      },
      {
        weight: '6 m',
        idealWeight: '328 g (3 + 6/8 cups)',
        overweight: '382 g (4 + 2/8 cups)',
      },
      {
        weight: '8 m',
        idealWeight: '303 g (3 + 3/8 cups)',
        overweight: '356 g (4 cups)',
      },
      {
        weight: '10 m',
        idealWeight: '290 g (3 + 2/8 cups)',
        overweight: '341 g ( 3 +7/8 cups)',
      },
      {
        weight: '12 m',
        idealWeight: '292 g (3 + 2/8 cups)',
        overweight: '342 g (3 + 7/8 cups)',
      },
      {
        weight: '14 m',
        idealWeight: '289 g (3 + 2/8 cups)',
        overweight: '338 g (3 + 6/8 cups)',
      },
      {
        weight: '16 m',
        idealWeight: 'Transition to Labrador Adult',
        overweight: 'Transition to Labrador Adult',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'No',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Immune Support',
      breed: 'Labrador',
      breed_size: 'No',
      flavour: 'Chicken',
      lifestage: 'Puppy',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Labrador_Retriever_Adult_12kg.jpg',
    id: 'RC_Labrador_Retriever_Adult_12kg',
    name: 'Royal Canin Labrador Retriever Adult (12kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 12.0,
    price: 1593,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: 'Labrador Retriever',
    needs: 'General',
    size: 'large',
    sterilised: 'No',
    productSize: '10.1-20kg',
    description:
      'The Royal Canin Labrador Retriever Adult Dog Food is designed exclusively for pure breed Labrador Retrievers over 15 months. The Labrador Retriever is a breed that tends to eat quickly without chewing its food. The donut shaped kibble of the...',
    longDescription:
      '<div class="std" itemprop="description"><p>The <strong>Royal Canin Labrador Retriever Adult Dog Food</strong> is designed exclusively for pure breed Labrador Retrievers over 15 months. The Labrador Retriever is a breed that tends to eat quickly without chewing its food. The donut shaped kibble of the Labrador Retriever formula helps to slow the rate of ingestion and encourage the Labrador to chew the food.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Ideal Weight - </strong>Maintains an ideal weight thanks to an adapted calorie content.</li><li><strong>Joint &amp; Bone Support -</strong> Enriched with calcium and phosphorus to maintains bone &amp; joint health.</li><li><strong>Healthy Skin &amp; Coat -</strong> Contains nutrients that help to support the skin\\\\\\\'s "barrier role" and maintain skin &amp; coat healthy (EPA &amp; DHA). </li><li><strong><span>Exclusive Kibble Design: - </span></strong><span>Exclusive tailor-made kibble is adapted to your Labrador Retriever.</span></li></ul></div>',
    keyBenefits: [
      'Ideal Weight -',
      'Joint & Bone Support -',
      'Healthy Skin & Coat  -',
      'Exclusive Kibble Design: -',
    ],
    feedingGuide: [
      {
        weight: 'Weight of dog',
        idealWeight: 'Low activity',
        overweight: 'Medium activity',
      },
      {
        weight: '26 kg',
        idealWeight: '308 g (4+1/8 cups)',
        overweight: '356 g (4+6/8 cups)',
      },
      {
        weight: '28 kg',
        idealWeight: '325 g (4+3/8 cups)',
        overweight: '376 g (5 cups)',
      },
      {
        weight: '30 kg',
        idealWeight: '342 g (4+5/8 cups)',
        overweight: '396 g (5+3/8 cups)',
      },
      {
        weight: '32 kg',
        idealWeight: '359 g (4+7/8 cups)',
        overweight: '416 g (5+5/8 cups)',
      },
      {
        weight: '34 kg',
        idealWeight: '376 g (5 cups)',
        overweight: '435 g (5+7/8 cups)',
      },
      {
        weight: '36 kg',
        idealWeight: '393 g (5+2/8 cups)',
        overweight: '455 g (6+1/8 cups)',
      },
      {
        weight: '38 kg',
        idealWeight: '409 g (5+4/8 cups)',
        overweight: '473 g (6+3/8 cups)',
      },
      {
        weight: '40 kg',
        idealWeight: '425 g (5+6/8 cups)',
        overweight: '492 g (6+5/8 cups)',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'Labrador',
      breed_size: 'No',
      flavour: 'Chicken',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Pomeranian_Adult_1_5kg.jpg',
    id: 'RC_Pomeranian_Adult_1_5kg',
    name: 'Royal Canin Pomeranian Adult (1.5kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1.5,
    price: 302,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: 'Pomeranian',
    needs: 'General',
    size: 'small',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'Royal Canin Pomeranian Adult Dog Food is a tailor-made, breed-exclusive formula especially for adult Pomeranian dogs like yours.This delicious food contains advanced nutrients and an adapted mineral content to help support healthy joints and bones....',
    longDescription:
      '<div class="std" itemprop="description"><p><strong>Royal Canin Pomeranian Adult Dog Food</strong> is a tailor-made, breed-exclusive formula especially for adult Pomeranian dogs like yours.</p><p>This delicious food contains advanced nutrients and an adapted mineral content to help support healthy joints and bones. </p><p><strong>Key Features:</strong></p><ul><li><strong>Bone &amp; Joint Suport:</strong> Enriched with EPA &amp; DHA.</li><li><strong>Healthy Skin &amp; Coat:</strong> Enriched with an adapted content of EPA &amp; DHA and borage oil.</li><li><strong>Digestive Care</strong>: A balanced blend of fibres, including psyllium, helps facilitate intestinal transit and highly digestible proteins.</li><li><strong>Dental Health:</strong> Helps reduce tartar formation thanks to calcium chelators to support dental health.</li></ul></div>',
    keyBenefits: [
      'Bone & Joint Suport:',
      'Healthy Skin & Coat:',
      'Digestive Care',
      'Dental Health:',
    ],
    feedingGuide: [
      {
        weight: 'DOG WEIGHT',
        idealWeight: 'LOW ACTIVITY',
        overweight: 'NORMAL ACTIVITY',
      },
      {
        weight: '1 kg',
        idealWeight: '24 g (2/8 cup)',
        overweight: '28 g ( 2/8 cup)',
      },
      {
        weight: '2kg',
        idealWeight: '41 g (3/8 cup)',
        overweight: '47 g (4/8 cup)',
      },
      {
        weight: '3 kg',
        idealWeight: '55 g (5/8 cup)',
        overweight: '64 g (5/8 cup)',
      },
      {
        weight: '3,5 kg',
        idealWeight: '62 g (5/8 cup)',
        overweight: '71 g (6/8 cup)',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'No',
      breed: 'No',
      breed_size: 'Mini Breed',
      flavour: 'Chicken',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Pomeranian_Adult_3kg.jpg',
    id: 'RC_Pomeranian_Adult_3kg',
    name: 'Royal Canin Pomeranian Adult (3kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 3.0,
    price: 599,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: 'Pomeranian',
    needs: 'General',
    size: 'very small',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'Royal Canin Pomeranian Adult Dog Food is a tailor-made, breed-exclusive formula especially for adult Pomeranian dogs like yours.This delicious food contains advanced nutrients and an adapted mineral content to help support healthy joints and bones....',
    longDescription:
      '<div class="std" itemprop="description"><p><strong>Royal Canin Pomeranian Adult Dog Food</strong> is a tailor-made, breed-exclusive formula especially for adult Pomeranian dogs like yours.</p><p>This delicious food contains advanced nutrients and an adapted mineral content to help support healthy joints and bones. </p><p><strong>Key Features:</strong></p><ul><li><strong>Bone &amp; Joint Suport:</strong> Enriched with EPA &amp; DHA.</li><li><strong>Healthy Skin &amp; Coat:</strong> Enriched with an adapted content of EPA &amp; DHA and borage oil.</li><li><strong>Digestive Care</strong>: A balanced blend of fibres, including psyllium, helps facilitate intestinal transit and highly digestible proteins.</li><li><strong>Dental Health:</strong> Helps reduce tartar formation thanks to calcium chelators to support dental health.</li></ul></div>',
    keyBenefits: [
      'Bone & Joint Suport:',
      'Healthy Skin & Coat:',
      'Digestive Care',
      'Dental Health:',
    ],
    feedingGuide: [
      {
        weight: 'DOG WEIGHT',
        idealWeight: 'LOW ACTIVITY',
        overweight: 'NORMAL ACTIVITY',
      },
      {
        weight: '1 kg',
        idealWeight: '24 g (2/8 cup)',
        overweight: '28 g ( 2/8 cup)',
      },
      {
        weight: '2kg',
        idealWeight: '41 g (3/8 cup)',
        overweight: '47 g (4/8 cup)',
      },
      {
        weight: '3 kg',
        idealWeight: '55 g (5/8 cup)',
        overweight: '64 g (5/8 cup)',
      },
      {
        weight: '3,5 kg',
        idealWeight: '62 g (5/8 cup)',
        overweight: '71 g (6/8 cup)',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'No',
      breed: 'No',
      breed_size: 'Mini Breed',
      flavour: 'Chicken',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Poodle_Puppy_3kg.jpg',
    id: 'RC_Poodle_Puppy_3kg',
    name: 'Royal Canin Poodle Puppy (3kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 3.0,
    price: 530,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Puppy',
    breed: 'Poodle',
    needs: 'General',
    size: 'small',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'Complete feed for dogs - Specially for Poodle puppies - Up to 10 months old.',
  },
  {
    image: '/pet_images/RC_Poodle_Adult_1_5kg.jpg',
    id: 'RC_Poodle_Adult_1_5kg',
    name: 'Royal Canin Poodle Adult (1.5kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1.5,
    price: 275,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: 'Poodle',
    needs: 'General',
    size: 'small',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'The Royal Canin Poodle Adult Dog Food is designed exclusively for pure breed Toy and Miniature Poodles over 10 months.The Poodle has a long, straight muzzle with teeth that meet in a scissors bite. The kibbles of the Poodle formula have been...',
    longDescription:
      '<div class="std" itemprop="description"><p>The <strong>Royal Canin Poodle Adult Dog Food</strong> is designed exclusively for pure breed Toy and Miniature Poodles over 10 months.</p><p>The Poodle has a long, straight muzzle with teeth that meet in a scissors bite. The kibbles of the Poodle formula have been designed to make it easier for this breed to pick up and encourage chewing.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Coat Health -</strong> Contains nutrients that help to provide the nourishment needed to maintain the good health of the Poodle\\\'s woolly coat.</li><li><strong>Dental Health - </strong>Reduces tartar formation thanks to calcium chelators.</li><li><strong>Muscle Tone - </strong>Supports the muscle tone of a Poodle with precise protein content and L-carnitine.</li><li><strong><span>Exclusive Kibble Design: - </span></strong><span>Exclusive tailor-made kibble is adapted to your Poodle.</span></li></ul></div>',
    keyBenefits: [
      'Coat Health -',
      'Dental Health -',
      'Muscle Tone -',
      'Exclusive Kibble Design: -',
    ],
    feedingGuide: [
      {
        weight: 'WEIGHT OF DOG',
        idealWeight: 'LOW ACTIVITY',
        overweight: 'MEDIUM ACTIVITY',
      },
      {
        weight: '2 kg',
        idealWeight: '39 g (3/8 cup)',
        overweight: '46 g (4/8 cup)',
      },
      {
        weight: '6 kg',
        idealWeight: '90 g (1 cup)',
        overweight: '104 g (1+1/8 cups)',
      },
      {
        weight: '10 kg',
        idealWeight: '132 g (1+3/8 cups)',
        overweight: '152 g (1+5/8 cups)',
      },
      {
        weight: '12 kg',
        idealWeight: '151 g (1+5/8 cups)',
        overweight: '175 g (1+7/8 cups)',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'Poodle',
      breed_size: 'No',
      flavour: 'Chicken',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Poodle_Adult_7_5kg.jpg',
    id: 'RC_Poodle_Adult_7_5kg',
    name: 'Royal Canin Poodle Adult (7.5kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 7.5,
    price: 1107,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: 'Poodle',
    needs: 'General',
    size: 'small',
    sterilised: 'No',
    productSize: '5.1-10kg',
    description:
      'The Royal Canin Poodle Adult Dog Food is designed exclusively for pure breed Toy and Miniature Poodles over 10 months.The Poodle has a long, straight muzzle with teeth that meet in a scissors bite. The kibbles of the Poodle formula have been...',
    longDescription:
      '<div class="std" itemprop="description"><p>The <strong>Royal Canin Poodle Adult Dog Food</strong> is designed exclusively for pure breed Toy and Miniature Poodles over 10 months.</p><p>The Poodle has a long, straight muzzle with teeth that meet in a scissors bite. The kibbles of the Poodle formula have been designed to make it easier for this breed to pick up and encourage chewing.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Coat Health -</strong> Contains nutrients that help to provide the nourishment needed to maintain the good health of the Poodle\\\'s woolly coat.</li><li><strong>Dental Health - </strong>Reduces tartar formation thanks to calcium chelators.</li><li><strong>Muscle Tone - </strong>Supports the muscle tone of a Poodle with precise protein content and L-carnitine.</li><li><strong><span>Exclusive Kibble Design: - </span></strong><span>Exclusive tailor-made kibble is adapted to your Poodle.</span></li></ul></div>',
    keyBenefits: [
      'Coat Health -',
      'Dental Health -',
      'Muscle Tone -',
      'Exclusive Kibble Design: -',
    ],
    feedingGuide: [
      {
        weight: 'WEIGHT OF DOG',
        idealWeight: 'LOW ACTIVITY',
        overweight: 'MEDIUM ACTIVITY',
      },
      {
        weight: '2 kg',
        idealWeight: '39 g (3/8 cup)',
        overweight: '46 g (4/8 cup)',
      },
      {
        weight: '6 kg',
        idealWeight: '90 g (1 cup)',
        overweight: '104 g (1+1/8 cups)',
      },
      {
        weight: '10 kg',
        idealWeight: '132 g (1+3/8 cups)',
        overweight: '152 g (1+5/8 cups)',
      },
      {
        weight: '12 kg',
        idealWeight: '151 g (1+5/8 cups)',
        overweight: '175 g (1+7/8 cups)',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'Poodle',
      breed_size: 'No',
      flavour: 'Chicken',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Pug_Puppy_1_5kg.jpg',
    id: 'RC_Pug_Puppy_1_5kg',
    name: 'Royal Canin Pug Puppy (1.5kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1.5,
    price: 296,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Puppy',
    breed: 'Pug',
    needs: 'General',
    size: 'small',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'The Royal Canin Pug Junior Puppy Food is designed exclusively for pure breed Pugs up 10 months.Royal Canin Pug Puppy contains a specific complex and the omega-3 fatty acids to help nourish and support the skin\'s barrier role, this is important for...',
    longDescription:
      '<div class="std" itemprop="description"><p>The <strong>Royal Canin Pug Junior Puppy Food</strong> is designed exclusively for pure breed Pugs up 10 months.</p><p><span>Royal Canin Pug Puppy contains a specific complex and the omega-3 fatty acids to help nourish and support the skin\\\\\\\'s barrier role, this is important for optimal maintenance of your puppy\\\\\\\'s healthy skin</span></p><p><strong>Key Benefits:</strong></p><ul><li><strong>Immune System Support : </strong>Premium formula designed to support your puppy’s natural defences during this essential growth stage.</li><li><strong>Digestive Health : </strong>Supports digestion and healthy balance of intestinal flora, contributing to good stool quality.</li><li><strong>Healthy Skin :</strong> Contains nutrients that help to support the skin\\\\\\\'s "barrier role" and maintain skin health (EPA &amp; DHA). </li><li><strong>Exclusive kibble - special brachycephalic jaw :</strong> Tailor-made kibble design helps Pugs easily pick up and chew their food.</li></ul></div>',
    keyBenefits: [
      'Immune System Support :',
      'Digestive Health :',
      'Healthy Skin :',
      'Exclusive kibble - special brachycephalic jaw :',
    ],
    feedingGuide: [
      {
        weight: 'AGE (MONTHS)',
        idealWeight: 'ADULT WEIGHT = 6 KG',
        overweight: 'ADULT WEIGHT = 8 KG',
      },
      {
        weight: '2 m',
        idealWeight: '106 g ( 1+1/8 cups)',
        overweight: '127g (1+3/8 cups)',
      },
      {
        weight: '3 m',
        idealWeight: '122 g (1+2/8 cups)',
        overweight: '149 g (1+4/8 cups)',
      },
      {
        weight: '4 m',
        idealWeight: '128 g (1+3/8 cups)',
        overweight: '158 g (1+5/8 cups)',
      },
      {
        weight: '5 m',
        idealWeight: '129 g (1+3/8 cups)',
        overweight: '161 g (1+5/8 cups)',
      },
      {
        weight: '6 m',
        idealWeight: '128 g (1+3/8 cups)',
        overweight: '159 g (1+5/8 cups)',
      },
      {
        weight: '7 m',
        idealWeight: '116 g (1+2/8 cups)',
        overweight: '144 g (1+4/8 cups)',
      },
      {
        weight: '8 m',
        idealWeight: '104 g (1+1/8 cups)',
        overweight: '129 g (1+3/8cups)',
      },
      {
        weight: '9 m',
        idealWeight: '92 g (1 cups)',
        overweight: '115 g (1+2/8 cups)',
      },
      {
        weight: '10 m',
        idealWeight: '91 g (1 cups)',
        overweight: '114 g (1+1/8 cups)',
      },
      {
        weight: '11 m',
        idealWeight: 'Transition to Pug Adult',
        overweight: 'Transition to Pug Adult',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'No',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'No',
      breed: 'Pug',
      breed_size: 'Small Breed',
      flavour: 'Chicken',
      lifestage: 'Puppy',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Pug_Adult_1_5kg.jpg',
    id: 'RC_Pug_Adult_1_5kg',
    name: 'Royal Canin Pug Adult (1.5kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1.5,
    price: 302,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: 'Pug',
    needs: 'General',
    size: 'small',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'The Royal Canin Pug Adult Dog Food is designed exclusively for pure breed Pugs over 10 months.The Pug has a large round head with a short square muzzle. Their characteristic jaw and very thick lips make it difficult to pick up food. The Pug...',
    longDescription:
      '<div class="std" itemprop="description"><p>The <strong>Royal Canin Pug Adult Dog Food</strong> is designed exclusively for pure breed Pugs over 10 months.</p><p>The Pug has a large round head with a short square muzzle. Their characteristic jaw and very thick lips make it difficult to pick up food. The Pug formula\\\'s "cloverleaf" shaped kibbles are designed to make it easier for the Pug to pick up and encourage chewing.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Healthy Skin -</strong> Contains nutrients that help to support the skin\\\'s "barrier role" and maintain skin amp; health (EPA &amp; DHA). </li><li><strong><span>Muscle Tone - </span></strong><span>Supports your Pug’s muscle tone with precise protein content and L-carnitine.</span></li><li><span><strong>Ideal Weight -</strong> Maintains an ideal weight thanks to an adapted calorie content.</span></li><li><strong>Exclusive kibble: Special brachycephalic jaw - </strong> Tailor-made kibble design helps Pugs easily pick up and chew their food.</li></ul></div>',
    keyBenefits: [
      'Healthy Skin  -',
      'Muscle Tone -',
      'Ideal Weight -',
      'Exclusive kibble: Special brachycephalic jaw -',
    ],
    feedingGuide: [
      {
        weight: 'WEIGHT OF DOG',
        idealWeight: 'NORMAL ACTIVITY',
        overweight: 'HIGH ACTIVITY',
      },
      {
        weight: '6 kg',
        idealWeight: '93 g (1 + 1/8)',
        overweight: '108 g (1 + 3/8)',
      },
      {
        weight: '7 kg',
        idealWeight: '105 g (1 + 2/8)',
        overweight: '121 g (1 + 4/8)',
      },
      {
        weight: '8 kg',
        idealWeight: '116 g (1 + 3/8)',
        overweight: '134 g (1 + 5/8)',
      },
      {
        weight: '9 kg',
        idealWeight: '126 g (1 + 4/8)',
        overweight: '146 g (1 + 6/8)',
      },
      {
        weight: '10 kg',
        idealWeight: '137 g (1 + 5/8)',
        overweight: '158 g (1 + 7/8)',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'No',
      breed: 'Pug',
      breed_size: 'No',
      flavour: 'Chicken',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Pug_Adult_3kg.jpg',
    id: 'RC_Pug_Adult_3kg',
    name: 'Royal Canin Pug Adult (3kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 3.0,
    price: 539,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: 'Pug',
    needs: 'General',
    size: 'small',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'The Royal Canin Pug Adult Dog Food is designed exclusively for pure breed Pugs over 10 months.The Pug has a large round head with a short square muzzle. Their characteristic jaw and very thick lips make it difficult to pick up food. The Pug...',
    longDescription:
      '<div class="std" itemprop="description"><p>The <strong>Royal Canin Pug Adult Dog Food</strong> is designed exclusively for pure breed Pugs over 10 months.</p><p>The Pug has a large round head with a short square muzzle. Their characteristic jaw and very thick lips make it difficult to pick up food. The Pug formula\\\'s "cloverleaf" shaped kibbles are designed to make it easier for the Pug to pick up and encourage chewing.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Healthy Skin -</strong> Contains nutrients that help to support the skin\\\'s "barrier role" and maintain skin amp; health (EPA &amp; DHA). </li><li><strong><span>Muscle Tone - </span></strong><span>Supports your Pug’s muscle tone with precise protein content and L-carnitine.</span></li><li><span><strong>Ideal Weight -</strong> Maintains an ideal weight thanks to an adapted calorie content.</span></li><li><strong>Exclusive kibble: Special brachycephalic jaw - </strong> Tailor-made kibble design helps Pugs easily pick up and chew their food.</li></ul></div>',
    keyBenefits: [
      'Healthy Skin  -',
      'Muscle Tone -',
      'Ideal Weight -',
      'Exclusive kibble: Special brachycephalic jaw -',
    ],
    feedingGuide: [
      {
        weight: 'WEIGHT OF DOG',
        idealWeight: 'NORMAL ACTIVITY',
        overweight: 'HIGH ACTIVITY',
      },
      {
        weight: '6 kg',
        idealWeight: '93 g (1 + 1/8)',
        overweight: '108 g (1 + 3/8)',
      },
      {
        weight: '7 kg',
        idealWeight: '105 g (1 + 2/8)',
        overweight: '121 g (1 + 4/8)',
      },
      {
        weight: '8 kg',
        idealWeight: '116 g (1 + 3/8)',
        overweight: '134 g (1 + 5/8)',
      },
      {
        weight: '9 kg',
        idealWeight: '126 g (1 + 4/8)',
        overweight: '146 g (1 + 6/8)',
      },
      {
        weight: '10 kg',
        idealWeight: '137 g (1 + 5/8)',
        overweight: '158 g (1 + 7/8)',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'No',
      breed: 'Pug',
      breed_size: 'No',
      flavour: 'Chicken',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Rottweiler_Puppy_12kg.jpg',
    id: 'RC_Rottweiler_Puppy_12kg',
    name: 'Royal Canin Rottweiler Puppy (12kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 12.0,
    price: 1574,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Puppy',
    breed: 'Rottweiler',
    needs: 'General',
    size: 'large',
    sterilised: 'No',
    productSize: '10.1-20kg',
    description:
      'Complete feed for dogs - Specially for Rottweiler puppies - Up to 18 months old.',
    longDescription:
      '<div class="std" itemprop="description"><p>Complete feed for dogs - Specially for Rottweiler puppies - Up to 18 months old.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Immune System Support - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Digestive Health - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Growth Support - </strong>Nutritional support tailored to your pet\'s needs.</li></ul></div>',
    keyBenefits: [
      'Immune System Support -',
      'Digestive Health -',
      'Growth Support -',
    ],
    feedingGuide: [
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'Rottweiler',
      breed_size: 'No',
      flavour: 'None',
      lifestage: 'Puppy',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Rottweiler_Adult_12kg.jpg',
    id: 'RC_Rottweiler_Adult_12kg',
    name: 'Royal Canin Rottweiler Adult (12kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 12.0,
    price: 1593,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: 'Rottweiler',
    needs: 'General',
    size: 'large',
    sterilised: 'No',
    productSize: '10.1-20kg',
    description:
      'Royal Canin Rottweiler Adult Dog Food is designed exclusively for pure breed Rottweilers over 18 months.Your Rottweiler pup has big energy requirements and deserves the right nutrition to fuel their playful and active lifestyle!Key Benefits:Healthy...',
    longDescription:
      '<div class="std" itemprop="description"><p><strong>Royal Canin Rottweiler Adult Dog Food</strong> is designed exclusively for pure breed Rottweilers over 18 months.</p><p>Your Rottweiler pup has big energy requirements and deserves the right nutrition to fuel their playful and active lifestyle!</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Healthy Cardiac Function - </strong>Enriched with taurine and EPA &amp; DHA to help support good cardiac function.</li><li><strong>Ideal Muscle Mass - </strong>Maintains your Rottweiler\\\'s powerful muscles with precise protein content and L-carnitine.</li><li><strong>Joint &amp; Bone Support - </strong>Supports bone &amp; joint health, while maintaing an ideal weight.</li><li><strong>Exclusive Kibble Design - </strong>Exclusive tailor-made kibble is adapted to your Rottweiler.</li></ul></div>',
    keyBenefits: [
      'Healthy Cardiac Function -',
      'Ideal Muscle Mass -',
      'Joint & Bone Support -',
      'Exclusive Kibble Design -',
    ],
    feedingGuide: [
      {
        weight: 'WEIGHT OF DOG',
        idealWeight: 'LOW ACTIVITY',
        overweight: 'MEDIUM ACTIVITY',
      },
      {
        weight: '40 kg',
        idealWeight: '375 g (4 cups)',
        overweight: '494 g (5+2/8 cups)',
      },
      {
        weight: '42 kg',
        idealWeight: '389 g (4+18 cups)',
        overweight: '512 g (5+4/8 cups)',
      },
      {
        weight: '44 kg',
        idealWeight: '403 g (4+2/8 cups)',
        overweight: '530 g (5+5/8 cups)',
      },
      {
        weight: '46 kg',
        idealWeight: '417 g (4+4/8 cups)',
        overweight: '548 g (5+7/8 cups)',
      },
      {
        weight: '48 kg',
        idealWeight: '430 g (4+5/8 cups)',
        overweight: '566 g (6 cups)',
      },
      {
        weight: '50 kg',
        idealWeight: '444 g (4+6/8 cups)',
        overweight: '584 g (6+2/8 cups)',
      },
      {
        weight: '52 kg',
        idealWeight: '457 g (4+7/8 cups)',
        overweight: '601 g (6+3/8 cups)',
      },
      {
        weight: '54 kg',
        idealWeight: '470 g (5 cups)',
        overweight: '618 g (6+5/8 cups)',
      },
      {
        weight: '56 kg',
        idealWeight: '483 g (5+1/8 cups)',
        overweight: '636 g (6+6/8 cups)',
      },
      {
        weight: '58 kg',
        idealWeight: '496 (5+28 cups)',
        overweight: '653 g (7 cups)',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'Rottweiler',
      breed_size: 'No',
      flavour: 'Chicken',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Schnauzer_Puppy_1_5kg.jpg',
    id: 'RC_Schnauzer_Puppy_1_5kg',
    name: 'Royal Canin Schnauzer Puppy (1.5kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1.5,
    price: 296,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Puppy',
    breed: '',
    needs: 'General',
    size: 'small',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'Complete feed for dogs - From 2 to 10 months.',
    longDescription:
      '<div class="std" itemprop="description"><p>Complete feed for dogs - From 2 to 10 months.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Immune System Support - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Digestive Health - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Growth Support - </strong>Nutritional support tailored to your pet\'s needs.</li></ul></div>',
    keyBenefits: [
      'Immune System Support -',
      'Digestive Health -',
      'Growth Support -',
    ],
    feedingGuide: [
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'No',
      breed_size: 'No',
      flavour: 'None',
      lifestage: 'Puppy',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Schnauzer_Adult_3kg.jpg',
    id: 'RC_Schnauzer_Adult_3kg',
    name: 'Royal Canin Schnauzer Adult (3kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 3.0,
    price: 539,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: '',
    needs: 'General',
    size: 'small',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'The Royal Canin Miniature Schnauzer Adult Dog Food is designed exclusively for pure breed Miniature Schnauzers over 10 months.The Miniature Schnauzer has a moderately blunt muzzle with teeth that meet in a scissors bite. The kibbles of the Miniature...',
    longDescription:
      '<div class="std" itemprop="description"><p>The <strong>Royal Canin Miniature Schnauzer Adult Dog Food</strong> is designed exclusively for pure breed Miniature Schnauzers over 10 months.</p><p>The Miniature Schnauzer has a moderately blunt muzzle with teeth that meet in a scissors bite. The kibbles of the Miniature Schnauzer formula have been designed to make it easier for this breed to pick up and encourage chewing.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Dental Health - </strong>Reduce tartar formation thanks to calcium chelators.</li><li><strong><span>Exclusive Kibble Design - </span></strong><span>Exclusive tailor-made kibble is adapted to your Schnauzer. </span></li><li><strong>Urinary Tract Healthy - </strong>Encourages your pup to drink in order to promote urine dilution, thus maintaining a healthy urinary system.</li><li><strong>Ideal Weight - </strong>Formula designed to help the Miniature Schnauzer maintain an ideal weight.</li><li><strong>Intense Coat Colour - </strong>Mainrains the coat\\\'s natural colour through optimal levels of amino acids. </li></ul></div>',
    keyBenefits: [
      'Dental Health -',
      'Exclusive Kibble Design -',
      'Urinary Tract Healthy -',
      'Ideal Weight -',
      'Intense Coat Colour -',
    ],
    feedingGuide: [
      {
        weight: 'WEIGHT OF DOG',
        idealWeight: 'LOW ACTIVITY',
        overweight: 'MEDIUM ACTIVITY',
      },
      {
        weight: '4 Kg',
        idealWeight: '74 g (7/8 cups)',
        overweight: '86 g (1 cups)',
      },
      {
        weight: '5 Kg',
        idealWeight: '88 g (1 cups)',
        overweight: '102 g (1+1/8 cups)',
      },
      {
        weight: '6 Kg',
        idealWeight: '101 g (1+1/8 cups)',
        overweight: '116 g (1+2/8 cups)',
      },
      {
        weight: '7 Kg',
        idealWeight: '113 g (1+2/8 cups)',
        overweight: '131 g (1+4/8 cups)',
      },
      {
        weight: '8 Kg',
        idealWeight: '125 g (1+3/8 cups)',
        overweight: '144 g (1+5/8 cups)',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'Miniature Schnauzer',
      breed_size: 'No',
      flavour: 'Chicken',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Schnauzer_Adult_7_5kg.jpg',
    id: 'RC_Schnauzer_Adult_7_5kg',
    name: 'Royal Canin Schnauzer Adult (7.5kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 7.5,
    price: 1107,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: '',
    needs: 'General',
    size: 'small',
    sterilised: 'No',
    productSize: '5.1-10kg',
    description:
      'The Royal Canin Miniature Schnauzer Adult Dog Food is designed exclusively for pure breed Miniature Schnauzers over 10 months.The Miniature Schnauzer has a moderately blunt muzzle with teeth that meet in a scissors bite. The kibbles of the Miniature...',
    longDescription:
      '<div class="std" itemprop="description"><p>The <strong>Royal Canin Miniature Schnauzer Adult Dog Food</strong> is designed exclusively for pure breed Miniature Schnauzers over 10 months.</p><p>The Miniature Schnauzer has a moderately blunt muzzle with teeth that meet in a scissors bite. The kibbles of the Miniature Schnauzer formula have been designed to make it easier for this breed to pick up and encourage chewing.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Dental Health - </strong>Reduce tartar formation thanks to calcium chelators.</li><li><strong><span>Exclusive Kibble Design - </span></strong><span>Exclusive tailor-made kibble is adapted to your Schnauzer. </span></li><li><strong>Urinary Tract Healthy - </strong>Encourages your pup to drink in order to promote urine dilution, thus maintaining a healthy urinary system.</li><li><strong>Ideal Weight - </strong>Formula designed to help the Miniature Schnauzer maintain an ideal weight.</li><li><strong>Intense Coat Colour - </strong>Mainrains the coat\\\'s natural colour through optimal levels of amino acids. </li></ul></div>',
    keyBenefits: [
      'Dental Health -',
      'Exclusive Kibble Design -',
      'Urinary Tract Healthy -',
      'Ideal Weight -',
      'Intense Coat Colour -',
    ],
    feedingGuide: [
      {
        weight: 'WEIGHT OF DOG',
        idealWeight: 'LOW ACTIVITY',
        overweight: 'MEDIUM ACTIVITY',
      },
      {
        weight: '4 Kg',
        idealWeight: '74 g (7/8 cups)',
        overweight: '86 g (1 cups)',
      },
      {
        weight: '5 Kg',
        idealWeight: '88 g (1 cups)',
        overweight: '102 g (1+1/8 cups)',
      },
      {
        weight: '6 Kg',
        idealWeight: '101 g (1+1/8 cups)',
        overweight: '116 g (1+2/8 cups)',
      },
      {
        weight: '7 Kg',
        idealWeight: '113 g (1+2/8 cups)',
        overweight: '131 g (1+4/8 cups)',
      },
      {
        weight: '8 Kg',
        idealWeight: '125 g (1+3/8 cups)',
        overweight: '144 g (1+5/8 cups)',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'Miniature Schnauzer',
      breed_size: 'No',
      flavour: 'Chicken',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Shih_Tzu_Puppy_1_5kg.jpg',
    id: 'RC_Shih_Tzu_Puppy_1_5kg',
    name: 'Royal Canin Shih Tzu Puppy (1.5kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1.5,
    price: 296,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Puppy',
    breed: 'Shih Tzu',
    needs: 'General',
    size: 'small',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'The Royal Canin Shih Tzu Junior Puppy Food is designed exclusively for pure breed Shih Tzus up to 10 months old. This junior formula contains highly digestible protein to promote a balanced intestinal flora and optimal digestive tolerance.Key...',
    longDescription:
      '<div class="std" itemprop="description"><p>The<strong> Royal Canin Shih Tzu Junior Puppy Food</strong> is designed exclusively for pure breed Shih Tzus up to 10 months old. </p><p><span>This junior formula contains highly digestible protein to promote a balanced intestinal flora and optimal digestive tolerance.</span></p><p><strong>Key Benefits:</strong></p><ul><li><strong>Immune System Support : </strong>Premium formula designed to support your puppy’s natural defences during this essential growth stage.</li><li><strong>Digestive Health : </strong>Supports digestion and healthy balance of intestinal flora, contributing to good stool quality.</li><li><strong>Skin &amp; Coat Health :</strong> Contains nutrients that help to provide the nourishment needed to maintain the good health of your Shih Tzu’s skin and coat.</li><li><strong>Exclusive Kibble:</strong><strong>Special Brachyceohalic Jaw :</strong> Tailor-made kibble design helps the Shih Tzu easily pick up and chew their food.</li></ul></div>',
    keyBenefits: [
      'Immune System Support :',
      'Digestive Health :',
      'Skin & Coat Health :',
      'Exclusive Kibble:',
    ],
    feedingGuide: [
      {
        weight: 'AGE (MONTHS)',
        idealWeight: 'ADULT WEIGHT = 4 KG',
        overweight: 'ADULT WEIGHT = 5 KG',
      },
      {
        weight: '2 m',
        idealWeight: '80 g (7/8 cups)',
        overweight: '96 g (1 cups)',
      },
      {
        weight: '3 m',
        idealWeight: '91 g (1 cups)',
        overweight: '108 g (1+1/8 cups)',
      },
      {
        weight: '4 m',
        idealWeight: '95 g (1 cups)',
        overweight: '113 g (1+2/8 cups)',
      },
      {
        weight: '5 m',
        idealWeight: '95 g (1 cups)',
        overweight: '113 g (1+2/8 cups)',
      },
      {
        weight: '6 m',
        idealWeight: '86 g (7/8 cups)',
        overweight: '103 g (1+1/8 cups)',
      },
      {
        weight: '7 m',
        idealWeight: '77 g (7/8 cups)',
        overweight: '92 g (1 cups)',
      },
      {
        weight: '8 m',
        idealWeight: '68 g (6/8 cups)',
        overweight: '81 g (7/8cups)',
      },
      {
        weight: '9 m',
        idealWeight: '68 g (6/8 cups)',
        overweight: '81 g (7/8 cups)',
      },
      {
        weight: '10 m',
        idealWeight: '67 g (6/8 cups)',
        overweight: '80 g (7/8 cups)',
      },
      {
        weight: '11 m',
        idealWeight: 'Transition to Shih Tzu Adult',
        overweight: 'Transition to Shih Tzu Adult',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'No',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'No',
      breed: 'Shih Tzu',
      breed_size: 'No',
      flavour: 'Chicken',
      lifestage: 'Puppy',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Shih_Tzu_Adult_1_5kg.jpg',
    id: 'RC_Shih_Tzu_Adult_1_5kg',
    name: 'Royal Canin Shih Tzu Adult (1.5kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1.5,
    price: 302,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: 'Shih Tzu',
    needs: 'General',
    size: 'small',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'Complete feed for dogs - Specially for adult and mature Shih Tzus - Over 10 months old.',
    longDescription:
      '<div class="std" itemprop="description"><p>Complete feed for dogs - Specially for adult and mature Shih Tzus - Over 10 months old.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Maintains Ideal Weight - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Healthy Skin & Coat - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Digestive Health - </strong>Nutritional support tailored to your pet\'s needs.</li></ul></div>',
    keyBenefits: [
      'Maintains Ideal Weight -',
      'Healthy Skin & Coat -',
      'Digestive Health -',
    ],
    feedingGuide: [
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'Shih Tzu',
      breed_size: 'No',
      flavour: 'None',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Shih_Tzu_Adult_7_5kg.jpg',
    id: 'RC_Shih_Tzu_Adult_7_5kg',
    name: 'Royal Canin Shih Tzu Adult (7.5kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 7.5,
    price: 1107,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: 'Shih Tzu',
    needs: 'General',
    size: 'small',
    sterilised: 'No',
    productSize: '5.1-10kg',
    description:
      'Complete feed for dogs - Specially for adult and mature Shih Tzus - Over 10 months old.',
    longDescription:
      '<div class="std" itemprop="description"><p>Complete feed for dogs - Specially for adult and mature Shih Tzus - Over 10 months old.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Maintains Ideal Weight - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Healthy Skin & Coat - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Digestive Health - </strong>Nutritional support tailored to your pet\'s needs.</li></ul></div>',
    keyBenefits: [
      'Maintains Ideal Weight -',
      'Healthy Skin & Coat -',
      'Digestive Health -',
    ],
    feedingGuide: [
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'Shih Tzu',
      breed_size: 'No',
      flavour: 'None',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Yorkshire_Terrier_Puppy_1_5kg.jpg',
    id: 'RC_Yorkshire_Terrier_Puppy_1_5kg',
    name: 'Royal Canin Yorkshire Terrier Puppy (1.5kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1.5,
    price: 296,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Puppy',
    breed: 'Yorkshire Terrier',
    needs: 'General',
    size: 'small',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'The Royal Canin Yorkshire Terrier Junior Puppy Food is designed exclusively for pure breed Yorkshire Terrier puppies from 8 weeks to 10 months.The formula is enriched with an adapted content of Omega-3 fatty acids and Omega-6 fatty acids (from...',
    longDescription:
      '<div class="std" itemprop="description"><p>The <strong>Royal Canin Yorkshire Terrier Junior Puppy Food</strong> is designed exclusively for pure breed Yorkshire Terrier puppies from 8 weeks to 10 months.</p><p><span>The formula is enriched with an adapted content of Omega-3 fatty acids and Omega-6 fatty acids (from borage oil), as well biotin to help maintain your puppy’s coat health. </span></p><p><strong>Key Benefits:</strong></p><ul><li><strong>Immune System Support - </strong>Premium formula designed to support your puppy’s natural defences during this essential growth stage.</li><li><strong>Digestive Health - </strong>Supports digestion and healthy balance of intestinal flora, contributing to good stool quality.</li><li><strong>Coat Health -</strong> Contains nutrients that help to provide the nourishment needed to maintain the good health of your Yorkie\\\\\\\'s long coat.</li><li><strong>Dental Health - </strong>Reduce tartar formation thanks to calcium chelators.</li><li><strong><span>Exclusive Kibble Design - </span></strong><span>Exclusive tailor-made kibble is adapted to the Yorkshire Terriers\\\\\\\'s small jaw. </span></li></ul></div><td style="text-align: center;"></td><tr><td data-sheets-value="\\\\\\\'{&quot;1&quot;:3,&quot;3&quot;:2}\\\\\\\'" style="text-align: center;">2</td><td data-sheets-numberformat="\\\\\\\'{&quot;1&quot;:5,&quot;2&quot;:&quot;d/m&quot;,&quot;3&quot;:1}\\\\\\\'" data-sheets-value="\\\\\\\'{&quot;1&quot;:3,&quot;3&quot;:44228}\\\\\\\'" style="text-align: center;">1/2</td><td data-sheets-value="\\\\\\\'{&quot;1&quot;:3,&quot;3&quot;:49}\\\\\\\'" style="text-align: center;">49</td><td data-sheets-numberformat="\\\\\\\'{&quot;1&quot;:5,&quot;2&quot;:&quot;d/m&quot;,&quot;3&quot;:1}\\\\\\\'" data-sheets-value="\\\\\\\'{&quot;1&quot;:3,&quot;3&quot;:44228}\\\\\\\'" style="text-align: center;">1/2</td><td data-sheets-value="\\\\\\\'{&quot;1&quot;:3,&quot;3&quot;:54}\\\\\\\'" style="text-align: center;">54</td><td data-sheets-numberformat="\\\\\\\'{&quot;1&quot;:5,&quot;2&quot;:&quot;d/m&quot;,&quot;3&quot;:1}\\\\\\\'" data-sheets-value="\\\\\\\'{&quot;1&quot;:3,&quot;3&quot;:44228}\\\\\\\'" style="text-align: center;">1/2</td><td data-sheets-value="\\\\\\\'{&quot;1&quot;:3,&quot;3&quot;:55}\\\\\\\'" style="text-align: center;">55</td><td data-sheets-numberformat="\\\\\\\'{&quot;1&quot;:5,&quot;2&quot;:&quot;d/m&quot;,&quot;3&quot;:1}\\\\\\\'" data-sheets-value="\\\\\\\'{&quot;1&quot;:3,&quot;3&quot;:44228}\\\\\\\'" style="text-align: center;">1/2</td><td data-sheets-value="\\\\\\\'{&quot;1&quot;:3,&quot;3&quot;:55}\\\\\\\'" style="text-align: center;">55</td><td data-sheets-numberformat="\\\\\\\'{&quot;1&quot;:5,&quot;2&quot;:&quot;d/m&quot;,&quot;3&quot;:1}\\\\\\\'" data-sheets-value="\\\\\\\'{&quot;1&quot;:3,&quot;3&quot;:44228}\\\\\\\'" style="text-align: center;">1/2</td><td data-sheets-value="\\\\\\\'{&quot;1&quot;:3,&quot;3&quot;:48}\\\\\\\'" style="text-align: center;">48</td><td data-sheets-numberformat="\\\\\\\'{&quot;1&quot;:5,&quot;2&quot;:&quot;d/m&quot;,&quot;3&quot;:1}\\\\\\\'" data-sheets-value="\\\\\\\'{&quot;1&quot;:3,&quot;3&quot;:44411}\\\\\\\'" style="text-align: center;">3/8</td><td data-sheets-value="\\\\\\\'{&quot;1&quot;:3,&quot;3&quot;:40}\\\\\\\'" style="text-align: center;">40</td><td data-sheets-numberformat="\\\\\\\'{&quot;1&quot;:5,&quot;2&quot;:&quot;d/m&quot;,&quot;3&quot;:1}\\\\\\\'" data-sheets-value="\\\\\\\'{&quot;1&quot;:3,&quot;3&quot;:44411}\\\\\\\'" style="text-align: center;">3/8</td><td data-sheets-value="\\\\\\\'{&quot;1&quot;:3,&quot;3&quot;:39}\\\\\\\'" style="text-align: center;">39</td><td data-sheets-numberformat="\\\\\\\'{&quot;1&quot;:5,&quot;2&quot;:&quot;d/m&quot;,&quot;3&quot;:1}\\\\\\\'" data-sheets-value="\\\\\\\'{&quot;1&quot;:3,&quot;3&quot;:44411}\\\\\\\'" style="text-align: center;">3/8</td><td data-sheets-value="\\\\\\\'{&quot;1&quot;:3,&quot;3&quot;:39}\\\\\\\'" style="text-align: center;">39</td><td adult"}\\\\\\\'="" data-sheets-value="\\\\\\\'{&quot;1&quot;:2,&quot;2&quot;:&quot;Yorkshire" style="text-align: center;" terrier=""><div><div>Yorkshire Terrier Adult</div></div></td></tr><tr><td data-sheets-value="\\\\\\\'{&quot;1&quot;:3,&quot;3&quot;:3}\\\\\\\'" style="text-align: center;">3</td><td data-sheets-numberformat="\\\\\\\'{&quot;1&quot;:5,&quot;2&quot;:&quot;d/m&quot;,&quot;3&quot;:1}\\\\\\\'" data-sheets-value="\\\\\\\'{&quot;1&quot;:3,&quot;3&quot;:44413}\\\\\\\'" style="text-align: center;">5/8</td><td data-sheets-value="\\\\\\\'{&quot;1&quot;:3,&quot;3&quot;:63}\\\\\\\'" style="text-align: center;">63</td><td data-sheets-numberformat="\\\\\\\'{&quot;1&quot;:5,&quot;2&quot;:&quot;d/m&quot;,&quot;3&quot;:1}\\\\\\\'" data-sheets-value="\\\\\\\'{&quot;1&quot;:3,&quot;3&quot;:44289}\\\\\\\'" style="text-align: center;">3/4</td><td data-sheets-value="\\\\\\\'{&quot;1&quot;:3,&quot;3&quot;:71}\\\\\\\'" style="text-align: center;">71</td><td data-sheets-numberformat="\\\\\\\'{&quot;1&quot;:5,&quot;2&quot;:&quot;d/m&quot;,&quot;3&quot;:1}\\\\\\\'" data-sheets-value="\\\\\\\'{&quot;1&quot;:3,&quot;3&quot;:44289}\\\\\\\'" style="text-align: center;">3/4</td><td data-sheets-value="\\\\\\\'{&quot;1&quot;:3,&quot;3&quot;:75}\\\\\\\'" style="text-align: center;">75</td><td data-sheets-numberformat="\\\\\\\'{&quot;1&quot;:5,&quot;2&quot;:&quot;d/m&quot;,&quot;3&quot;:1}\\\\\\\'" data-sheets-value="\\\\\\\'{&quot;1&quot;:3,&quot;3&quot;:44289}\\\\\\\'" style="text-align: center;">3/4</td><td data-sheets-value="\\\\\\\'{&quot;1&quot;:3,&quot;3&quot;:75}\\\\\\\'" style="text-align: center;">75</td><td data-sheets-numberformat="\\\\\\\'{&quot;1&quot;:5,&quot;2&quot;:&quot;d/m&quot;,&quot;3&quot;:1}\\\\\\\'" data-sheets-value="\\\\\\\'{&quot;1&quot;:3,&quot;3&quot;:44289}\\\\\\\'" style="text-align: center;">3/4</td><td data-sheets-value="\\\\\\\'{&quot;1&quot;:3,&quot;3&quot;:68}\\\\\\\'" style="text-align: center;">68</td><td data-sheets-numberformat="\\\\\\\'{&quot;1&quot;:5,&quot;2&quot;:&quot;d/m&quot;,&quot;3&quot;:1}\\\\\\\'" data-sheets-value="\\\\\\\'{&quot;1&quot;:3,&quot;3&quot;:44413}\\\\\\\'" style="text-align: center;">5/8</td><td data-sheets-value="\\\\\\\'{&quot;1&quot;:3,&quot;3&quot;:61}\\\\\\\'" style="text-align: center;">61</td><td data-sheets-numberformat="\\\\\\\'{&quot;1&quot;:5,&quot;2&quot;:&quot;d/m&quot;,&quot;3&quot;:1}\\\\\\\'" data-sheets-value="\\\\\\\'{&quot;1&quot;:3,&quot;3&quot;:44228}\\\\\\\'" style="text-align: center;">1/2</td><td data-sheets-value="\\\\\\\'{&quot;1&quot;:3,&quot;3&quot;:54}\\\\\\\'" style="text-align: center;">54</td><td data-sheets-numberformat="\\\\\\\'{&quot;1&quot;:5,&quot;2&quot;:&quot;d/m&quot;,&quot;3&quot;:1}\\\\\\\'" data-sheets-value="\\\\\\\'{&quot;1&quot;:3,&quot;3&quot;:44228}\\\\\\\'" style="text-align: center;">1/2</td><td data-sheets-value="\\\\\\\'{&quot;1&quot;:3,&quot;3&quot;:53}\\\\\\\'" style="text-align: center;">53</td><td adult"}\\\\\\\'="" data-sheets-value="\\\\\\\'{&quot;1&quot;:2,&quot;2&quot;:&quot;Yorkshire" style="text-align: center;" terrier=""><div><div>Yorkshire Terrier Adult</div></div></td></tr><tr><td data-sheets-value="\\\\\\\'{&quot;1&quot;:3,&quot;3&quot;:4}\\\\\\\'" style="text-align: center;">4</td><td data-sheets-numberformat="\\\\\\\'{&quot;1&quot;:5,&quot;2&quot;:&quot;d/m&quot;,&quot;3&quot;:1}\\\\\\\'" data-sheets-value="\\\\\\\'{&quot;1&quot;:3,&quot;3&quot;:44289}\\\\\\\'" style="text-align: center;">3/4</td><td data-sheets-value="\\\\\\\'{&quot;1&quot;:3,&quot;3&quot;:78}\\\\\\\'" style="text-align: center;">78</td><td data-sheets-numberformat="\\\\\\\'{&quot;1&quot;:5,&quot;2&quot;:&quot;d/m&quot;,&quot;3&quot;:1}\\\\\\\'" data-sheets-value="\\\\\\\'{&quot;1&quot;:3,&quot;3&quot;:44415}\\\\\\\'" style="text-align: center;">7/8</td><td data-sheets-value="\\\\\\\'{&quot;1&quot;:3,&quot;3&quot;:88}\\\\\\\'" style="text-align: center;">88</td><td data-sheets-numberformat="\\\\\\\'{&quot;1&quot;:5,&quot;2&quot;:&quot;d/m&quot;,&quot;3&quot;:1}\\\\\\\'" data-sheets-value="\\\\\\\'{&quot;1&quot;:3,&quot;3&quot;:44415}\\\\\\\'" style="text-align: center;">7/8</td><td data-sheets-value="\\\\\\\'{&quot;1&quot;:3,&quot;3&quot;:92}\\\\\\\'" style="text-align: center;">92</td><td data-sheets-value="\\\\\\\'{&quot;1&quot;:3,&quot;3&quot;:1}\\\\\\\'" style="text-align: center;">1</td><td data-sheets-value="\\\\\\\'{&quot;1&quot;:3,&quot;3&quot;:92}\\\\\\\'" style="text-align: center;">92</td><td data-sheets-numberformat="\\\\\\\'{&quot;1&quot;:5,&quot;2&quot;:&quot;d/m&quot;,&quot;3&quot;:1}\\\\\\\'" data-sheets-value="\\\\\\\'{&quot;1&quot;:3,&quot;3&quot;:44415}\\\\\\\'" style="text-align: center;">7/8</td><td data-sheets-value="\\\\\\\'{&quot;1&quot;:3,&quot;3&quot;:84}\\\\\\\'" style="text-align: center;">84</td><td data-sheets-numberformat="\\\\\\\'{&quot;1&quot;:5,&quot;2&quot;:&quot;d/m&quot;,&quot;3&quot;:1}\\\\\\\'" data-sheets-value="\\\\\\\'{&quot;1&quot;:3,&quot;3&quot;:44289}\\\\\\\'" style="text-align: center;">3/4</td><td data-sheets-value="\\\\\\\'{&quot;1&quot;:3,&quot;3&quot;:75}\\\\\\\'" style="text-align: center;">75</td><td data-sheets-numberformat="\\\\\\\'{&quot;1&quot;:5,&quot;2&quot;:&quot;d/m&quot;,&quot;3&quot;:1}\\\\\\\'" data-sheets-value="\\\\\\\'{&quot;1&quot;:3,&quot;3&quot;:44413}\\\\\\\'" style="text-align: center;">5/8</td><td data-sheets-value="\\\\\\\'{&quot;1&quot;:3,&quot;3&quot;:66}\\\\\\\'" style="text-align: center;">66</td><td data-sheets-numberformat="\\\\\\\'{&quot;1&quot;:5,&quot;2&quot;:&quot;d/m&quot;,&quot;3&quot;:1}\\\\\\\'" data-sheets-value="\\\\\\\'{&quot;1&quot;:3,&quot;3&quot;:44413}\\\\\\\'" style="text-align: center;">5/8</td><td data-sheets-value="\\\\\\\'{&quot;1&quot;:3,&quot;3&quot;:66}\\\\\\\'" style="text-align: center;">66</td><td adult"}\\\\\\\'="" data-sheets-value="\\\\\\\'{&quot;1&quot;:2,&quot;2&quot;:&quot;Yorkshire" style="text-align: center;" terrier=""><div><div>Yorkshire Terrier Adult</div></div></td></tr>',
    keyBenefits: [
      'Immune System Support -',
      'Digestive Health -',
      'Coat Health -',
      'Dental Health -',
      'Exclusive Kibble Design -',
    ],
    feedingGuide: [
      {
        weight: '',
        idealWeight: '',
        overweight: '',
      },
      {
        weight: 'Target adult weight',
        idealWeight: '2 months',
        overweight: '',
      },
      {
        weight: 'kg',
        idealWeight: 'Cups per day',
        overweight: 'Grams per day',
      },
      {
        weight: '2',
        idealWeight: '1/2',
        overweight: '49',
      },
      {
        weight: '3',
        idealWeight: '5/8',
        overweight: '63',
      },
      {
        weight: '4',
        idealWeight: '3/4',
        overweight: '78',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'No',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'No',
      breed: 'Yorkshire Terrier',
      breed_size: 'No',
      flavour: 'Chicken',
      lifestage: 'Puppy',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Yorkshire_Terrier_Adult_1_5kg.jpg',
    id: 'RC_Yorkshire_Terrier_Adult_1_5kg',
    name: 'Royal Canin Yorkshire Terrier Adult (1.5kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1.5,
    price: 302,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: 'Yorkshire Terrier',
    needs: 'General',
    size: 'small',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'The Royal Canin Yorkshire Terrier Adult Dog Food is designed exclusively for pure breed Yorkshire Terriers over 10 months. Contributes to maintaining the health of your Yorkie\'s coat through an adapted content enriched by essential omega-3 fatty...',
    longDescription:
      '<div class="std" itemprop="description"><p>The <strong>Royal Canin Yorkshire Terrier Adult Dog Food</strong> is designed exclusively for pure breed Yorkshire Terriers over 10 months. </p><p><span>Contributes to maintaining the health of your Yorkie\\\'s coat through an adapted content enriched by essential omega-3 fatty acids (EPA &amp; DHA), omega-6 fatty acids, borage oil, and biotin.</span></p><p><strong>Key Benefits:</strong></p><ul><li><strong>Coat Health -</strong> Contains nutrients that help to provide the nourishment needed to maintain the good health of your Yorkshire\\\'s long coat. </li><li><strong>Dental Health - </strong>Reduce tartar formation thanks to calcium chelators.</li><li><strong><span>Exclusive Kibble Design - </span></strong><span>Exclusive tailor-made kibble is adapted to the Yorkshire\\\'s small jaw.</span></li><li><strong>Appetite Stimulation - </strong>Formulated to satisfy the appetite of even the fussiest of Yorkshire Terriers!</li><li><strong>Healthy Ageing Support - </strong>Contains a selection of nutrients to help maintain health in mature dogs.</li></ul></div>',
    keyBenefits: [
      'Coat Health -',
      'Dental Health -',
      'Exclusive Kibble Design -',
      'Appetite Stimulation -',
      'Healthy Ageing Support -',
    ],
    feedingGuide: [
      {
        weight: 'DOG\'S WEIGHT',
        idealWeight: 'LOW ACTIVITY LEVEL',
        overweight: 'NORMAL ACTIVITY LEVEL',
      },
      {
        weight: '2 kg',
        idealWeight: '40 g food per day',
        overweight: '47 g food per day',
      },
      {
        weight: '3 kg',
        idealWeight: '55 g food per day',
        overweight: '64 g food per day',
      },
      {
        weight: '4 kg',
        idealWeight: '68 g food per day',
        overweight: '79 g food per day',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'Yorkshire Terrier',
      breed_size: 'No',
      flavour: 'Chicken',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Yorkshire_Terrier_Adult_3kg.jpg',
    id: 'RC_Yorkshire_Terrier_Adult_3kg',
    name: 'Royal Canin Yorkshire Terrier Adult (3kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 3.0,
    price: 539,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: 'Yorkshire Terrier',
    needs: 'General',
    size: 'small',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'The Royal Canin Yorkshire Terrier Adult Dog Food is designed exclusively for pure breed Yorkshire Terriers over 10 months. Contributes to maintaining the health of your Yorkie\'s coat through an adapted content enriched by essential omega-3 fatty...',
    longDescription:
      '<div class="std" itemprop="description"><p>The <strong>Royal Canin Yorkshire Terrier Adult Dog Food</strong> is designed exclusively for pure breed Yorkshire Terriers over 10 months. </p><p><span>Contributes to maintaining the health of your Yorkie\\\'s coat through an adapted content enriched by essential omega-3 fatty acids (EPA &amp; DHA), omega-6 fatty acids, borage oil, and biotin.</span></p><p><strong>Key Benefits:</strong></p><ul><li><strong>Coat Health -</strong> Contains nutrients that help to provide the nourishment needed to maintain the good health of your Yorkshire\\\'s long coat. </li><li><strong>Dental Health - </strong>Reduce tartar formation thanks to calcium chelators.</li><li><strong><span>Exclusive Kibble Design - </span></strong><span>Exclusive tailor-made kibble is adapted to the Yorkshire\\\'s small jaw.</span></li><li><strong>Appetite Stimulation - </strong>Formulated to satisfy the appetite of even the fussiest of Yorkshire Terriers!</li><li><strong>Healthy Ageing Support - </strong>Contains a selection of nutrients to help maintain health in mature dogs.</li></ul></div>',
    keyBenefits: [
      'Coat Health -',
      'Dental Health -',
      'Exclusive Kibble Design -',
      'Appetite Stimulation -',
      'Healthy Ageing Support -',
    ],
    feedingGuide: [
      {
        weight: 'DOG\'S WEIGHT',
        idealWeight: 'LOW ACTIVITY LEVEL',
        overweight: 'NORMAL ACTIVITY LEVEL',
      },
      {
        weight: '2 kg',
        idealWeight: '40 g food per day',
        overweight: '47 g food per day',
      },
      {
        weight: '3 kg',
        idealWeight: '55 g food per day',
        overweight: '64 g food per day',
      },
      {
        weight: '4 kg',
        idealWeight: '68 g food per day',
        overweight: '79 g food per day',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'Yorkshire Terrier',
      breed_size: 'No',
      flavour: 'Chicken',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Yorkshire_Terrier_Adult_7_5kg.jpg',
    id: 'RC_Yorkshire_Terrier_Adult_7_5kg',
    name: 'Royal Canin Yorkshire Terrier Adult (7.5kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 7.5,
    price: 1107,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: 'Yorkshire Terrier',
    needs: 'General',
    size: 'small',
    sterilised: 'No',
    productSize: '5.1-10kg',
    description:
      'The Royal Canin Yorkshire Terrier Adult Dog Food is designed exclusively for pure breed Yorkshire Terriers over 10 months. Contributes to maintaining the health of your Yorkie\'s coat through an adapted content enriched by essential omega-3 fatty...',
    longDescription:
      '<div class="std" itemprop="description"><p>The <strong>Royal Canin Yorkshire Terrier Adult Dog Food</strong> is designed exclusively for pure breed Yorkshire Terriers over 10 months. </p><p><span>Contributes to maintaining the health of your Yorkie\\\'s coat through an adapted content enriched by essential omega-3 fatty acids (EPA &amp; DHA), omega-6 fatty acids, borage oil, and biotin.</span></p><p><strong>Key Benefits:</strong></p><ul><li><strong>Coat Health -</strong> Contains nutrients that help to provide the nourishment needed to maintain the good health of your Yorkshire\\\'s long coat. </li><li><strong>Dental Health - </strong>Reduce tartar formation thanks to calcium chelators.</li><li><strong><span>Exclusive Kibble Design - </span></strong><span>Exclusive tailor-made kibble is adapted to the Yorkshire\\\'s small jaw.</span></li><li><strong>Appetite Stimulation - </strong>Formulated to satisfy the appetite of even the fussiest of Yorkshire Terriers!</li><li><strong>Healthy Ageing Support - </strong>Contains a selection of nutrients to help maintain health in mature dogs.</li></ul></div>',
    keyBenefits: [
      'Coat Health -',
      'Dental Health -',
      'Exclusive Kibble Design -',
      'Appetite Stimulation -',
      'Healthy Ageing Support -',
    ],
    feedingGuide: [
      {
        weight: 'DOG\'S WEIGHT',
        idealWeight: 'LOW ACTIVITY LEVEL',
        overweight: 'NORMAL ACTIVITY LEVEL',
      },
      {
        weight: '2 kg',
        idealWeight: '40 g food per day',
        overweight: '47 g food per day',
      },
      {
        weight: '3 kg',
        idealWeight: '55 g food per day',
        overweight: '64 g food per day',
      },
      {
        weight: '4 kg',
        idealWeight: '68 g food per day',
        overweight: '79 g food per day',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'Yorkshire Terrier',
      breed_size: 'No',
      flavour: 'Chicken',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Chihuahua_Adult_12x85g.jpg',
    id: 'RC_Chihuahua_Adult_12x85g',
    name: 'Royal Canin Chihuahua Adult (12x85g)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1.02,
    price: 269,
    category: 'Wet food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: '',
    needs: 'General',
    size: 'small',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'Complete feed for dogs - For adult small breed dogs (weight between 1 and 10 kg) - Over 10 months old.',
    longDescription:
      'Suitable for small breed dogs over 10 months old that weigh up to 10kg, ROYAL CANINÃ‚Â® Mini Adult is specially formulated with all the nutritional needs of your adult mini dog in mind.<div style="margin: 0cm 0cm 8pt">Because small breed dogs like yours tend to have high energy needs, ROYAL CANINÃ‚Â® Mini Adult is formulated with nutrients that help to meet those energy needs, whilst also helping your dog to maintain a healthy weight.<div style="margin: 0cm 0cm 8pt">Some small breed dogs have fussier appetites than others, that\\\'s why ROYAL CANINÃ‚Â® Mini Adult\\\'s formula contains a selection of exclusive flavourings. It is this enhanced palatability that directly appeals to even the fussiest of dogs.<div style="margin: 0cm 0cm 8pt">ROYAL CANINÃ‚Â® Mini Adult also contains a variety of nutrients that help to support and maintain the health of your dog\\\'s skin and coat.<div style="margin: 0cm 0cm 8pt">To cater to each dog\\\'s individual preferences, ROYAL CANINÃ‚Â® Mini Adult is also available as wet food in delicious gravy.<div style="margin: 0cm 0cm 8pt">If you\\\'re considering mixed feeding, simply follow our feeding guidelines to ensure your dog gets an accurate amount of both wet and dry food for optimal benefit.</div></div></div></div></div>',
  },
  {
    image: '/pet_images/RC_Dachshund_Adult_12x85g.jpg',
    id: 'RC_Dachshund_Adult_12x85g',
    name: 'Royal Canin Dachshund Adult (12x85g)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1.02,
    price: 269,
    category: 'Wet food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: '',
    needs: 'General',
    size: 'small',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'Complete feed for dogs - For adult small breed dogs (weight between 1 and 10 kg) - Over 10 months old.',
    longDescription:
      'Suitable for small breed dogs over 10 months old that weigh up to 10kg, ROYAL CANINÃ‚Â® Mini Adult is specially formulated with all the nutritional needs of your adult mini dog in mind.<div style="margin: 0cm 0cm 8pt">Because small breed dogs like yours tend to have high energy needs, ROYAL CANINÃ‚Â® Mini Adult is formulated with nutrients that help to meet those energy needs, whilst also helping your dog to maintain a healthy weight.<div style="margin: 0cm 0cm 8pt">Some small breed dogs have fussier appetites than others, that\\\'s why ROYAL CANINÃ‚Â® Mini Adult\\\'s formula contains a selection of exclusive flavourings. It is this enhanced palatability that directly appeals to even the fussiest of dogs.<div style="margin: 0cm 0cm 8pt">ROYAL CANINÃ‚Â® Mini Adult also contains a variety of nutrients that help to support and maintain the health of your dog\\\'s skin and coat.<div style="margin: 0cm 0cm 8pt">To cater to each dog\\\'s individual preferences, ROYAL CANINÃ‚Â® Mini Adult is also available as wet food in delicious gravy.<div style="margin: 0cm 0cm 8pt">If you\\\'re considering mixed feeding, simply follow our feeding guidelines to ensure your dog gets an accurate amount of both wet and dry food for optimal benefit.</div></div></div></div></div>',
  },
  {
    image: '/pet_images/RC_Pomeranian_Adult_12x85g.jpg',
    id: 'RC_Pomeranian_Adult_12x85g',
    name: 'Royal Canin Pomeranian Adult (12x85g)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1.02,
    price: 269,
    category: 'Wet food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: '',
    needs: 'General',
    size: 'small',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'Complete feed for dogs - For adult small breed dogs (weight between 1 and 10 kg) - Over 10 months old.',
    longDescription:
      'Suitable for small breed dogs over 10 months old that weigh up to 10kg, ROYAL CANINÃ‚Â® Mini Adult is specially formulated with all the nutritional needs of your adult mini dog in mind.<div style="margin: 0cm 0cm 8pt">Because small breed dogs like yours tend to have high energy needs, ROYAL CANINÃ‚Â® Mini Adult is formulated with nutrients that help to meet those energy needs, whilst also helping your dog to maintain a healthy weight.<div style="margin: 0cm 0cm 8pt">Some small breed dogs have fussier appetites than others, that\\\'s why ROYAL CANINÃ‚Â® Mini Adult\\\'s formula contains a selection of exclusive flavourings. It is this enhanced palatability that directly appeals to even the fussiest of dogs.<div style="margin: 0cm 0cm 8pt">ROYAL CANINÃ‚Â® Mini Adult also contains a variety of nutrients that help to support and maintain the health of your dog\\\'s skin and coat.<div style="margin: 0cm 0cm 8pt">To cater to each dog\\\'s individual preferences, ROYAL CANINÃ‚Â® Mini Adult is also available as wet food in delicious gravy.<div style="margin: 0cm 0cm 8pt">If you\\\'re considering mixed feeding, simply follow our feeding guidelines to ensure your dog gets an accurate amount of both wet and dry food for optimal benefit.</div></div></div></div></div>',
  },
  {
    image: '/pet_images/RC_Poodle_Adult_12x85g.jpg',
    id: 'RC_Poodle_Adult_12x85g',
    name: 'Royal Canin Poodle Adult (12x85g)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1.02,
    price: 269,
    category: 'Wet food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: '',
    needs: 'General',
    size: 'small',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'Complete feed for dogs - For adult small breed dogs (weight between 1 and 10 kg) - Over 10 months old.',
    longDescription:
      'Suitable for small breed dogs over 10 months old that weigh up to 10kg, ROYAL CANINÃ‚Â® Mini Adult is specially formulated with all the nutritional needs of your adult mini dog in mind.<div style="margin: 0cm 0cm 8pt">Because small breed dogs like yours tend to have high energy needs, ROYAL CANINÃ‚Â® Mini Adult is formulated with nutrients that help to meet those energy needs, whilst also helping your dog to maintain a healthy weight.<div style="margin: 0cm 0cm 8pt">Some small breed dogs have fussier appetites than others, that\\\'s why ROYAL CANINÃ‚Â® Mini Adult\\\'s formula contains a selection of exclusive flavourings. It is this enhanced palatability that directly appeals to even the fussiest of dogs.<div style="margin: 0cm 0cm 8pt">ROYAL CANINÃ‚Â® Mini Adult also contains a variety of nutrients that help to support and maintain the health of your dog\\\'s skin and coat.<div style="margin: 0cm 0cm 8pt">To cater to each dog\\\'s individual preferences, ROYAL CANINÃ‚Â® Mini Adult is also available as wet food in delicious gravy.<div style="margin: 0cm 0cm 8pt">If you\\\'re considering mixed feeding, simply follow our feeding guidelines to ensure your dog gets an accurate amount of both wet and dry food for optimal benefit.</div></div></div></div></div>',
  },
  {
    image: '/pet_images/RC_Yorkshire_Terrier_Adult_12x85g.jpg',
    id: 'RC_Yorkshire_Terrier_Adult_12x85g',
    name: 'Royal Canin Yorkshire Terrier Adult (12x85g)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1.02,
    price: 269,
    category: 'Wet food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: '',
    needs: 'General',
    size: 'small',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'Complete feed for dogs - For adult small breed dogs (weight between 1 and 10 kg) - Over 10 months old.',
    longDescription:
      'Suitable for small breed dogs over 10 months old that weigh up to 10kg, ROYAL CANINÃ‚Â® Mini Adult is specially formulated with all the nutritional needs of your adult mini dog in mind.<div style="margin: 0cm 0cm 8pt">Because small breed dogs like yours tend to have high energy needs, ROYAL CANINÃ‚Â® Mini Adult is formulated with nutrients that help to meet those energy needs, whilst also helping your dog to maintain a healthy weight.<div style="margin: 0cm 0cm 8pt">Some small breed dogs have fussier appetites than others, that\\\'s why ROYAL CANINÃ‚Â® Mini Adult\\\'s formula contains a selection of exclusive flavourings. It is this enhanced palatability that directly appeals to even the fussiest of dogs.<div style="margin: 0cm 0cm 8pt">ROYAL CANINÃ‚Â® Mini Adult also contains a variety of nutrients that help to support and maintain the health of your dog\\\'s skin and coat.<div style="margin: 0cm 0cm 8pt">To cater to each dog\\\'s individual preferences, ROYAL CANINÃ‚Â® Mini Adult is also available as wet food in delicious gravy.<div style="margin: 0cm 0cm 8pt">If you\\\'re considering mixed feeding, simply follow our feeding guidelines to ensure your dog gets an accurate amount of both wet and dry food for optimal benefit.</div></div></div></div></div>',
  },
  // -- Health-specific Dry Food --
  {
    image: '/pet_images/RC_Exigent_Mini_1kg.jpg',
    id: 'RC_Exigent_Mini_1kg',
    name: 'Royal Canin Exigent Mini (1kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1.0,
    price: 225,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: '',
    needs: 'General',
    size: 'small',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'Royal Canin Mini Exigent Adult Dog Food for adult and mature small breed dogs (from 1 to 10 kg) - Over 10 months old - Dogs with fussy appetites.Featuring an exclusive blend of high-quality proteins and premium ingredients specially selected for...',
    longDescription:
      '<div class="std" itemprop="description"><p><strong>Royal Canin Mini Exigent Adult Dog Food f</strong>or adult and mature small breed dogs (from 1 to 10 kg) - Over 10 months old - Dogs with fussy appetites.</p><p>Featuring an exclusive blend of high-quality proteins and premium ingredients specially selected for your picky eater to ensure maximum acceptance. </p><p><strong>Key Features:</strong></p><ul><li><strong>Proven Results : </strong>Up to 99 % prefered.</li><li><strong>For small dogs with fussy appetites :</strong> Featuring ingredients and high quality proteins specially selected for small dogs, Mini Exigent has an aroma irresistible to the fussiest of eaters.</li></ul></div>',
    keyBenefits: [
      'Proven Results :',
      'For small dogs with fussy appetites :',
    ],
    feedingGuide: [
      {
        weight: 'DOG\'S WEIGHT',
        idealWeight: 'NORMAL ACTIVITY LEVEL',
        overweight: 'MODERATE ACTIVITY LEVEL',
      },
      {
        weight: '1 kg',
        idealWeight: '22 g (2/8 cup)',
        overweight: '26 g (2/8 cup)',
      },
      {
        weight: '3 kg',
        idealWeight: '51 g (4/8 cup)',
        overweight: '59 g (4/8 cup)',
      },
      {
        weight: '6 kg',
        idealWeight: '86 g (7/8 cup)',
        overweight: '99 g (1 cup)',
      },
      {
        weight: '10 kg',
        idealWeight: '126g (1+2/8 cups)',
        overweight: '146 g (1+3/8 cups)',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'No',
      breed: 'Non-Specific',
      breed_size: 'Small Breed',
      flavour: 'Chicken',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Mini_Adult_3kg.jpg',
    id: 'RC_Mini_Exigent_3kg',
    name: 'Royal Canin Exigent Mini (3kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 3.0,
    price: 576,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: '',
    needs: 'General',
    size: 'small',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'Royal Canin Mini Exigent Adult Dog Food for adult and mature small breed dogs (from 1 to 10 kg) - Over 10 months old - Dogs with fussy appetites.Featuring an exclusive blend of high-quality proteins and premium ingredients specially selected for...',
    longDescription:
      '<div class="std" itemprop="description"><p><strong>Royal Canin Mini Exigent Adult Dog Food f</strong>or adult and mature small breed dogs (from 1 to 10 kg) - Over 10 months old - Dogs with fussy appetites.</p><p>Featuring an exclusive blend of high-quality proteins and premium ingredients specially selected for your picky eater to ensure maximum acceptance. </p><p><strong>Key Features:</strong></p><ul><li><strong>Proven Results : </strong>Up to 99 % prefered.</li><li><strong>For small dogs with fussy appetites :</strong> Featuring ingredients and high quality proteins specially selected for small dogs, Mini Exigent has an aroma irresistible to the fussiest of eaters.</li></ul></div>',
    keyBenefits: [
      'Proven Results :',
      'For small dogs with fussy appetites :',
    ],
    feedingGuide: [
      {
        weight: 'DOG\'S WEIGHT',
        idealWeight: 'NORMAL ACTIVITY LEVEL',
        overweight: 'MODERATE ACTIVITY LEVEL',
      },
      {
        weight: '1 kg',
        idealWeight: '22 g (2/8 cup)',
        overweight: '26 g (2/8 cup)',
      },
      {
        weight: '3 kg',
        idealWeight: '51 g (4/8 cup)',
        overweight: '59 g (4/8 cup)',
      },
      {
        weight: '6 kg',
        idealWeight: '86 g (7/8 cup)',
        overweight: '99 g (1 cup)',
      },
      {
        weight: '10 kg',
        idealWeight: '126g (1+2/8 cups)',
        overweight: '146 g (1+3/8 cups)',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'No',
      breed: 'Non-Specific',
      breed_size: 'Small Breed',
      flavour: 'Chicken',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Mini_Weight_Care_3kg.png',
    id: 'RC_Mini_Weight_Care_3kg',
    name: 'Royal Canin Light Weight Care Mini (3kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 3.0,
    price: 531,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: '',
    needs: 'Weight care',
    size: 'small',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'Complete feed for dogs - For adult and mature small breed dogs (from 1 to 10 kg) - Over 10 months old - Dogs with a tendency to gain weight.',
  },
  {
    image: '/pet_images/RC_Light_Weight_Care_Medium_12kg.jpg',
    id: 'RC_Light_Weight_Care_Medium_12kg',
    name: 'Royal Canin Light Weight Care Medium (12kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 12.0,
    price: 1575,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: '',
    needs: 'Weight care',
    size: 'medium',
    sterilised: 'No',
    productSize: '10.1-20kg',
    description:
      'Complete feed for dogs - For dogs prone to weight gain and for maintaining a healthy weight.',
    longDescription:
      '<div class="std" itemprop="description"><p>Complete feed for dogs - For dogs prone to weight gain and for maintaining a healthy weight.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Helps Limit Weight Gain - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Maintains Muscle Mass - </strong>Nutritional support tailored to your pet\'s needs.</li></ul></div>',
    keyBenefits: [
      'Helps Limit Weight Gain -',
      'Maintains Muscle Mass -',
    ],
    feedingGuide: [
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'No',
      breed_size: 'No',
      flavour: 'None',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Maxi_Weight_Care_12kg.jpg',
    id: 'RC_Maxi_Weight_Care_12kg',
    name: 'Royal Canin Light Weight Care Maxi (12kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 12.0,
    price: 1575,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: '',
    needs: 'Weight care',
    size: 'large',
    sterilised: 'No',
    productSize: '10.1-20kg',
    description:
      'The Royal Canin Maxi Light Weight Care Adult Dog Food for adult and mature large breed dogs (from 26 to 44 kg) - Over 15 months old - Dogs with a tendency to gain weight.Crafted to support your mini dog’s overall well-being but has radically less...',
    longDescription:
      '<div class="std" itemprop="description"><p>The <strong>Royal Canin Maxi Light Weight Care Adult Dog Food</strong> f<span>or adult and mature large breed dogs (from 26 to 44 kg) - Over 15 months old - Dogs with a tendency to gain weight.</span></p><p>Crafted to support your mini dog’s overall well-being but has radically less fat to help them stay trim, active and light on their paws.</p><p><strong>Key Features:</strong></p><ul><li><strong>Proven results:</strong> 35 % less fat</li><li><strong>A high protein content: </strong>Helps maintain muscle mass and a low fat content helps limit weight gain. An optimal combination of soluble and insoluble fibres helps your dog feel full, while Omega-3 fatty acids help support healthy joint movement.</li></ul></div>',
    keyBenefits: [
      'Proven results:',
      'A high protein content:',
    ],
    feedingGuide: [
      {
        weight: 'DOG\'S WEIGHT',
        idealWeight: 'NORMAL ACTIVITY LEVEL',
        overweight: 'MODERATE ACTIVITY LEVEL',
      },
      {
        weight: '26 kg',
        idealWeight: '292 g (3+2/8 cups)',
        overweight: '357 g (3+6/8 cups)',
      },
      {
        weight: '32 kg',
        idealWeight: '341 g (3+6/8 cups)',
        overweight: '405 g (4+4/8 cups)',
      },
      {
        weight: '38 kg',
        idealWeight: '388 g (4+2/8 cups)',
        overweight: '461 g (5 cups)',
      },
      {
        weight: '44 kg',
        idealWeight: '433 g (4+6/8 cups)',
        overweight: '496 g (5+3/8 cups)',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Weight Control',
      breed: 'No',
      breed_size: 'Large Breed',
      flavour: 'Chicken',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Mini_Digestive_Care_3kg.jpg',
    id: 'RC_Mini_Digestive_Care_3kg',
    name: 'Royal Canin Digestive Care Mini (3kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 3.0,
    price: 531,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: '',
    needs: 'Digestive care',
    size: 'small',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'Royal Canin Mini Digestive Care Adult Dog Food\'s designed for adult and mature small breed dogs up to 10 kg.Extra-tasty recipe is specially crafted for dogs prone to digestive sensitivities. Key Features:Contains highly digestible proteins, a blend...',
    longDescription:
      '<div class="std" itemprop="description"><p><strong>Royal Canin Mini Digestive Care Adult Dog Food\\\\\\\'s</strong> designed for adult and mature small breed dogs up to 10 kg.</p><p>Extra-tasty recipe is specially crafted for dogs prone to digestive sensitivities. </p><p><strong>Key Features:</strong></p><ul><li>Contains <strong>highly digestible proteins</strong>, a blend of prebiotics and fibres to promote a balanced intestinal flora and help <strong>promote optimal stool quality.</strong></li><li>An ideally-balanced mix of soluble and insoluble fiber <strong>helps to limit fermentation</strong> and also <strong>supports intestinal transit</strong> exactly where it’s needed.</li><li><strong>Proven Results - </strong>Up 92% optimal stool quality development; the ultimate proof of a healthy gut.</li></ul></div>',
    keyBenefits: [
      'Contains',
      'An ideally-balanced mix of soluble and insoluble fiber',
      'Proven Results -',
    ],
    feedingGuide: [
      {
        weight: 'DOG\'S WEIGHT',
        idealWeight: 'NORMAL ACTIVITY LEVEL',
        overweight: 'MODERATE ACTIVITY LEVEL',
      },
      {
        weight: '1 kg',
        idealWeight: '22 g (1/8 cup)',
        overweight: '26 g (2/8 cup)',
      },
      {
        weight: '3 kg',
        idealWeight: '51 g (3/8 cup)',
        overweight: '59 g (4/8 cup)',
      },
      {
        weight: '6 kg',
        idealWeight: '86 g (6/8 cup)',
        overweight: '99 g (7/8 cup)',
      },
      {
        weight: '10 kg',
        idealWeight: '125 g (1 cup)',
        overweight: '145 g (1+2/8 cup)',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Digestive Care',
      breed: 'No',
      breed_size: 'Small Breed',
      flavour: 'Chicken',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Digestive_Care_Medium_3kg.jpg',
    id: 'RC_Digestive_Care_Medium_3kg',
    name: 'Royal Canin Digestive Care Medium (3kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 3.0,
    price: 531,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: '',
    needs: 'Digestive care',
    size: 'medium',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'Royal Canin Medium Digestive Care Adult Dog Food is suitable for dogs prone to digestive sensitivity that weigh between 11kg and 25kg.Tailored with active nutrients, this formula contains a range of prebiotics for healthy gut flora.Key Features:...',
    longDescription:
      '<div class="std" itemprop="description"><p><strong>Royal Canin Medium Digestive Care Adult Dog Food</strong> is suitable for dogs prone to digestive sensitivity that weigh between 11kg and 25kg.</p><p>Tailored with active nutrients, this formula contains a range of prebiotics for healthy gut flora.</p><p><strong>Key Features:</strong></p><ul><li>Contains highly <strong>digestible proteins</strong>, a blend of prebiotics and fibres to promote a balanced intestinal flora and helps promote optimal stool quality.</li><li>Includes balanced soluble and insoluble fibers for <strong>optimal digestive comfort</strong>.</li></ul></div>',
    keyBenefits: [
      'Contains highly',
      'Includes balanced soluble and insoluble fibers for',
    ],
    feedingGuide: [
      {
        weight: 'DOG\'S WEIGHT',
        idealWeight: 'NORMAL ACTIVITY LEVEL',
        overweight: 'MODERATE ACTIVITY LEVEL',
      },
      {
        weight: '26 kg',
        idealWeight: '281 g (3 cups)',
        overweight: '326 g (3+4/8 cups)',
      },
      {
        weight: '32 kg',
        idealWeight: '329 g (3+4/8 cups)',
        overweight: '381 g (4+1/8 cups)',
      },
      {
        weight: '38 kg',
        idealWeight: '374 g (4 cups)',
        overweight: '433 g (4+5/8 cups)',
      },
      {
        weight: '44 kg',
        idealWeight: '418 g (4+4/8 cups)',
        overweight: '484 g (5+1/8 cups)',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Digestive Care',
      breed: 'No',
      breed_size: 'Medium Breed',
      flavour: 'Chicken',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Digestive_Care_Medium_12kg.jpg',
    id: 'RC_Digestive_Care_Medium_12kg',
    name: 'Royal Canin Digestive Care Medium (12kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 12.0,
    price: 1575,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: '',
    needs: 'Digestive care',
    size: 'medium',
    sterilised: 'No',
    productSize: '10.1-20kg',
    description:
      'Royal Canin Medium Digestive Care Adult Dog Food is suitable for dogs prone to digestive sensitivity that weigh between 11kg and 25kg.Tailored with active nutrients, this formula contains a range of prebiotics for healthy gut flora.Key Features:...',
    longDescription:
      '<div class="std" itemprop="description"><p><strong>Royal Canin Medium Digestive Care Adult Dog Food</strong> is suitable for dogs prone to digestive sensitivity that weigh between 11kg and 25kg.</p><p>Tailored with active nutrients, this formula contains a range of prebiotics for healthy gut flora.</p><p><strong>Key Features:</strong></p><ul><li>Contains highly <strong>digestible proteins</strong>, a blend of prebiotics and fibres to promote a balanced intestinal flora and helps promote optimal stool quality.</li><li>Includes balanced soluble and insoluble fibers for <strong>optimal digestive comfort</strong>.</li></ul></div>',
    keyBenefits: [
      'Contains highly',
      'Includes balanced soluble and insoluble fibers for',
    ],
    feedingGuide: [
      {
        weight: 'DOG\'S WEIGHT',
        idealWeight: 'NORMAL ACTIVITY LEVEL',
        overweight: 'MODERATE ACTIVITY LEVEL',
      },
      {
        weight: '26 kg',
        idealWeight: '281 g (3 cups)',
        overweight: '326 g (3+4/8 cups)',
      },
      {
        weight: '32 kg',
        idealWeight: '329 g (3+4/8 cups)',
        overweight: '381 g (4+1/8 cups)',
      },
      {
        weight: '38 kg',
        idealWeight: '374 g (4 cups)',
        overweight: '433 g (4+5/8 cups)',
      },
      {
        weight: '44 kg',
        idealWeight: '418 g (4+4/8 cups)',
        overweight: '484 g (5+1/8 cups)',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Digestive Care',
      breed: 'No',
      breed_size: 'Medium Breed',
      flavour: 'Chicken',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Digestive_Care_Maxi_12kg.jpg',
    id: 'RC_Digestive_Care_Maxi_12kg',
    name: 'Royal Canin Digestive Care Maxi (12kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 12.0,
    price: 1575,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: '',
    needs: 'Digestive care',
    size: 'large',
    sterilised: 'No',
    productSize: '10.1-20kg',
    description:
      'Complete feed for dogs - For adult medium breed dogs - From 12 months to 10 years old - Dogs prone to digestive sensitivity.',
    longDescription:
      '<div class="std" itemprop="description"><p>Complete feed for dogs - For adult medium breed dogs - From 12 months to 10 years old - Dogs prone to digestive sensitivity.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Digestive Support - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Balanced Intestinal Flora - </strong>Nutritional support tailored to your pet\'s needs.</li></ul></div>',
    keyBenefits: [
      'Digestive Support -',
      'Balanced Intestinal Flora -',
    ],
    feedingGuide: [
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'No',
      breed_size: 'No',
      flavour: 'None',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Joint_Care_Maxi_10kg.jpg',
    id: 'RC_Joint_Care_Maxi_10kg',
    name: 'Royal Canin Joint Care Maxi (10kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 10.0,
    price: 1446,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: '',
    needs: 'Joint care',
    size: 'large',
    sterilised: 'No',
    productSize: '5.1-10kg',
    description:
      'Complete feed for dogs - For adult and mature large breed dogs - Dogs prone to joint sensitivity.',
    longDescription:
      '<div class="std" itemprop="description"><p>Complete feed for dogs - For adult and mature large breed dogs - Dogs prone to joint sensitivity.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Joint Support - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Mobility Support - </strong>Nutritional support tailored to your pet\'s needs.</li></ul></div>',
    keyBenefits: [
      'Joint Support -',
      'Mobility Support -',
    ],
    feedingGuide: [
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'No',
      breed_size: 'No',
      flavour: 'None',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Dermacomfort_Mini_1kg.jpg',
    id: 'RC_Dermacomfort_Mini_1kg',
    name: 'Royal Canin Dermacomfort Mini (1kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1.0,
    price: 179,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: '',
    needs: 'Sensitive skin',
    size: 'small',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'Royal Canin Mini Dermacomfort Adult Dog Food\'s for adult and mature small breed dogs (from 1 to 10 kg) - Over 10 months old - Dogs prone to skin irritation and itching.Formula is crafted to support your dog’s overall health as well as nourishing its...',
    longDescription:
      '<div class="std" itemprop="description"><p><strong>Royal Canin Mini Dermacomfort Adult Dog Food\\\'s </strong>for adult and mature small breed dogs (from 1 to 10 kg) - Over 10 months old - Dogs prone to skin irritation and itching.</p><p>Formula is crafted to support your dog’s overall health as well as nourishing its sensitive skin. It’s enriched with the essential fatty acids Omega 3 and 6, which help to calm and protect your dog’s skin and make it less sensitive to irritation.</p><p><strong>Key Features:</strong></p><ul><li><strong>Proven results : </strong>Healthy skin - 91 % of owners are satisfied after 2 months</li><li><strong>For dogs prone to skin irritation and itching : </strong>The dog’s skin respond to dietary, seasonal and environmental irritants. Too much scratching can damage his skin disrupting the protective skin barrier.</li><li><strong>Precise formula : </strong>Nutritionally formulated with Omega-3 &amp; 6 fatty acids, including GLA, EPA and DHA to help support and nourish his skin. Formulated to care for your dog’s skin and help him maintain a full, healthy coat.</li></ul></div>',
    keyBenefits: [
      'Proven results :',
      'For dogs prone to skin irritation and itching :',
      'Precise formula :',
    ],
    feedingGuide: [
      {
        weight: 'DOG\'S WEIGHT',
        idealWeight: 'NORMAL ACTIVITY LEVEL',
        overweight: 'MODERATE ACTIVITY LEVEL',
      },
      {
        weight: '1 kg',
        idealWeight: '24 g (2/8 cup)',
        overweight: '27 g (2/8 cup)',
      },
      {
        weight: '3 kg',
        idealWeight: '54 g (4/8 cup)',
        overweight: '63 g (5/8 cup)',
      },
      {
        weight: '6 kg',
        idealWeight: '91 g (7/8 cup)',
        overweight: '105 g (1 cup)',
      },
      {
        weight: '10 kg',
        idealWeight: '133 g (1+2/8 cups)',
        overweight: '154 g (1+3/8 cups)',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Sensitive Skin',
      breed: 'No',
      breed_size: 'Mini Breed',
      flavour: 'Chicken',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Mini_Skin_Care_3kg.jpg',
    id: 'RC_Mini_Skin_Care_3kg',
    name: 'Royal Canin Dermacomfort Mini (3kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 3.0,
    price: 495,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: '',
    needs: 'Sensitive skin',
    size: 'small',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'Royal Canin Mini Dermacomfort Adult Dog Food\'s for adult and mature small breed dogs (from 1 to 10 kg) - Over 10 months old - Dogs prone to skin irritation and itching.Formula is crafted to support your dog’s overall health as well as nourishing its...',
    longDescription:
      '<div class="std" itemprop="description"><p><strong>Royal Canin Mini Dermacomfort Adult Dog Food\\\'s </strong>for adult and mature small breed dogs (from 1 to 10 kg) - Over 10 months old - Dogs prone to skin irritation and itching.</p><p>Formula is crafted to support your dog’s overall health as well as nourishing its sensitive skin. It’s enriched with the essential fatty acids Omega 3 and 6, which help to calm and protect your dog’s skin and make it less sensitive to irritation.</p><p><strong>Key Features:</strong></p><ul><li><strong>Proven results : </strong>Healthy skin - 91 % of owners are satisfied after 2 months</li><li><strong>For dogs prone to skin irritation and itching : </strong>The dog’s skin respond to dietary, seasonal and environmental irritants. Too much scratching can damage his skin disrupting the protective skin barrier.</li><li><strong>Precise formula : </strong>Nutritionally formulated with Omega-3 &amp; 6 fatty acids, including GLA, EPA and DHA to help support and nourish his skin. Formulated to care for your dog’s skin and help him maintain a full, healthy coat.</li></ul></div>',
    keyBenefits: [
      'Proven results :',
      'For dogs prone to skin irritation and itching :',
      'Precise formula :',
    ],
    feedingGuide: [
      {
        weight: 'DOG\'S WEIGHT',
        idealWeight: 'NORMAL ACTIVITY LEVEL',
        overweight: 'MODERATE ACTIVITY LEVEL',
      },
      {
        weight: '1 kg',
        idealWeight: '24 g (2/8 cup)',
        overweight: '27 g (2/8 cup)',
      },
      {
        weight: '3 kg',
        idealWeight: '54 g (4/8 cup)',
        overweight: '63 g (5/8 cup)',
      },
      {
        weight: '6 kg',
        idealWeight: '91 g (7/8 cup)',
        overweight: '105 g (1 cup)',
      },
      {
        weight: '10 kg',
        idealWeight: '133 g (1+2/8 cups)',
        overweight: '154 g (1+3/8 cups)',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Sensitive Skin',
      breed: 'No',
      breed_size: 'Mini Breed',
      flavour: 'Chicken',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Dermacomfort_Mini_8kg.jpg',
    id: 'RC_Dermacomfort_Mini_8kg',
    name: 'Royal Canin Dermacomfort Mini (8kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 8.0,
    price: 1098,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: '',
    needs: 'Sensitive skin',
    size: 'small',
    sterilised: 'No',
    productSize: '5.1-10kg',
    description:
      'Royal Canin Mini Dermacomfort Adult Dog Food\'s for adult and mature small breed dogs (from 1 to 10 kg) - Over 10 months old - Dogs prone to skin irritation and itching.Formula is crafted to support your dog’s overall health as well as nourishing its...',
    longDescription:
      '<div class="std" itemprop="description"><p><strong>Royal Canin Mini Dermacomfort Adult Dog Food\\\'s </strong>for adult and mature small breed dogs (from 1 to 10 kg) - Over 10 months old - Dogs prone to skin irritation and itching.</p><p>Formula is crafted to support your dog’s overall health as well as nourishing its sensitive skin. It’s enriched with the essential fatty acids Omega 3 and 6, which help to calm and protect your dog’s skin and make it less sensitive to irritation.</p><p><strong>Key Features:</strong></p><ul><li><strong>Proven results : </strong>Healthy skin - 91 % of owners are satisfied after 2 months</li><li><strong>For dogs prone to skin irritation and itching : </strong>The dog’s skin respond to dietary, seasonal and environmental irritants. Too much scratching can damage his skin disrupting the protective skin barrier.</li><li><strong>Precise formula : </strong>Nutritionally formulated with Omega-3 &amp; 6 fatty acids, including GLA, EPA and DHA to help support and nourish his skin. Formulated to care for your dog’s skin and help him maintain a full, healthy coat.</li></ul></div>',
    keyBenefits: [
      'Proven results :',
      'For dogs prone to skin irritation and itching :',
      'Precise formula :',
    ],
    feedingGuide: [
      {
        weight: 'DOG\'S WEIGHT',
        idealWeight: 'NORMAL ACTIVITY LEVEL',
        overweight: 'MODERATE ACTIVITY LEVEL',
      },
      {
        weight: '1 kg',
        idealWeight: '24 g (2/8 cup)',
        overweight: '27 g (2/8 cup)',
      },
      {
        weight: '3 kg',
        idealWeight: '54 g (4/8 cup)',
        overweight: '63 g (5/8 cup)',
      },
      {
        weight: '6 kg',
        idealWeight: '91 g (7/8 cup)',
        overweight: '105 g (1 cup)',
      },
      {
        weight: '10 kg',
        idealWeight: '133 g (1+2/8 cups)',
        overweight: '154 g (1+3/8 cups)',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Sensitive Skin',
      breed: 'No',
      breed_size: 'Mini Breed',
      flavour: 'Chicken',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Dermacomfort_Medium_3kg.jpg',
    id: 'RC_Dermacomfort_Medium_3kg',
    name: 'Royal Canin Dermacomfort Medium (3kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 3.0,
    price: 468,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: '',
    needs: 'Sensitive skin',
    size: 'medium',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'Complete feed for dogs - For adult and mature medium breed dogs - From 12 months to 10 years old - Dogs prone to skin irritation and itching.',
    longDescription:
      '<div class="std" itemprop="description"><p>Complete feed for dogs - For adult and mature medium breed dogs - From 12 months to 10 years old - Dogs prone to skin irritation and itching.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Healthy Skin - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Shiny Coat - </strong>Nutritional support tailored to your pet\'s needs.</li></ul></div>',
    keyBenefits: [
      'Healthy Skin -',
      'Shiny Coat -',
    ],
    feedingGuide: [
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'No',
      breed_size: 'No',
      flavour: 'None',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Dermacomfort_Medium_12kg.jpg',
    id: 'RC_Dermacomfort_Medium_12kg',
    name: 'Royal Canin Dermacomfort Medium (12kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 12.0,
    price: 1422,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: '',
    needs: 'Sensitive skin',
    size: 'medium',
    sterilised: 'No',
    productSize: '10.1-20kg',
    description:
      'Complete feed for dogs - For adult and mature medium breed dogs - From 12 months to 10 years old - Dogs prone to skin irritation and itching.',
    longDescription:
      '<div class="std" itemprop="description"><p>Complete feed for dogs - For adult and mature medium breed dogs - From 12 months to 10 years old - Dogs prone to skin irritation and itching.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Healthy Skin - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Shiny Coat - </strong>Nutritional support tailored to your pet\'s needs.</li></ul></div>',
    keyBenefits: [
      'Healthy Skin -',
      'Shiny Coat -',
    ],
    feedingGuide: [
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'No',
      breed_size: 'No',
      flavour: 'None',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Dermacomfort_Maxi_12kg.jpg',
    id: 'RC_Dermacomfort_Maxi_12kg',
    name: 'Royal Canin Dermacomfort Maxi (12kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 12.0,
    price: 1422,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: '',
    needs: 'Sensitive skin',
    size: 'large',
    sterilised: 'No',
    productSize: '10.1-20kg',
    description:
      'Complete feed for dogs - For adult large breed dogs - From 15 months to 8 years old - Dogs prone to skin irritation and itching.',
    longDescription:
      '<div class="std" itemprop="description"><p>Complete feed for dogs - For adult large breed dogs - From 15 months to 8 years old - Dogs prone to skin irritation and itching.</p><p><strong>Key Benefits:</strong></p><ul><li><strong>Healthy Skin - </strong>Nutritional support tailored to your pet\'s needs.</li><li><strong>Shiny Coat - </strong>Nutritional support tailored to your pet\'s needs.</li></ul></div>',
    keyBenefits: [
      'Healthy Skin -',
      'Shiny Coat -',
    ],
    feedingGuide: [
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Dry Food',
      breed: 'No',
      breed_size: 'No',
      flavour: 'None',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  {
    image: '/pet_images/RC_Mini_Adult_3kg.jpg',
    id: 'RC_Mini_Relax_Care_3kg',
    name: 'Royal Canin Relax Care Mini (3kg)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 3.0,
    price: 531,
    category: 'Dry food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: '',
    needs: 'General',
    size: 'small',
    sterilised: 'No',
    productSize: '1.1-5kg',
    description:
      'Royal Canin Relax Care Adult Dog Food for adult and mature small breed dogs (from 1 to 10 kg) - Over 10 months old - Dogs in a changing environment.Certain life events like car trips, moving house, or the arrival of new family members can make your...',
    longDescription:
      '<div class="std" itemprop="description"><p><strong>Royal Canin Relax Care Adult Dog Food</strong> for adult and mature small breed dogs (from 1 to 10 kg) - Over 10 months old - Dogs in a changing environment.</p><p>Certain life events like car trips, moving house, or the arrival of new family members can make your dog feel uneasy. High-quality nutrition can help to calm your dog’s nerves, meaning a better all-round quality of life.</p><p><strong>Key Features:</strong></p><ul><li><strong>Proven results : </strong>+44 % normal behaviour in changing environment.</li><li><strong>Precise formula :</strong> This precicely balanced nutritional solution with proven efficacy, is formulated with specific nutrients to help your dog feel relaxed in an intense and changing environment.</li><li><strong>For dogs in a changeable environment :</strong> Changes in your dog’s routine can impact his wellbeing. Situations such as a trip in the car, moving to a new home, or the arrival of a new baby can make a dog nervous. Adapting his nutrition can help him cope with change.</li></ul></div>',
    keyBenefits: [
      'Proven results :',
      'Precise formula :',
      'For dogs in a changeable environment :',
    ],
    feedingGuide: [
      {
        weight: 'LOW ACTIVITY (DRY ONLY)',
        idealWeight: 'LOW ACTIVITY (DRY AND WET)',
        overweight: 'MEDIUM ACTIVITY (DRY ONLY)',
      },
      {
        weight: '1kg',
        idealWeight: '25g (2/8 cup)',
        overweight: '14g (1/8 cup) + 1 pouch',
      },
      {
        weight: '3kg',
        idealWeight: '57g (6/8 cup)',
        overweight: '35g (3/8 cups) + 1 pouch',
      },
      {
        weight: '6kg',
        idealWeight: '96g ( 1 + 1/8 cups)',
        overweight: '74g (7/8 cup) + 1 pouch',
      },
      {
        weight: '10kg',
        idealWeight: '141g (1+6/8 cups)',
        overweight: '119 (1+ 4/8 cups) + 1 pouch',
      },
    ],
    additionalInfo: {
      brands: 'Royal Canin',
      pet_type: 'Dog',
      featured: 'No',
      product_type: 'Dry Food',
      product_feature: 'Anxiety',
      breed: 'No',
      breed_size: 'Mini Breed',
      flavour: 'Chicken',
      lifestage: 'Adult',
      size_chart: 'No',
    },
  },
  // -- Wet Food (All Sizes) --
  {
    image: '/pet_images/RC_Exigent_All_Sizes_12_x_85g.jpg',
    id: 'RC_Exigent_All_Sizes_12_x_85g',
    name: 'Royal Canin Exigent All Sizes (12 x 85g)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1.02,
    price: 269,
    category: 'Wet food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: '',
    needs: 'General',
    size: 'small',
    sterilised: 'No',
    productSize: '',
    description:
      'Complete feed for dogs - For adult small breed dogs (weight between 1 and 10 kg) - Over 10 months old.',
    longDescription:
      'Suitable for small breed dogs over 10 months old that weigh up to 10kg, ROYAL CANINÃ‚Â® Mini Adult is specially formulated with all the nutritional needs of your adult mini dog in mind.<div style="margin: 0cm 0cm 8pt">Because small breed dogs like yours tend to have high energy needs, ROYAL CANINÃ‚Â® Mini Adult is formulated with nutrients that help to meet those energy needs, whilst also helping your dog to maintain a healthy weight.<div style="margin: 0cm 0cm 8pt">Some small breed dogs have fussier appetites than others, that\\\'s why ROYAL CANINÃ‚Â® Mini Adult\\\'s formula contains a selection of exclusive flavourings. It is this enhanced palatability that directly appeals to even the fussiest of dogs.<div style="margin: 0cm 0cm 8pt">ROYAL CANINÃ‚Â® Mini Adult also contains a variety of nutrients that help to support and maintain the health of your dog\\\'s skin and coat.<div style="margin: 0cm 0cm 8pt">To cater to each dog\\\'s individual preferences, ROYAL CANINÃ‚Â® Mini Adult is also available as wet food in delicious gravy.<div style="margin: 0cm 0cm 8pt">If you\\\'re considering mixed feeding, simply follow our feeding guidelines to ensure your dog gets an accurate amount of both wet and dry food for optimal benefit.</div></div></div></div></div>',
  },
  {
    image: '/pet_images/RC_Light_Weight_Care_All_Sizes_12_x_85g.jpg',
    id: 'RC_Light_Weight_Care_All_Sizes_12_x_85g',
    name: 'Royal Canin Light Weight Care All Sizes (12 x 85g)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1.02,
    price: 269,
    category: 'Wet food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: '',
    needs: 'General',
    size: 'small',
    sterilised: 'No',
    productSize: '',
    description:
      'Complete feed for dogs - For adult small breed dogs (weight between 1 and 10 kg) - Over 10 months old.',
    longDescription:
      'Suitable for small breed dogs over 10 months old that weigh up to 10kg, ROYAL CANINÃ‚Â® Mini Adult is specially formulated with all the nutritional needs of your adult mini dog in mind.<div style="margin: 0cm 0cm 8pt">Because small breed dogs like yours tend to have high energy needs, ROYAL CANINÃ‚Â® Mini Adult is formulated with nutrients that help to meet those energy needs, whilst also helping your dog to maintain a healthy weight.<div style="margin: 0cm 0cm 8pt">Some small breed dogs have fussier appetites than others, that\\\'s why ROYAL CANINÃ‚Â® Mini Adult\\\'s formula contains a selection of exclusive flavourings. It is this enhanced palatability that directly appeals to even the fussiest of dogs.<div style="margin: 0cm 0cm 8pt">ROYAL CANINÃ‚Â® Mini Adult also contains a variety of nutrients that help to support and maintain the health of your dog\\\'s skin and coat.<div style="margin: 0cm 0cm 8pt">To cater to each dog\\\'s individual preferences, ROYAL CANINÃ‚Â® Mini Adult is also available as wet food in delicious gravy.<div style="margin: 0cm 0cm 8pt">If you\\\'re considering mixed feeding, simply follow our feeding guidelines to ensure your dog gets an accurate amount of both wet and dry food for optimal benefit.</div></div></div></div></div>',
  },
  {
    image: '/pet_images/RC_Digestive_Care_All_Sizes_12_x_85g.jpg',
    id: 'RC_Digestive_Care_All_Sizes_12_x_85g',
    name: 'Royal Canin Digestive Care All Sizes (12 x 85g)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1.02,
    price: 269,
    category: 'Wet food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: '',
    needs: 'General',
    size: 'small',
    sterilised: 'No',
    productSize: '',
    description:
      'Complete feed for dogs - For adult small breed dogs (weight between 1 and 10 kg) - Over 10 months old.',
    longDescription:
      'Suitable for small breed dogs over 10 months old that weigh up to 10kg, ROYAL CANINÃ‚Â® Mini Adult is specially formulated with all the nutritional needs of your adult mini dog in mind.<div style="margin: 0cm 0cm 8pt">Because small breed dogs like yours tend to have high energy needs, ROYAL CANINÃ‚Â® Mini Adult is formulated with nutrients that help to meet those energy needs, whilst also helping your dog to maintain a healthy weight.<div style="margin: 0cm 0cm 8pt">Some small breed dogs have fussier appetites than others, that\\\'s why ROYAL CANINÃ‚Â® Mini Adult\\\'s formula contains a selection of exclusive flavourings. It is this enhanced palatability that directly appeals to even the fussiest of dogs.<div style="margin: 0cm 0cm 8pt">ROYAL CANINÃ‚Â® Mini Adult also contains a variety of nutrients that help to support and maintain the health of your dog\\\'s skin and coat.<div style="margin: 0cm 0cm 8pt">To cater to each dog\\\'s individual preferences, ROYAL CANINÃ‚Â® Mini Adult is also available as wet food in delicious gravy.<div style="margin: 0cm 0cm 8pt">If you\\\'re considering mixed feeding, simply follow our feeding guidelines to ensure your dog gets an accurate amount of both wet and dry food for optimal benefit.</div></div></div></div></div>',
  },
  {
    image: '/pet_images/RC_Dermacomfort_All_Sizes_12_x_85g.jpg',
    id: 'RC_Dermacomfort_All_Sizes_12_x_85g',
    name: 'Royal Canin Dermacomfort All Sizes (12 x 85g)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1.02,
    price: 269,
    category: 'Wet food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: '',
    needs: 'General',
    size: 'small',
    sterilised: 'No',
    productSize: '',
    description:
      'Complete feed for dogs - For adult small breed dogs (weight between 1 and 10 kg) - Over 10 months old.',
    longDescription:
      'Suitable for small breed dogs over 10 months old that weigh up to 10kg, ROYAL CANINÃ‚Â® Mini Adult is specially formulated with all the nutritional needs of your adult mini dog in mind.<div style="margin: 0cm 0cm 8pt">Because small breed dogs like yours tend to have high energy needs, ROYAL CANINÃ‚Â® Mini Adult is formulated with nutrients that help to meet those energy needs, whilst also helping your dog to maintain a healthy weight.<div style="margin: 0cm 0cm 8pt">Some small breed dogs have fussier appetites than others, that\\\'s why ROYAL CANINÃ‚Â® Mini Adult\\\'s formula contains a selection of exclusive flavourings. It is this enhanced palatability that directly appeals to even the fussiest of dogs.<div style="margin: 0cm 0cm 8pt">ROYAL CANINÃ‚Â® Mini Adult also contains a variety of nutrients that help to support and maintain the health of your dog\\\'s skin and coat.<div style="margin: 0cm 0cm 8pt">To cater to each dog\\\'s individual preferences, ROYAL CANINÃ‚Â® Mini Adult is also available as wet food in delicious gravy.<div style="margin: 0cm 0cm 8pt">If you\\\'re considering mixed feeding, simply follow our feeding guidelines to ensure your dog gets an accurate amount of both wet and dry food for optimal benefit.</div></div></div></div></div>',
  },
  {
    image: '/pet_images/RC_Relax_Care_All_Sizes_12_x_85g.jpg',
    id: 'RC_Relax_Care_All_Sizes_12_x_85g',
    name: 'Royal Canin Relax Care All Sizes (12 x 85g)',
    imageExt: '.jpg',
    inStock: 0,
    weight: 1.02,
    price: 269,
    category: 'Wet food',
    brand: 'Royal Canin',
    age: 'Adult',
    breed: '',
    needs: 'General',
    size: 'small',
    sterilised: 'No',
    productSize: '',
    description:
      'Complete feed for dogs - For adult small breed dogs (weight between 1 and 10 kg) - Over 10 months old.',
    longDescription:
      'Suitable for small breed dogs over 10 months old that weigh up to 10kg, ROYAL CANINÃ‚Â® Mini Adult is specially formulated with all the nutritional needs of your adult mini dog in mind.<div style="margin: 0cm 0cm 8pt">Because small breed dogs like yours tend to have high energy needs, ROYAL CANINÃ‚Â® Mini Adult is formulated with nutrients that help to meet those energy needs, whilst also helping your dog to maintain a healthy weight.<div style="margin: 0cm 0cm 8pt">Some small breed dogs have fussier appetites than others, that\\\'s why ROYAL CANINÃ‚Â® Mini Adult\\\'s formula contains a selection of exclusive flavourings. It is this enhanced palatability that directly appeals to even the fussiest of dogs.<div style="margin: 0cm 0cm 8pt">ROYAL CANINÃ‚Â® Mini Adult also contains a variety of nutrients that help to support and maintain the health of your dog\\\'s skin and coat.<div style="margin: 0cm 0cm 8pt">To cater to each dog\\\'s individual preferences, ROYAL CANINÃ‚Â® Mini Adult is also available as wet food in delicious gravy.<div style="margin: 0cm 0cm 8pt">If you\\\'re considering mixed feeding, simply follow our feeding guidelines to ensure your dog gets an accurate amount of both wet and dry food for optimal benefit.</div></div></div></div></div>',
  }
];

export { royalcaninDogProducts };
